/*
 * @Author: yusha
 * @Date: 2024-04-19 14:04:45
 * @LastEditors: yusha
 * @LastEditTime: 2024-07-30 18:36:47
 * @Description:
 */
export default {
  清算后扣除: '정산후 공제',
  未清算: '미결제',
  已经清算: '결제완료',
  结算状态: '결제 여부',
  //   未结算: '미결제',
  //   结算中: '청산중',
  //   已结算: '결제완료',
  部分清算: '부분청산',
  扣费明细: '공제 내역',
  实际扣除: '실제 공제',
  待生成: '생성 대기 중',
  '已退押金/押金': '반환보증금/보증금',
  合计费用: '합계비용',
  '当商品状态更改为“已检”和“已取消”，则会清算指定的商品金额，订单的所有商品状态更改为“已清算”，则订单清算完成': '상품의 상태가 \'검사완료품\' 또는 \'취소\'로 변경되면 상품의 금액이 정산됩니다.주문하신 모든 상품의 상태가 "청산완료"일 경우, 주문은 "청산완료"로 간주됩니다.',
  //   ------------------------------------
  肩宽: '어깨 너비',
  横宽: '몸 너비',
  衣长: '옷길이',
  袖长: '소매 길이',
  品牌成长的全方位支持: '브랜드 성장을 위한 전방위적 지원',
  'THE CKB（直航）付费会员': 'THE CKB 유료회원은 무료상담이 필요하시면 언제든지 연락주세요.',
  '从策划提案到采购、OEM/ODM、质量管理、物流等全流程，提供一站式全方位支持。': '제안부터 구매, OEM/ODM, 품질 관리, 물류 등 전부 과정에 걸쳐 원스톱 전방위 지원을 제공합니다.',
  袖宽: '소매 너비',
  袖口宽: '커프 너비',
  连肩袖长度: '소매길이',
  领围: '칼라 둘레',
  腰围: '허리',
  臀围: '엉덩이',
  前档长: '인심',
  后档长: '더 라이즈',
  裤脚宽: '헴 너비',
  大腿根围: '암피트 너비',
  半身裙: '스커트',
  裙长: '총 길이',
  连衣裙: '드레스',
  后衣长: '몸 뒤쪽',
  '头围（内侧）': '머리 둘레(내부)',
  高度: '높이',
  肩带: '어깨 끈',
  下胸围: '언더부스트',
  长度: '총 길이',
  最大宽度: '최대 너비',
  跟高: '힐 높이',
  鞋底宽: '바닥 너비',
  '鞋底的长度（有鞋跟的商品除外）': '솔 총길이(굽이 있는 상품 제외)',
  鞋前宽: '발등 둘레',
  '脚踝围（外侧）': '발목 둘레(외부 치수)',
  '筒围（内侧）': '토우 둘레(내부 치수)',
  鞋底高度: '솔 높이',
  宽度: '너비',
  实物图片: '실물 사진',
  简易检品: '상세검품(표만)',
  详细检品: '상세검품(표면+안면)',
  开扣眼: '버튼 홀 열기',
  缝布标: '태그 봉제',
  缝水洗标: '워싱라벨 봉제',
  '去原标（水洗标、布标、吊牌）': '천 태그, 세탁 태그 제외(태그 전부 제외)',
  首饰台纸: '액세서리용 대지',
  检针服务: '검침 작업',
  熨烫: '다림질',
  除味: '탈취 작업',
  '感谢卡（检品时放在每件商品内）': '감사카드 넣기(검품시 넣기)',
  '丝带包装（检品时放在每件商品内）': '리본 포장(검품 시 넣기)',
  '雪梨纸包装（检品时放在每件商品内）': '얇은 잎 종이 포장(검품시 넣기)',
  穿吊牌: '꼬리표 제봉',
  通电检查: '통전 검사',
  '刮刮卡（检品时放在每件商品内）': '스크래치 카드(검품시 넣기)',
  '优惠券（检品时放在每件商品内）': '쿠폰(검품시 넣기)',
  '保证卡（检品时放在每件商品内）': '보증카드(검품시 넣기)',
  说明书: '설명서',
  普通OPP袋: '보통 OPP 가방',
  定制OPP袋: '별주 OPP 가방',
  特殊收纳袋: '특수 수납 가방',
  '其他物料放置（检品时放在每件商品内）': '기타자재배치(검품시 넣기)',
  尺寸测量服务: '상품 측정',
  气泡膜: '뽁뽁이',
  商品缠绕膜服务: '스트레치 필름 서비스',
  商品缓冲垫服务: '제품 쿠션 서비스',
  剪原标: '원래 태크 제거',
  剪布标: '천 라벨을 제거',
  剪水洗标: '워싱라벨 제거',
  剪吊牌: '태그 제거',
  '尺寸变更(缝尺码标)': '사이즈변경(사이즈스티커)',
  '尺寸变更(尺码贴)': '사이즈변경(사이즈스티커)',
  宽松检品: '허술한 검사',
  圧縮袋梱包: '압축봉투 포장',
  新商品服务: '신상품 확인 서비스',
  '感谢卡（发货时放在每个包裹里）': '감사카드 넣기(발송시 넣기)',
  '丝带包装（发货时放在每个包裹里）': '리본 포장(발송시 넣기)',
  装箱服务: '포장 서비스',
  贴标: '라벨 붙여넣기',
  打托盘: '팔레트 포장',
  '雪梨纸包装（发货时放在每个包裹里）': '얇은 잎 종이 포장(발송시 넣기)',
  '刮刮卡（发货时放在每个包裹里）': '스크래치 카드(발송시 넣기)',
  '优惠券（发货时放在每个包裹里）': '쿠폰(발송시 넣기)',
  '保证卡（发货时放在每个包裹里）': '보증카드(발송시 넣기)',
  '其他物料放置（发货时放在每个包裹里）': '기타자재배치(발송시 넣기)',
  '发货袋-普通快递袋': '택배봉투-일반택배봉투',
  商品打木架: '패키지 나무틀',
  贴箱唛: '스티커 마크',
  组合返工: '세트상품 재작업처리',
  '国/地区': '국가/지역',
  '都道府県/州/地域': '지역',
  国际料金表: '국제 요금표',
  '订单商品代金(预估)': '상품 대금(예상)',
  '订单商品附加项(预估)': '부가서비스 비용(예상)',
  '订单本次实付金额(预估)': '합계 지불 금액(예상)',
  国家不能为空: '국가는 비워둘 수 없습니다.',
  国家填写有误: '국가 작성 오류',
  待确认报价: '견적 확인',
  s: '보류중',
  是否有异常联络: '이상상품 처리',
  支付信息: '총 결제 금액',
  订单总金额: '주문 총 금액',
  'API 未链接': 'API 미연결',
  转账金额: '이체 금액',
  提供的服务: '제공하는 서비스',
  银行转帐: '은행 계좌 이체',
  有缺陷的产品退货: '불량품 반품',
  OEM批量生产: 'OEM 대량 구매',
  OEM样品订单: 'OEM 샘플 제작',
  '* 只可办理资金充值、各店转账、缴纳会员费': '* 자금 충전, 매장별 이체, 회원비 납부만 처리가능',
  '订单将在商店下达，因此': '주문은 상점에서 하달되므로',
  '下单前，您必须先通过转账方式将资金转入商店。': '주문하기 전에 먼저 이체를 통해 점포으로 자금을 이체해야 합니다.',
  '产品价格/产品选择成本': '제품가격/제품선택원가',
  '可立即存款，转账费 3.4%': '즉시입금가능, 이체수수료 3.4%',
  '付款反映：约1个工作日': '지불반영 : 약 1영업일',
  '*周末、公众假期和替代假期的转账将在下一个工作日处理。': '*주말, 공휴일, 대체휴가 이체는 다음 영업일에 처리됩니다.',
  '请提供包含转账日期、转账请求人、收件人姓名和转账金额信息的图片。': '이체일자, 이체청구인, 수취인 성함과 이체금액 정보가 포함된 이미지를 부탁드립니다.',
  '简单快捷；可立即存款；转账费 3.4%': '간편 간편, 즉시입금 가능, 이체수수료 3.4%',
  出借人的土地: '차용인의 토지',
  银行网站: '은행 웹사이트',
  '双字节片假名，名字和姓氏之间的双字节空格': '这个不用翻译，韩国没有WF',
  '*必须与实际转账姓名一致。 请注意输入错误': '*실제 계좌이체 이름과 일치해야 합니다. 입력 오류에 주의하시기 바랍니다',
  注意: '주의',
  '如果取消，所有输入的信息将被删除。': '취소하시면 입력하신 모든 정보가 삭제됩니다.',
  '你确定你要继续吗？': '계속하시겠습니까?',
  '指定账户付款完成后，资金立即记入系统账户': '지정된 계좌의 지불이 완료된 후, 자금은 즉시 시스템 계좌에 입금됩니다.',
  请注意: '주의해 주세요.',
  '注册信息与实际账户信息必须完全一致。 只要信息中的一个字符不同，就无法验证支付筛选。': '등록 정보와 실제 계정 정보가 완전히 일치해야 합니다. 메시지의 한 문자가 다른 한, 결제 심사를 검증할 수 없습니다.',
  货币: '화폐',
  账户持有人姓名: '계좌 소유자명',
  帐号: '계좌 번호',
  银行代码: '은행 코드',
  分行代码: '지점 코드',
  银行名: '은행명',
  银行国家: '은행 국가',
  银行地址: '은행 주소',
  往来账户: '당좌 계정',
  复制银行信息: '은행 정보 복사하기',
  预定转移日期: '이전 예정일',
  请选择: '선택 요망',
  请选择2: '선택해 주세요',
  必填字段: '필수 필드',
  '请注意，如果预定的转账日期与您输入的付款日期不匹配，则付款可能需要一些时间才能反映在系统帐户中。': '입금예정일이 입력하신 결제일과 일치하지 않을 경우, 결제금액이 시스템 계정에 반영되기까지 다소 시간이 소요될 수 있음을 유의하시기 바랍니다.',
  '货币：日元': '화폐：한화',
  搜索来源银行名称: '출처 은행명 검색',
  '未找到银行名称 手动输入': '은행명을 찾을 수 없으므로 수동으로 입력해 주세요',
  输入转账来源银行名称: '계좌이체 출처 은행명 입력',
  店铺配置: '설정관리',
  添加地址: '주소 추가',
  年: '년',
  月: '월',
  日: '일',
  押金退还: '보증금 반환',
  修改附加项组合: '추가 항목조합 수정',
  待确认运输方式: '배송 보류',
  原运输方式: '원운송 방식',
  变更理由: '변경 사유',
  建议运输方式: '권장 운송방식',
  收件人姓名: '수취인 이름',
  费用明细: '비용 명세',
  押金: '작성',
  订单已清算完毕: '주문 정산 완료',
  已返还: '반환 완료',
  未返金: '미 환불',
  商品代金: '상품 대금',
  未确认: '미 확인',
  国内运费: '중국국내 운송비',
  代购手续费: '금액',
  '{day}期({rate})商品代金(押金)': '{day}기 상품 대금(보증금)({rate})',
  '商品附加项(押金)': '상품 옵션비용(보증금)',
  '商品代金(押金)': '상품 대금(보증금)',
  返金: '요금 반환',
  '商品附加项(返品不可不良品)': '상품 부가항목(불량품→양품)',
  国内运费退款: '중국국내 운송비 환불',
  '这是提交订单时重新订购（缺货、出现缺陷时重新购买）的临时付款。 包括产品价格和产品选择成本。': '주문서 제출 시 재주문(품절, 불량 발생 시 재구매)에 대한 가지급금입니다. 제품 가격과 제품 선택 비용을 포함합니다.',
  '一旦最终费用确定，相关费用将全额退还。': '최종 비용이 확인되면 해당 비용은 전액 환불됩니다.',
  '经检验、退货、换货等后，为最终产品价格及产品选择费用。': '검사, 반품, 교환 등을 거친 후 최종 제품 가격 및 제품 선택 비용입니다.',
  '这将是中国境内的最终运费和购买费用。': '이것은 중국내 최종 운송비와 구매 비용입니다',
  没有设置: '설정 없음',
  下载收据: '영수증 다운로드 ',
  质检区库存使用数量: '검품 구역 재고 수량',
  成品区库存使用数量: '완제품 구역 재고 수량',
  库存: '재고',
  '使用单件库存组装套件时，将收取返工费。': '단품 재고 조립 키트 사용 시 재작업비가 부과됩니다.',
  '请检查价目表了解返工费。': '가격표를 검토하여 재작업비를 알아보세요.',
  '（单品库存是已经存放在良品室的良品库存，使用单品库存制作套装时，良品库存必须退回检验室重新包装，因此会产生返工费收费。增加。）': '(단품재고는 양품실에 이미 보관되어 있는 양품재고이며, 단품재고를 사용하여 세트를 제작하는 경우 양품재고는 검사실로 반송하여 재포장하여야 하므로 재작업비 발생됩니다.)',
  商品基础信息: '상품 기초 정보',
  链接添加: '링크 추가',
  附加项组合: '옵션 조합',
  '您可以将多项附加项创建为一个组合，帮助您快速选择附加项': '여러개의 옵션을 조합함으로써, 옵션 선택을 빠르게 하도록 도와줍니다.',
  主站: 'HOME',
  最新情報: '최신 정보',
  '什么是THE CKB': 'THE CKB란',
  费率计划: '요금안내',
  计划诊断: '계획 진단',
  国际航运: '국제 운항',
  代购服务: '구매대행 서비스',
  '- 购买现有产品': '- 기존 제품 구매',
  '- FBA直送': '- FBA 직송',
  检验服务: '검품 서비스',
  '- 检查': '- 검수',
  '- 维修': '- 보수',
  物流服务: '물류 서비스',
  '- 国际运输': '- 국제 운송',
  '- 仓库储存': '- 창고 보관',
  促销服务: '기타 서비스',
  '- 翻译': '- 번역',
  '- 照片': '- 사진',
  '- 导入文章': '- 문장 올리기',
  系统: '시스템',
  库存系统: 'B2B',
  无库存系统: 'D2C',
  使用流程: '사용 절차',
  常问问题: '자주 묻는 질문',
  文件要求: '문서 요구 사항',
  免费注册: '가입',
  免费注册2: '가입',
  询问: '문의',
  采购来源: '구매사이트',
  信息: '정보',
  辅料选择: '부자재 선택',
  '客户资材必须得提前先下好，保存在仓库，否则无法对应': '고객의 자재는 반드시 미리 주문하여 창고에 보관해야 하며, 그렇지 않으면 대응할 수 없습니다.',
  新增寻源任务: 'OEM신청',
  附加项管理: '옵션 셋팅',
  '韩国站{value}级会员': '한국역 {value}급 회원',
  会员资格结束日期: '회원 마감 날짜',
  我的商品测量结果: '상품 사진 및 수치',
  我的商品测量结果menu: '상품 사진 및 수치',
  韩语: '한국어',
  '韩国站{value}级会员等级说明': '한국역 {value}급 회원등급 안내',
  费用详情: '비용 명세',
  待付款提醒: '미지급 알림',
  '您有{num}笔订单待付款，请及时支付，否则会影响订单履约': '지불해야 할 {num}개의 주문서가 있으니, 제때에 지불하십시오, 그렇지 않으면 주문 이행에 영향을 줄 겁니다.',
  错误信息: '오류 정보',
  购物车商品: '장바구니 상품',
  我的商品: '나의 상품',
  '转账金额（韩元）': '이체 금액(한화)',
  '处理缺陷/异常': '불량/이상 처리',
  商品问题原因: '상품문제원인',
  商品数量: '수량',
  请选择处理方式: '처리방식을 선택해 주세요',
  只可选择一种: '하나만 선택 가능',
  更换颜色: '컬러 변경',
  取消商品: '상품 취소',
  换个链接: '링크 병경',
  平台商品SKU: '플랫폼 제품 SKU',
  'THE CKB订单编号': 'THE CKB 주문번호',
  申请售后时间: 'A/S일자',
  售后进度: '진행상황',
  售后原因: '신청 원인',
  导出订单: '주문목록 다운로드',
  重新发起: '재 신청',
  撤销: '취소',
  申请售后: 'A/S신청',
  撤销售后: 'A/S신청 취소',
  申请时间: '날짜 선택',
  取消进度: '상태 취소',
  '该操作，会将已发起售后商品信息撤销，请确认是否撤销该商品售后？': '【확인하세요】\n신청하신 A/S 신청을 취소하면 해당 상품에서는 다시 A/S 신청이 불가합니다.신청을 취소하시겠습니까?',
  撤销商品不可再次发起撤销: '취소하면 해당 상품에서는 다시 A/S 신청이 불가합니다',
  请选择售后原因: '신청원인',
  详细说明: '상세 설명',
  申请售后数量: '신청 수량',
  售后退款金额: '환불액',
  '点击上传图片（最多上传5张）(只能上传jpg/png文件，且不超过10M)': '이미지 업로드해주세요!(최대 5장까지.형식:jpg/png10M이내))',
  '点击上传图片（最多上传5张）(只能上传jpg/png文件，且不超过10000kb)': '이미지 업로드해주세요!(최대 5장까지.형식:jpg/png 10000kb이내))',
  撤销成功: '취소 완료',
  问题处理: '대응 지시 선택',
  问题处理2: '이상주문 목록',
  售后: '사후 보상 신청',
  申请取消: '취소 신청',
  商品取消履历: '취소 목록',
  待处理: '처리 대기중',
  业务处理中: '업무부서 처리중',
  财务处理中: '재무부서 처리중',
  已退款: '환불 완료',
  已拒绝: '거부 처리',
  已拒绝2: '거부',
  已拒绝4: '거부',
  '重新发起（处理中）': '재발기(처리 중)',
  已撤销: '취소 완료',
  次品: '불량품',
  次品2: '불량품',
  相异品: '상이품',
  数量不足: '수량 부족',
  处理中: '준비중',
  处理中1: '준비중',
  保留库存: '재고 보관',
  取消成功: '취소완료',
  商品信息: '상품 정보',
  '商品信息(CM)': '상품 정보(CM)',
  问题生成时间: '날짜 선택',
  处理方式: '대응 상태',
  取消数量: '취소 수량',
  退款金额: '환불액',
  申请售后件数: '신청 수량',
  拒绝原因: '거부이유',
  拒绝原因2: '거부하는 이유',
  退款总金额: '환불 총액',
  退款说明: '환불 설명',
  不可优先发货: '우선 발송 불가',
  '可优先发货(订单下部分商品已全部上架)': '우선 발송 가능 (검품 완료 상품)',
  未处理: '미처리',
  已处理: '처리 완료',
  商品sku: '상품 sku',
  组合附加项: '세트조 옵션',
  下单组合数: '세트세트주문수',
  组合完成数: '세트조 완료수',
  '服务费（元）': '수수료(위안)',
  组合状态: '대응 상태',
  商品画像: '상품 이미지',
  本单质检上架数: '양품수',
  转结落单库存数: '잔재고 이용수',
  组合落单库存处理情况: '본 주문잔재고',
  国家: '국가',
  都道府県: '도시명',
  序号: 'No.',
  商品单价: '상품 단가',
  '总价（RMB）': '합계액(CNY)',
  总价2: '합계액',
  商品状态: '상품현황',
  详情费用: '비용 명세',
  代买手续费: '대행 수수료',
  入库手续费: '입고 수수료',
  质检手续费: '검품 수수료',
  发货手续费: '발송 수수료',
  发货单号: '발송의뢰번호',
  生成时间: '작성 일시',
  国际运单号: ' 운송장 번호',
  重量g: '중량(g)',
  是否发货: '배송 상황',
  发货时间: '발송 일시',
  商品番号: '상품 번호',
  其他费用: '기타',
  费用类型: '비용 유형',
  时间: '일시',
  地址详情: '상세주소',
  客户订单编号: '고객주문번호',
  下单时间: '주문 일시',
  详情地址: '상세주소',
  编辑地址: '편집',
  取消并退款: '환불 완료',
  已上架: '출고 가능',
  检品中: '검품중',
  异常: '이상',
  国内运输中: '국내운송중',
  已发货: '배송중',
  已发货2: '배송중',
  已采购: '구매완료',
  采购中: '구매중',
  已入库: '입고완료',
  待采购: '구매대기중',
  查看: '상세',
  发货单详情: '발송상세부',
  未发货: '출하 대기',
  未发货2: '출하 대기',
  编辑收货地址: '배송지 편집',
  请确认取消信息: '취소 정보',
  '确认是否取消？': '확인 부탁드립니다.',
  合: '합',
  订单编号: '고객주문번호',
  等待审核: '심사 대기',
  下单成功: '발주 완료',
  订单来源: '발주처',
  订单类型: '주문 종류',
  国际物流信息详情: '국제 배송 정보',
  业务类型: '매입유형',
  取消结果: '취소 상황',
  所有订单: '모든주문',
  待付款: '결제대기',
  可发货: '발송 대기',
  部分发货: '일부 발송 대기',
  已完成: '완료',
  已完成2: '지불완료',
  物流公司: '운송회사',
  国际物流单号: '트레킹 번호',
  发货数量: '배송수량',
  是否合单: '발송 상태',
  Base: 'Base',
  Shopify: 'Shopify',
  Stores: 'STORES',
  Amazon: 'Amazon',
  直发订单: '직송 주문',
  囤货订单: '재고 보관 주문',
  可优先发货: '우선 발송 가능',
  未组合: '대응 대기',
  组合中: '대응 중',
  组合完成: '대응 완료',
  取消组合: '취소',
  日志: '조작 로그',
  详情: '상세',
  优先发货: '우선 발송',
  去支付: '지불하러',
  是否去支付: '지불하러',
  国际物流单号信息: '국제배송의뢰번호',
  商品日志详情: '조작 로그',
  支付成功: '지불완료',
  结束时间: '종료일',
  商品搜索: '상품 검색',
  下单日: '주문일',
  发货日: '발송일',
  客户商品信息: '고객 상품 정보',
  客户商品SKU: '고객님 상품 SKU',
  客户商品名称: '상품명',
  客户商品规格: '고객 규격',
  客户商品图片: '상품 이미지',
  采购商品SKU: '직항편 SKU',
  采购商品信息: 'THE CKB 상품 정보',
  采购商品名称: 'CKB 상품명',
  采购商品规格: '직항편 상품 규격',
  采购商品图片: '직항편 상품 이미지',
  商品采购渠道: '구입처',
  商品状态变更日志: '상태 변경 이력',
  操作记录: '상태',
  变更时间: '상태 변경일',
  '已上架（已清算）': '출고 가능(청산 완료)',
  '你授权的xxx店铺取消授权后，店铺订单和商品将不再同步，是否继续取消？': 'API연계해제로xxx데이터는읽을수없습니다.',
  是: 'API 연계를 해제하시겠습니까?',
  否: '연계 해제',
  解绑成功: '취소',
  店铺名: '점포명',
  创建时间: '작성일시',
  状态: '작성 일시',
  店铺钱包可用余额: '점포 잔액',
  店铺账号: '점포 계정',
  api权限: '계정 정보',
  店铺管理: '기초설정관리',
  授权店铺管理: '점포 관리',
  添加新店铺: '점포추가',
  激活子账号: '부계정 생성',
  配置店铺: '설정 관리',
  开启自动同步下单: '점포 설정',
  取消授权: '자동 발주',
  创建成功: '연계 해제',
  创建成功2: '연결 완료',
  保存成功: '보존 완료',
  修改成功: '변경 완료',
  店铺修改成功: '매장정보 변경완료',
  物流配置修改成功: '변경이 성공했습니다',
  水洗标制作: '세탁 태그 작성',
  日本配送公司: '운송회사',
  国际发货单号: '트레킹 번호',
  偏远地区附加费: '원거리 수송 수수료',
  偏远地区附加费退回: '원거리 운송 수수료 환불',
  '出账 / 入账': '출/입금',
  余额: '잔액',
  明细: '명세',
  流水号: '접수 번호',
  日期: '날짜',
  可用余额: '사용 가능 잔액',
  直行发货单号: '직항편 발송 의뢰 번호',
  出账: '출금',
  入账: '입금',
  充值: '충전',
  转账: '이체',
  表格导出: '다운로드',
  的钱包: '계좌수지표',
  主账号钱包: '부모 계정 계좌 목록',
  我的店铺钱包: '예치금 내역보기',
  冻结金额: '동결 금액',
  未入账金额: '충전금액(元）-심사중',
  查询: '검색',
  收据下载: '입금영수증다운로드',
  金额: '무통장입금액(KRW)',
  币种: '화폐 종류',
  上传凭证: '업로드하기',
  '振込金額(日本円)': '송금금액(일본엔)',
  公司名称: '회사명',
  店铺主页入口: '홈페이지',
  姓氏: '씨',
  名字: '이름',
  邮箱地址: '로그인용 이메일',
  国际: '국적',
  存入金额: '무통장입금',
  '加载完成！': '읽기 완료!',
  '充值成功！': '충전완료!',
  充值成功: '충전완료',
  收款账号: '이체처 계좌 정보',
  最多可转账金额: '이체 가능액',
  '商品sku/店铺商品sku/海外仓sku': '상품sku/고객상품sku/FNSKU',
  店铺商品sku: '고객상품sku',
  选择地址: '주소 선택',
  输入的手机号位数不正确: '올바른 전화번호를 입력해 주세요.',
  区町村不能为空: '구읍면 불능 상태',
  最少3个文字以上: '3글자 이상을 입력해 주세요.',
  请输入正确的邮编: '올바른 우편번호를 입력해 주세요.',
  地址添加成功: '새주소 추가완료',
  'sku/平台商品信息': 'sku/상품정보',
  库存数量: '양품수',
  代采商品良品数: '양품수',
  客户商品sku: '고객 SKU',
  海外仓sku: 'FNSKU',
  店铺名称: '점포명',
  需要填写清关地址: '통관 주소를 입력해 주세요!',
  选择清关地址: '통관주소 선택',
  添加清关地址: '통관주소 선택',
  补货批次标题: '납품 타이틀',
  箱唛上传: '상자 라벨',
  物流方式: '운송회사',
  kg: 'kg',
  计算: '계산',
  预估物流价: '참고 배송료',
  '注意：您可以在此输入预计的重量 大致估算出物流价格，货品发出前将根据实际扣除物流费用，请确保您的账户余额充足，余额不足无法扣款将影响您的发货进度。': '【주의】여기에 예상 중량을 입력하여 예상 물류 가격을 추정할 수 있으며 상품을 발송하기 전에 실제 물류 비용을 공제할 겁니다!계좌 잔액이 충분한지 확인하십시오. 잔액이 부족하면 차감할 수 없는 것은 배송 진행에 영향을 미칩니다.',
  填写: '입력',
  移除: '삭제',
  请选择商品: '상품을 선택해주세요',
  '区町村-详细地址': '구읍면-상세주소',
  国际发货标题不能为空: '※ 필수 항목입니다',
  必填: '※ 필수 항목입니다',
  必填2: '필수항목입니다',
  物流方式不能为空: '물류 방식은 비워둘 수 없습니다.',
  '支持格式doc;excel;pdf;': '형식 : doc, excel, pdf',
  '文件大小不超过50m；': '용량:50M 이내',
  箱唛上传不能为空: '※ 필수 항목입니다',
  拣货中: '피킹 작업 중',
  打标中: '라벨 부착 중',
  打包中: '포장 중',
  打包完成: '포장 완료',
  标题: '제목',
  运单号: '운송장 번호',
  大件fba: '대량배송(FBA)',
  大件普通: '대량 배송(FBA 이외)',
  小件: '소액 배송',
  次品退货: '불량품 반품',
  次品退货2: '불량품 반품',
  异常退货: '이상품 반품',
  仓库调拨: '창고 조달 중',
  创建补货计划: 'Amazon 납품 플랜 작성',
  'Amazon sku': 'Amazon sku',
  sku: 'sku',
  补货批次号: '아마존 납품 번호',
  国际运费号: '운송장 번호',
  运输方式: '운송 방식',
  合计总额: '합계액',
  AMAZON商品名称: 'Amazon 상품명',
  计划发货数量: '배송 예정수',
  基本详情: '배송 정보',
  发货重量: '총중량(포장후중량)',
  计费重量: '청구 중량',
  国际发货状态: '배송 상황',
  '收货仓/地址': '납품처',
  配送件数: '배송 건수',
  箱数: '상자 수',
  装箱清单: '포장 리스트',
  装箱清单2: '포장 명세서',
  商品内容: '상품 상세',
  创建国际发货: '국제 배송 의뢰',
  寻源表: '견적 의뢰서',
  寻源种类: '상품류',
  类别: '플랜',
  X类: 'X류',
  类别注明: '서비스 내용',
  产品名称: '상품명',
  参考图片: '참고 이미지',
  提供项: '참고 정보',
  是否提供: '제공 완료',
  具体内容: '상세',
  参考链接: '참고 URL',
  样衣: '샘플',
  物流单号: '추적 번호',
  需要改动的地方: '변경하고 싶은 부분',
  '描述内容(材质，设计，颜色，尺寸等)': '디자인설명(원단, 디자인, 색상, 사이즈 등)',
  附件: '첨부 파일',
  式样书: '사양서',
  '附件(包含产品的色卡、尺寸、特殊工艺、面料信息等)': '첨부파일(상품의 색상, 사이즈, 디자인, 원단 등의 정보를 입력해주세요)',
  面料: '옷감',
  需求描述: '변경하고 싶은 부분의 설명',
  面料信息: '원단 상세',
  色卡信息: '컬러',
  Logo: 'Logo',
  '详细说明(颜色、尺寸、位置、工艺等)': '설명(컬러, 사이즈, 로고 프린트 위치)',
  辅料种类: '자재 종류',
  'THE CKB预选方案选择': '직항편 추천 방안 선택',
  分类: '항목',
  选择方案: '상세',
  定制补充部分: '고객 요망',
  文字描述: '설명',
  材质方案: '원단 방안',
  款式方案: '디자인 방안',
  尺寸方案: '크기 방안',
  颜色方案: '컬러 방안',
  款式描述: '디자인 상세',
  材质描述: '사이즈 상세',
  尺寸描述: '척촌묘술',
  颜色描述: '색상 상세',
  设计图或参考图片: '화상',
  产品信息: '상품 상세',
  具体尺码信息: '사이즈 가이드',
  对应关系: '상세',
  自己提供: '사이즈 가이드를 제출하다',
  尺码表: '사이즈 가이드',
  参考链接尺寸: '상품페이지 치수 참고',
  'THE CKB提供': '직항편 제안',
  其他补充: '비고',
  下单需求: '주문 정보',
  期望价格: '희망 가격',
  期望交期: '희망 납기',
  期望起订量范围: '희망 로트 수',
  侧重点: '중시할 것',
  品质: '품질',
  交期: '납기',
  Logo需求情况: '로고 상세를 말해주세요',
  需要: '네',
  不需要: '아니에요',
  '工厂、资质要求': '지정공장, 허가증에 관한 요청',
  特殊需求: '기타 요망',
  服装: '의류',
  杂货: '잡화',
  辅料: '부자재',
  内容: '상세',
  备注说明: '비고',
  操作人: '사용자',
  报价信息: '견적서',
  是否加Logo: 'Logo 추가',
  是否为特殊面料: '특수 명단',
  次品处理方式: '불량품 처리방식',
  风险: '리스크',
  打样费: '샘플 제작 요금',
  打样时间: '샘플 납기',
  天: '일',
  时: '시간',
  分: '분',
  秒: '초',
  最小起订量: '최저 로트수',
  单尺码: '싱글 사이즈',
  多尺码: '멀티 사이즈',
  商品数量区间: '상품수',
  阶梯价格: '가격',
  报价有效期: '견적서 유효기간',
  国际运费说明: '※ 상품보다 공장에서 당사 창고까지 국내 배송료가 발생할 수 있습니다.배송비가 발생할 경우 잔액보다 비용을 인출해 드립니다.',
  全部订单: '주문 목록 목록',
  未发布: '미제출',
  等待报价: '견적 대기',
  已报价: '견적 확인',
  寻源成功: '견적 완료',
  报价失效: '견적서 유효기간 만료',
  已取消: '취소 완료',
  已取消2: '취소',
  重新发布: '재제출',
  再次买入单号: '재구매 번호',
  类型: '종류',
  申请表: '신청 목록',
  商品名: '상품명',
  查看明细: '상세',
  发起时间: '작성 일시',
  寻源单编号: '견적서 의뢰서 번호',
  查看详情: '상세',
  拒绝备注: '비고',
  是否确认编辑: '재편집하시겠습니까?',
  是否确认发布寻源单: '발주',
  发布: '제출',
  是否确认取消待发布寻源单: '취소하시겠습니까?',
  是否确定下样品单: '샘플 발주하시겠습니까?',
  下样品单: '샘플 발주',
  是否确定下大货单: '양산을 합니까?',
  下大货单: '양산',
  是否确认申请退款: '환불하시겠습니까?',
  申请退款: '환불 요청',
  报价过期: '견적서 유효기간 만료',
  是否确认申请复购: '견적 유효기간이 지났습니다, 최신 견적을 의뢰하시겠습니까?',
  复购申请: '재구매',
  是否确认重新编辑: '재편집하시겠습니까?',
  重新编辑: '편집',
  重新编辑2: '재편집하다',
  操作日志: '조작 로그',
  发布成功: '제출 완료',
  退款成功: '환불완료',
  已提交申请复购: '이제교신복장',
  复购申请中: '견적 의뢰중',
  复购已拒绝: '거부필',
  复购已报价: '견적 확인중',
  关联异常: '연결 오류',
  待关联: '끈 대기',
  售卖价格: '고객 판매 가격',
  关联状态: '옵션설정 여부',
  已关联SKU数量: 'SKU 연결 완료',
  采购商品名: 'CKB 상품명',
  采购价格: '매입 가격',
  采购商品图: '직항편 상품 이미지',
  '该店铺未授权同步数据功能，授权后可绑定商品，享受自动下单功能。': 'API 미연계, API 연계로 주문 자동 처리 가능',
  '因采购链接发生变动，请重新绑定': '구입처 URL 변경 완료, 다시 구입처 연결 처리를 해 주십시오.',
  编辑关联: '연결 변경',
  番号保存成功: '보존 완료',
  组合商品SKU: '세트 조 번호',
  组合在库状态: '잔재고',
  '单价（元）': '단가(元)',
  '待组合库存数量（截止时间）': '단품잔재고수(조합기한)',
  组合商品管理: '세트 세트 상품 목록',
  扩大加购: '카트에 추가',
  完结: '단품으로 관리',
  加购: '카트에 추가',
  附加项修改成功: '옵션변경이완료되었습니다.',
  添加成功: '추가 완료',
  完结成功: '단품상품관리로변경완료',
  存在待组合: '잔재고 있음',
  不存在待组合: '잔재고 없음',
  找相似: '유사 상품을 찾다',
  断开: '해제',
  店铺商品sku解绑成功: '연결을 해제했습니다',
  选定: '선택',
  已连接其他SKU: '끈을 매김',
  断开原有链接: '매듭을 해제하다',
  请选择采购商品sku: '직항편 상품을 선택해 주세요',
  请选择店铺商品sku: '고객님 상품을 선택해주세요',
  请选择商品附加项: '상품옵션을선택해주세요',
  店铺商品sku绑定成功: '직항편 상품과 연결이 완료되었습니다.',
  同步成功: '도입이 완료되었습니다',
  '10-20元': '10-20위안',
  '20-30元': '20-30위안',
  '30-50元': '30-50위안',
  '50-100元': '50-100위안',
  '100-150元': '100-150위안',
  '200-300元': '200-300위안',
  '300元以上': '300위안 이상',
  选择要链接的商品: '구입처 상품을 선택',
  选择要链接商品的SKU: 'SKU와 결부',
  自动同步采购订单: '발주 정보를 자동으로 도입',
  '同步已授权的店铺内商品，并进行绑定': '점포 상품 정보를 가져와 구입 URL과 연결',
  搜索青蛙商品: '상품을 검색하다',
  商品链接或商品名: 'URL,상품명,THE CKB 상품번호를 검색하여 주문',
  类目筛选: '목록 선택',
  价格筛选: '가격 선택',
  采购商品: '구입처',
  店铺商品: '고객 상품',
  重新选择商品: '구입처 재설정',
  创建关联: '연결 만들기',
  系统查询到您有辅料未添加到附加项配置: '설정된 옵션이 없습니다.',
  平均单价: '평균 단가',
  锁定: '발송대기',
  可用: '가용 재고',
  待处理次品: '불량품(반품불가)',
  辅料图片: '사진',
  辅料名称: '부자재명',
  关联附加项: '옵션 설정',
  辅料规格: '규격',
  辅料skuid: '자재 SKU',
  待入库: '입고 대기',
  次品图: '화상',
  说明: '상세',
  说明2: '주의',
  丢弃: '폐기',
  转为正常商品: '양품으로 입고',
  我的商品库存: '재고',
  我的物料: '부자재',
  未关联附加项: '미연결',
  '未关联附加项的辅料，将不会再订单商品中自动使用': '옵션 적용 미설정 자재 있음',
  下单时的附加项不可用: '주문시 옵션으로 자재이용불가',
  配置附加项: '옵션 연결',
  辅料绑定提醒: '부자재의 옵션을 설정해 주세요.',
  '物料名/sku': '상품명/SKU',
  已有关联附加项: '설정 완료',
  未有关联附加项: '미설정',
  可用库存数量筛选: '분류',
  至: '-',
  清空: '초기화',
  批量加入购物车: '장바구니 일괄 추가',
  '关闭自动续费后，您的会员将于': '회원비 자동납부 해제로 인해 현 회원 클래스의 이용이',
  到期请前往paypal平台关闭自动续费: 'Paypal 공식 사이트에서 자동 지불 설정을 해제하십시오.',
  '到期是否现在关闭？': '로 종료합니다',
  '恭喜！！！已为您开启自动续费，记得保持余额充足': '회원비 자동이체를 ON으로 했습니다.',
  支付方式: '지불 방법',
  购买明细: '지불 명세',
  会员信息: '회원 플랜',
  原价: '통상 구입 가격',
  优惠金额: '묶음 할인',
  ヶ月: '개월',
  有效期: '유효 기간',
  总计: '합계',
  立即支付: '지불하러',
  立即支付2: '즉시 지불',
  '购买会员到期后我们会为您自动续费，您可在工作台-会员管理中关闭自动续费服务': '회원비 자동결제 설정 및 해제는 회원 페이지에서 변경하실 수 있습니다.',
  月会员办理: '회원 플랜',
  每月: '월',
  选择办理会员周期: '이용 기간',
  请联系主账号更改会员等级: '본계정만 회원 등급을 변경 가능',
  去充值: '자금 충전으로',
  去充值2: '자금 충전으로',
  您的账户余额不足: '계좌 잔액 부족',
  确认支付: '지불하러',
  '立即购买（自动续费）': '지불하러',
  '购买后新会员等级立即生效，原有等级作废，如有疑问请联系客服': '즉시 변경 후 회원 플랜 적용 가능',
  请选择会员套餐: '회원 플랜을 선택',
  自动续费中: '회원비 자동이체',
  开通自动续费: '회원비자동지급ON',
  到期: '종료일',
  关闭成功: '회원비자동지급 OFF 변경완료',
  我的消息: '메시지',
  全部已读: '모두 읽음',
  已读: '읽음',
  '未读/已读': '읽지 않음/읽음',
  姓名: '성명',
  请输入姓名: '수취인을 입력해 주세요.',
  手机号: '연락 방법',
  请输入市区町村: '시구읍면을 입력해 주세요.',
  请输入详细地址: '상세주소를 입력해주세요',
  请输入邮箱: '메일 주소',
  '你的子账号没有修改权限，请联系主账号管理者修改你的密码': '서브 어카운트에서는 정보 수정이 불가능합니다.메인 어카운트부터 대응해 주십시오.',
  无效内容: '무효값',
  无效的地址: '주소가 무효입니다.',
  收件人姓名不能为空: '※ 필수 항목입니다',
  市不能为空: '※ 필수 항목입니다',
  确定删除该商品: '이 상품을 삭제하시겠습니까?',
  确定不再显示该商品: '이 상품을 숨기겠습니까?',
  确定清空购物车: '카트 상품을 모두 삭제하시겠습니까?',
  确定删除此配置: '이 설정 내용을 삭제하시겠습니까?',
  确定删除此地址: '이 주소를 삭제하시겠습니까?',
  '当前页面的修改内容未保存，是否离开': '변경사항은 저장되어 있지 않습니다. 다른 페이지로 이동하시겠습니까?',
  请至少选择一个配置类目: '적어도 하나의 카테고리를 선택하십시오.',
  请将收货人信息填写完整后提交订单: '입력 필수, 배송지 정보',
  '单笔订单价值不得超过XX元，请调整商品数量': 'XX위안 이상 주문하려면 B2B 페이지로 이동해서 주문하시기 바랍니다!',
  添加附加项模板成功: '디폴트 옵션을 추가했습니다.',
  修改附加项模板成功: '디폴트 옵션 변경이 완료되었습니다.',
  修改邮箱成功: '메일 주소 변경이 완료되었습니다.',
  登录: '로그인',
  请登录: '로그인',
  请先登录: '로그인',
  密码登录: '사용자 이름 로그인',
  邮箱验证登录: '이메일 주소 로그인',
  获取验证码: '인증코드 발송',
  忘记密码: '비밀번호 찾기',
  '没有账号?去注册会员': '신규 회원 등록',
  '用户名或邮箱不正确。': '사용자 이름 입력 오류.',
  '请重新输入1-18位用户名或邮箱。': '유저명은, 1~18 이내의 반각영수문자로 설정해 주세요.',
  '输入的密码格式不正确，密码由6-32位字母或数字组成': '패스워드 입력 오류.패스워드는, 6~32문자 이내의 반각영수로 설정해 주세요.',
  '邮箱格式不正确，请重新输入': '메일 주소 입력 필수',
  '验证码格式不正确，请重新输入': '인증 코드는 유효하지 않습니다.최신 코드를 입력하십시오.',
  '请确认后输入验证码。': '확인하시고 인증코드를 입력해주세요.',
  '密码不正确，请重新输入': '패스워드 입력 오류.',
  '用户名或密码不正确，请重新输入': '사용자 이름 입력 오류.',
  '邮箱或验证码错误，请重新输入': '인증 코드 비활성화.인증코드를 다시 보내주시고 올바른 인증번호를 입력해주세요.',
  密码不能为空: '비밀번호를 입력해주세요',
  用户名不能为空: '※ 필수 항목입니다',
  输入用户名: '사용자 이름 입력',
  输入密码: '비밀번호 입력',
  输入邮箱: '이메일 주소 입력',
  输入验证码: '인증코드입력',
  找回密码: '비밀번호 잊어버리신 경우',
  重设密码: '비밀번호 재설정',
  注册邮箱: '이메일 주소',
  邮箱验证码: '인증 코드',
  新密码设置: '새 비밀번호',
  再次确认新密码: '새 비밀번호(확인용)',
  密码修改成功: '비밀번호 재설정이 완료되었습니다.',
  '请使用刚才重新设定的密码登录。': '방금 재설정한 로그인 비밀번호로 로그인 해주세요.',
  提交: '확인',
  注册: '신규 등록',
  '已有会员，': '已有会员，',
  立即登录: '로그인',
  请选择适合你的业务类型: '구입 방법을 선택해 주십시오.',
  适合想要进货到日本仓库的用户: '일본 창고로 납품 (대량 배송)',
  适合想要从中国直发商品到末端客户的用户: '최종 사용자에게 직송(소액배송)',
  立即进入: '홈페이지로',
  用户名: '아이디',
  联系人姓名: '이름',
  密码: '비밀번호',
  再次确认密码: '패스워드(확인용)',
  性别: '성별',
  先生: '남성',
  女士: '여성',
  邮箱: '이메일 주소',
  验证码: '인증 코드',
  联系电话: '전화번호',
  已发送: '송신 완료',
  '已发送{X}S': '송신 완료({X})',
  '该用户名已被注册，': '이 사용자 이름은 이미 사용되었습니다.',
  '请输入别的用户名。': '다른 사용자 이름을 입력하십시오.',
  '用户名不可用。': '사용자 이름 입력 오류.',
  '用户名不可用，请重新设置1-18位(特殊字符和标点符号不能使用)': '아이디 사용 불가, 1-18자리 재설정(특수문자 및 문장부호 사용 불가)/이용규약에 동의/기존 계정',
  '用户名请设置为1~18以内的字符。': '유저명은, 1~18 이내의 문자로 설정해 주세요.',
  '用户名请设置为1~18以内的字符(不支持特殊字符和标点符号)': '유저명은, 1~18 이내의 문자로 설정해 주세요(특수 문자, 기호 입력 불가).',
  联系人姓名不能为空: '※ 필수 항목입니다',
  '格式不正确，请输入真实姓名，包括假名和文字及英文': '이름 형식이 올바르지 않습니다.이름은 한자, 히라가나, 가타가나와 영문만 사용해주세요.',
  '输入的密码格式不正确，请设置6-32位字母或数字，区分大小写': '패스워드 입력 오류.패스워드는, 6~32문자 이내의 반각영숫자로 설정해 주세요.',
  两次密码不一致: '비밀번호 불일치',
  邮箱已被注册: '메일 주소 변경 필요.입력 메일 주소는 이미 이용되고 있습니다.',
  无效的手机号码: '유효한 전화번호를 입력해 주세요.',
  请确认您的手机号码为10到11位数字: '전화번호를 10자리 또는 11자리 반각숫자로 입력해주세요',
  请设置用户名: '사용자 이름 입력',
  '你的名字是？': '성명',
  设置你的登陆密码: '비밀번호 입력',
  请再次输入您的密码: '패스워드(확인용) 입력',
  '请输入您的手机号码（选填）': '(임의) 전화번호 입력',
  '请输入你的Chatwork ID （选填）': 'Chatwork ID (임의)',
  '请输入你的Skype （选填）': 'Skype (임의)',
  注册并登录: '신규 등록',
  同意以下条款: '이용 규약에 동의합니다',
  '已有账号，马上登录': '이미 계정을 가지고 계신 분 로그인',
  返回首页: '홈페이지로',
  默认业务类型: '디폴트 매입 방법',
  新密码: '새 비밀번호',
  原密码: '기존 비밀번호',
  旧密码重置密码: '이전 비번 재설정',
  邮箱重置密码: '이메일 비번 재설정',
  请输入原密码: '현 로그인 비밀번호',
  请输入新密码: '새 비밀번호',
  输入Aucfan的注册邮箱: '输入Aucfan的注册邮箱',
  '根据您输入的信息可以获得会员免费体验，所以请务必输入。': '입력하신 정보를 바탕으로 회원 무료체험이 부여되오니 반드시 입력해주세요.',
  提现渠道: '인출처',
  银行名称: '수취 은행',
  银行名称3: '고객님의 송금처 은행명',
  支店名: '지점 번호',
  口座类别: '계좌 종류',
  银行账号: '은행 계좌',
  银行账号3: '무통장입금원계좌번호',
  收款人名称: '수취인명',
  '提现金额（RMB）': '환불금액(CNY)',
  汇率: '환율',
  费率: '요율',
  可提现金额: '환불 가능액',
  提现手续费: '인출 수수료',
  '提现金额（JPY）': '환불금액(JPY)',
  提现原因: '서랍 원인',
  电子邮件地址: '이메일 주소',
  银行卡: '은행 계좌',
  普通: '보통',
  发送: '送送',
  请选择提现渠道: '인출처',
  请输入银行名称: '무통장입금 은행명',
  请输入支店名: '지점 번호',
  请选择口座类别: '계좌 종류',
  请输入银行账号: '은행 계좌',
  请输入收款人名称: '수취인명입력',
  请输入提现金额: '인출금액 입력',
  请输入验证码: '4자리 인증코드 입력',
  请输入提现原因: '서랍 이유 입력',
  请输入邮箱验证码: '인증 코드',
  个人中心: '마이페이지',
  帮助: '도움말',
  客服: '서비스',
  历史订单: '주문 이력',
  我的库存: '장바구니',
  用户信息: '사용자 정보',
  OEM寻源单: 'OEM으로 해서 메뉴화',
  OEM发起寻源: 'OEM 견적 의뢰',
  同步的订单: '주문관리(API발주)',
  插件安装: 'KAERU 툴',
  购买会员等级: '회원 등급',
  我的店铺: '점포 관리',
  我的钱包: '예치금 내역보기',
  登录账户管理: '회원정보관리',
  授权店铺: '점포 연계',
  异常订单: '이상 주문',
  购物车: '장바구니',
  搜索: '검색',
  最近加入的商品: '최근에 추가한 상품',
  选择你经常使用的功能: '톱 메뉴의 구성을 조정하다',
  最多可选择X个: '최대 X개까지 선택해주세요.',
  请选择你经常使用的类目: '자주 사용되는 카테고리를 선택해주세요.',
  '欢迎来到THE CKB': 'THE CKB 시스템에 오신 것을 환영합니다.',
  会员等级: '회원 등급',
  切换账号: '계정',
  我的订单: '주문 목록',
  账号设置: '계정 설정',
  我的收藏: '즐겨찾기',
  登录账号管理: '회원정보관리',
  我收藏的商品和店铺: '즐겨찾기',
  我买过的商品和店铺: '구매완료상품/상점',
  我看过的商品和店铺: '최근 본 상품/상점',
  关联商品: '연결 만들기',
  退出登录: '로그아웃',
  当前账号已退出: '로그아웃했습니다.',
  修改邮箱: '이메일 주소 변경',
  新邮箱地址: '새 메일 주소',
  注销子账号: '자녀 계정 삭제',
  用户信息更新成功: '갱신 완료',
  邮箱修改成功: '메일주소를 변경했습니다.',
  子帐户创建完成: '자녀계정생성완료',
  快速创建: '점포추가',
  店铺追加: '점포추가',
  切换B2B囤货业务: 'B2B(유재고) 시스템으로',
  切换D2C代发业务: 'D2C(무재고) 시스템으로',
  店铺采购管理: '옵션 설정',
  我的地址: '수취인 정보',
  店铺平台: '사이트',
  登录信息: '로그인 정보',
  修改密码: '비밀번호 변경',
  采购配置: '매입 설정',
  附加项配置: '기본 옵션 설정',
  国际物流配置: '국제 배송 설정',
  您能接受的采购价格上涨: '상품 상한가 설정',
  次品付费重购: '불량품 대처 설정',
  接受次品重拍: '교환',
  '指定“换货”的场合下，每件商品可以免费交换X次。': '『상품교환』을 지정하면, 각 상품당 X회까지 무료로 교환 대응 가능합니다.',
  'X次以上每次都会产生现有商品购买手续费 (最大换货次数为3次) 。': 'X회 이상은 매번 기존품 매입 수수료가 발생합니다(최대 교환 횟수는 3회).',
  '自动换货次数达到上限 (3次) 时的对应方式可以通过“异常订单设定”来设定。': '자동 교환 횟수가 상한(3회)에 달할 경우의 대응 방식은 「이상 주문 설정」에 의해 설정 가능합니다. ',
  '如果您指定“退货退款”，一旦出现质量问题，我们会自动向您的店铺退款，并自动取消您的订单。': '<반품환불> 지정 시 불량품 발생 즉시 매장으로 반품 및 상품대금을 자동 환불해드리며 주문 상품이 자동 취소됩니다.',
  'D2C会员推荐“换货”。': 'D2C회원님은 교환을 권장합니다',
  退货退款: '반품환불',
  '如果您指定“退货退款”，一旦出现质量问题，您可以自动向商店退还退货和货款。': '반품환불 지정 시 불량품 발생 즉시 매장으로 반품 및 상품대금을 자동 환불 가능합니다.',
  '未指定的情况下，出现次品时，每次的都会向您确认处理方式。': '미지정의 경우는, 불량품이 발생하는 대로, 매번 대응 방법을 확인합니다.',
  '由于在收到指示之前商品会处于持续待机状态，会导致配送延迟，因此建议事先指定处理方式。': '대응지시가 있을 때까지 상품은 대기상태가 지속되고 배송지연으로 이어지므로 사전 대응지정을 권장합니다',
  '从购物车下单时，如果没有按类别设置默认选项，则使用适用于所有商品的默认选项': '카트에서 발주할 경우 카테고리별 디폴트 옵션 설정이 없으면 전 상품에 적용된 디폴트 옵션을 이용합니다',
  '从购物车下单时，如果已为每个类别设置默认选项，则可以自动设置该类别的订购商品选项。': '카트에서 발주할 경우 카테고리별 디폴트 옵션 설정이 완료되면 해당 카테고리의 주문 상품 옵션은 자동 설정 가능합니다.',
  水洗标信息配置: '워싱라벨 정보 설정',
  配置品牌专属水洗标: '워싱라벨 기본 설정',
  打开全部: '편집',
  去配置: '설정하러 가기`',
  使用类目: '사용 카테고리',
  类目失效: '이용 불가 카테고리',
  搜索地址: '주소 검색',
  选择物流公司: '운송회사',
  请选择物流公司: '운송회사',
  国际面单主设定: '의뢰주 설정',
  国际面单依赖主设定: '의뢰주 설정',
  联系方式: '연락 방법',
  发货附加项: '배송 옵션',
  发货附加项2: '배송 옵션',
  添加新地址: '새주소 추가',
  会社编号: '사업자 번호',
  日文收货地址: '일본어의 경우',
  英文收货地址: '영어의 경우',
  修改地址: '주소 변경',
  一键自动配置: '직항편 권장',
  一键配置: '직항편 권장',
  我的类目: '카테고리',
  选择您要配置的类目: '카테고리 선택 - 검색',
  选择商品附加服务: '옵션',
  选择发货附加服务: '발송용 옵션 선택',
  选择我的物料: '자재 선택',
  附加项: '옵션',
  附加项详情: '옵션',
  辅料sku: '자재 SKU',
  辅料名: '자재명',
  预计在库数: '유효 재고 수',
  去补货: '재고 보충',
  编辑国际物流附加项: '발송용옵션설정',
  我的频道: 'MY 채널',
  市场购: '현장구매',
  透明购: '추천사이트',
  D2C无仓库代发: 'D2C(무재고)',
  B2B仓库囤货: 'B2B(유재고)',
  采购平台: '매입 사이트',
  类目: '카테고리',
  中国语入力: '중국어 입력',
  日本语入力: '일본어 입력',
  详细检索: '고집 조건',
  去登录: '로그인',
  TaoBao: '타오바오',
  Tmall: 'Tmall',
  搜款网: '수선화',
  网商园: '➆상사',
  全部类目: '모든 카테고리',
  搜索范围: '구입처',
  搜索关键词: '키워드',
  重置条件: '클리어',
  搜索历史: '검색 이력',
  热门推荐词: '인기 키워드',
  采购渠道: '매입 루트',
  采购市场: '구입처',
  关联我的商品: '연결 만들기',
  商品详情: '상품 상세',
  商品来源: '구입처',
  加入收藏夹: '즐겨찾기에 추가',
  取消收藏: '즐겨찾기 상품에서 삭제',
  商品金额: '상품 대금',
  已选清单: '선택한 상품',
  手续费总额: '수수료',
  国际运费: '국제 배송료',
  国际运费退款: '국제 배송료 환불',
  附加项费用: '옵션 비용',
  单价预估成本: '구입 비용(개산)',
  请选择附加项: '옵션 연결',
  请选择附加项2: '상품 옵션을 선택해 주세요',
  单品预估成本价: '구입 비용(개산)',
  相似商品: '유사 상품',
  相似店铺: '유사 점포',
  加入购物车: '장바구니에 추가',
  传输到我的店铺: '자사 사이트 일괄 등록',
  下载商品图: '상품 이미지 다운로드',
  关联到我的店铺商品: '연결 만들기',
  X件可售: '재고수 X건',
  商品添加至购物车: '카트추가완료',
  该商品无法下载商品图: '이 상품은 상품도를 다운로드 할 수 없습니다.',
  商品图下载成功: '다운로드 완료',
  '部分图片读取失败，请按需手动下载。': '일부 이미지를 읽을 수 없습니다.필요에 따라 수동으로 다운로드하십시오.',
  '正在开启自动下载。': '자동 다운로드가 활성화되어 있습니다.',
  购买数量: '구입수',
  创建子账号: '부계정 생성',
  创建店铺: '점포추가',
  开店平台: '분류',
  平台名: '사이트',
  店铺品牌名: '점포명',
  店铺URL地址: '사이트 주소',
  店铺URL: '사이트 주소',
  店铺密钥: '가게 암호',
  创建并授权店铺数据: '가게 데이터 생성 및 권한 부여',
  请输入店铺所在的平台名称: '운영중인 사이트명을 입력하세요',
  请输入店铺或品牌名: '점포명 입력',
  请输入店铺访问链接: '운영중인 사이트 주소를 입력해 주세요',
  如需授权店铺API请阅读并同意: 'API 이용약관에 동의합니다',
  隐私权限: '개인 정보 보호 정책',
  店铺地址不正确: '가게 URL이 틀렸습니다',
  创建店铺成功: '가게작성완료',
  修改店铺成功: '가게변경완료',
  店铺授权成功: 'API 연계 완료',
  修改店铺信息: '가게 정보 변경',
  授权状态: '연결 상태',
  保存店铺: '보존',
  未授权: '미연결',
  已授权: 'API 연결 완료',
  应用密钥: 'API 연결용 secret',
  应用ID: 'API연결용ID',
  站外搜索: '중국 사이트 검색',
  中国档口七日爆款: '인기 상품(7일간)',
  推荐档口: '추천 점포',
  进入店铺: '더 보기',
  我收藏的店铺: '상점',
  我看过的店铺: '최근본 매장',
  我买过的店铺: '구매했던 매장',
  '担当推荐店铺（含档口）': '담당 추천 점포(시장점포 포함)',
  '推荐店铺（含档口）': '추천 점포(시장점포 포함)',
  我看过的商品: '최근본 상품',
  我买过的商品: '구매했던 상품',
  我收藏的商品: '상품',
  担当推荐商品: '담당 추천 상품',
  猜你喜欢的商品: '추천 상품',
  平台频道: 'EASYBUY 채널',
  去购买: '상품을 구입하러 가기',
  去选品: '상세하게',
  去看看: '상세하게',
  主题市场: '테마 마켓',
  猜你喜欢的店铺: '추천 가게',
  品类市场: '카테고리 시장',
  市场: '시장',
  青蛙频道: 'THE CKB 채널',
  更多最新文章: '더 보기',
  采购相关: '구입에 대하여',
  物流相关: '물류에 대해서',
  优惠相关: '캠페인에 대해서',
  OME相关: 'OEM에 대하여',
  他社合作相关: '타사 업무 제휴에 대하여',
  热门文章: '인기 기사',
  档案: '카테고리',
  上一篇: '앞으로',
  下一篇: '다음에',
  采购到库存: '재고 보유',
  C端直发: '최종 사용자 직송',
  选择店铺: '점포 선택',
  请选择店铺: '매장을 선택해주세요',
  检索平台: '구입처',
  价格浮动百分比: '구매단가상한율',
  '原有的商品缺货时，我们会帮你查找新的采购链接，所以请告诉我您能接受的采购价格区间变动': '지정 숍에서 매입할 수 없는 경우, 설정된 단가 상한을 기준으로 다른 숍을 검색합니다. 초회 설정치를, 매입시의 디폴트치로 설정합니다. 변경은, 정보설정 페이지에서 편집해 주세요.',
  创建组合商品: '세트 상품 작성',
  确认并支付: '지불하러 가기',
  收件人: '수취인',
  都道府县: '시/도',
  市区町村: '시/군/구',
  市: '시/구/군',
  区町村: '구정촌',
  详细地址: '상세주소',
  邮编: '우편번호',
  自定义订单编号: '고객주문번호',
  购买店铺: '점포명',
  购买类型: '주문 종류',
  收件人不能为空: '※ 필수 항목입니다',
  联系电话不能为空: '※ 필수 항목입니다',
  都道府县不能为空: '※ 필수 항목입니다',
  详细地址不能为空: '※ 필수 항목입니다',
  邮编不能为空: '※ 필수 항목입니다',
  商品预估价格: '상품대금(개산)',
  商品预估附加项价格: '옵션비(개산)',
  订单预估总价: '합계액(개산)',
  当前余额: '잔액',
  提交订单: '제출',
  '提示：此金额为预估报价，您下单后，该部分金额将会被冻结。等到该订单采购处理全部完成后，我们会自动解冻这部分金额，并按照实际产生的金额进行扣费。实际扣费详情您可以后续在资金明细页面或订单详情页面查看。': '안내: 이 금액은 견적 가격이며, 주문하시면 해당 금액은 동결됩니다.주문서 구매처리가 모두 완료되면 이 부분은 자동으로 해동되며 실제 발생한 금액에 따라 차감됩니다.실제 공제내역은 추후 자금내역페이지 또는 주문내역페이지에서 확인하실 수 있습니다.',
  组合商品名称不能为空: '※ 필수 항목입니다',
  组合商品名称: '세트조 상품명',
  组合商品规格: '세트조 규격',
  商品图片: '상품 이미지',
  商品规格: '상품 설명',
  商品规格2: '상품 설명',
  单组数量: '단품 수량',
  保存并加入购物车: '저장하여 장바구니에 추가',
  组合商品附加项: '세트조 옵션',
  选择附加项: '옵션 편집',
  组合详情: '세트 구성 내역',
  组合图片: '메인 이미지',
  组合: '세트 세트 상품',
  全部: '전부',
  返回: '돌아가기',
  其他: '기타',
  平台: '사이트',
  变更: '변경',
  全选: '모두 선택',
  商品名称: '상품명',
  规格: '규격',
  商品属性: '상품의 속성',
  在库数量: '재고수',
  '可用库存/采购数量': '양품수/구매수',
  '使用库存/采购数量': '재고이용수/구매수',
  下单数量: '주문 수량',
  起订量: '로트 수',
  起订量件: '로트수(건)',
  单价: '단가',
  单价2: '단가',
  单价元: '단가(위안)',
  总价元: '합계액(위안)',
  版费元: '판자(위안)',
  小计: '소계',
  商品附加项: '상품 부가항목',
  商品附加项费用: '상품 부가항목비용',
  操作: '관리',
  编辑: '편집',
  修改: '편집',
  合计: '점수',
  合计2: '합계',
  支付: '받침',
  账号: '어카운트',
  工作台: '마이페이지',
  OEM: 'OEM',
  意见反馈: '의견',
  提示: '힌트',
  提示2: '확인 부탁드립니다.',
  提示3: '주의하세요.',
  创建: '작성',
  确定: '확인',
  确认: '확인',
  保存: '저장',
  同意: '동의하다',
  取消: '취소',
  撤回: '취소',
  删除: '삭제',
  元: '元',
  件: '건',
  价格区间: '가격대',
  风格: '스타일',
  颜色: '옷감의 컬러',
  颜色2: '옷감의 컬러',
  尺码: '크기',
  其他条件: '다른 조건',
  综合: '추천',
  综合排序: '추천',
  价格: '가격순',
  成交额: '판매량순',
  信用: '리뷰평가순서',
  销量: '인기 순서',
  数量: '수량',
  排序: '순서',
  自定义: '가격대',
  去结算: '주문하러 가기',
  查看更多: '더 보기',
  默认: '디폴트',
  '上传中...': '상품데이터동기중...',
  离开: '취소',
  注意2: '주의해 주십시오',
  无: '없음',
  暂无: '없음',
  选填: '선택지',
  批量删除: '일괄 삭제',
  公司名: '회사명',
  收货地址: '배송지',
  清关地址: '통관 주소',
  设为默认: '기본 주소로 설정',
  姓名En: '이름(영어)',
  都道府县En: '도도부현(영어)',
  市区町村En: '시구읍면(영어)',
  详细地址En: '상세주소(영어)',
  添加商品: '상품추가',
  图片: '사진',
  商品类型: '상품 종류',
  至少选一个: '적어도 하나를 선택해 주세요.',
  重置: '새로 고침',
  '商品名称/SKU': '상품명/SKU',
  加入组合: '추가',
  普通商品: '보통상품',
  OEM商品: 'OEM상품',
  组合商品: '세트상품',
  购物车为空: '카트에 상품은 없습니다',
  上传图片: '이미지 업로드하기',
  无法上传商品: '상품을 업로드할 수 없습니다.',
  '仅支持已授权店铺上传商品，该店铺未授权': '이 매장은 미연계로 상품을 업로드할 수 없습니다.',
  '请输入购买单价上限。在指定店铺无法购买的情况下，会以设定的单价上限为基准，来搜索其他店铺。': '구매 단가 상한을 입력하십시오.지정 숍에서 매입할 수 없는 경우, 설정된 단가 상한을 기준으로 다른 숍을 검색합니다.',
  '指定“换货”的话，每件商品可以免费换货X次。X次以上按Y元/次收取换货手续费 (最大换货次数为Z次)': '『상품교환』을 지정하면, 각 상품당 X회까지 무료로 교환 대응 가능합니다.X회 이상은 Y원/회의 교환수수료가 발생합니다(최대 교환횟수는 Z회)',
  '如果您指定“退货退款”，一旦发生质量问题，会自动向您的店铺退货货款。': '반품환불 지정 시 불량품 발생 즉시 매장으로 반품 및 상품대금을 자동 환불 가능합니다',
  '未指定的情况下，出现次品时，每次都会向您确认处理方式。': '미지정의 경우는 불량품이 발생하는 대로 매번 대응 방법을 확인합니다.',
  创建寻源单: '견적 의뢰',
  寻源单列表: '견적의뢰관리',
  复购申请列表: '견적 재구매',
  待接单: '접수 대기',
  待报价: '견적 대기',
  待商榷: '상담 대기',
  寻源失败: '환불 완료',
  发布时间: '의뢰일',
  起始日: '개시일',
  结束日: '종료일',
  寻源单详情: '의뢰서',
  订单状态: '주문 상황',
  下一步: '다음',
  拒绝: '거부하다',
  拒绝2: '지불 거부',
  确定下样品单: '샘플 발주하시겠습니까?',
  确定下大货单: '양산을 합니까?',
  评价: '평가',
  有: '있다',
  没有: '없음',
  取消寻源单: '취소',
  确认下单: '발주',
  确认重新编辑: '재편집하시겠습니까?',
  确认申请退款: '환불하시겠습니까?',
  确认申请复购: '견적 유효기간이 지났습니다, 최신 견적을 의뢰하시겠습니까?',
  '发布此寻源单需要收取XXX元服务费，请问是否确定发布': 'XXX위안 대응 요금이 부과되어 견적 의뢰를 제출합니까?',
  '发布此寻源单无需收费，请问是否确定发布': '무료 서비스, 견적 의뢰를 제출합니까?',
  示例: '예',
  以上没有我需要的: '기타',
  '您想要一个什么类型的商品？': '상품류를 선택해 주세요',
  '请问你要做什么辅料？': '원하시는 자재를 선택해주세요',
  请填写您需要的辅料: '자재를 선택해주세요',
  文件上传: '파일 업로드하기',
  '请问你有自己的方案吗？': '자신의 계획을 준비하고 있습니까?',
  '我有自己的想法，请THE CKB根据我的要求帮我生产': '자신의 아이디어가 있고 그에 부응하여 생산하세요.',
  '我没有自己的想法，希望THE CKB帮我推荐方案': '자신의 아이디어가 없는 직항편에서 계획서를 제안하세요.',
  '我有自己的想法，但是我也想看一下THE CKB的推荐方案': '제 아이디어가 있습니다만, 직항편에서 추천하는 방안도 참고 희망합니다.',
  请详细表述并上传您需要定制的辅料设计图或参考图片: '원하시는 내용 상세정보를 입력해주세요.',
  请详细描述您需要定制的款式信息: '원하시는 디자인 상세내용을 말씀해주세요.',
  请详细描述您需要定制的材质信息: '원하시는 원단 상세내용을 말씀해주세요',
  请详细描述您需要定制的尺寸信息: '원하시는 사이즈를 말씀해 주세요',
  请查看我们的款式推荐方案: '직항편 디자인 추천 방안을 봐주세요',
  请查看我们的材质推荐方案: '직항편 원단 추천 방안을 봐주세요',
  请查看我们的尺寸推荐方案: '직항편 사이즈 추천 방안을 봐주세요',
  请查看我们的颜色推荐方案: '직항편 색상 추천 방안을 봐주세요',
  请选择Logo印刷方案: '로고 인쇄제안을 선택해주세요',
  价格和起订量: '가격과 최저 주문수',
  总价: '총액',
  版费: '금형 비용',
  选择色卡: '컬러 차트 선택',
  搜索色号: '컬러 차트 번호 검색',
  色号或色卡名称: '컬러 채팅 번호',
  请至少选择一种色卡: '1점 이상의 컬러차트를 선택해주세요',
  已选色卡: '컬러 차트 선택 완료',
  '请问你对本次杂货OEM的初步需求是怎样的？': '이번 잡화 OEM 관련해서 요청은 어떻게 하시겠어요?',
  '根据图片或样品，帮我生产出一模一样的产品。（包含加Logo）': '이미지 및 샘플에 따라 상품원단 + 디자인이 일치하는 상품을 생산하십시오.',
  '在既成品的基础上，我有一些改良的需求 。（包括颜色、材质、 功能、尺寸、设计等的改良）': '기성품에서 변경하여 상품을 생산하십시오.(색상, 소재, 사이즈, 디자인 등의 개선)',
  '请联系本公司的对应担当。': '저희 담당자에게 연락주세요.',
  '在本公司发起OEM生产需要提供样式书，详情请咨询您的对应担当。': '당사에서 OEM 생산에 필요한 사양서를 제공해야 하기 때문에 자세한 내용을 담당자가 안내해 드리겠습니다.',
  '请问您是否有样品可邮寄？': '귀사에서 샘플을 우송할 수 있습니까?',
  '请问您需要附加Logo吗？': '로고 프린트 할게요?',
  请完善Logo信息: '로고 디자인을 제공해주세요',
  '请对logo颜色、尺寸、工艺、位置做说明': '로고 색상, 사이즈, 프린트 위치를 설명해주세요.',
  '请问您对本次寻源的工厂或产品资质有特殊要求吗？': '견적 의뢰 공장, 허가증 관련 요청사항이 있으신가요?',
  资质要求: '허가증에 관한 요망',
  请上传您的参考链接或图片: '참고 URL 또는 참고 이미지 업로드하기',
  '请问您是否有式样书？': '사양서가 있나요?',
  '我需要定制全新的产品，目前市场上没有既成品可参考。': '오리지널 상품을 생산하고 싶습니다.기성품이 없습니다.',
  请上传式样书: '사양서 업로드하기',
  '式样书必须包含产品的色卡、尺寸、特殊工艺、面料信息等': '상품의 사양서만 있음(샘플이나 참고 이미지, 상품 URL 없음).사양서에 따른 상품 생산을 실시하고 싶다.',
  '使用THE CKB帮助您制作式样书': '직항편에 사양서 작성을 의뢰하다',
  '由于信息不足，THE CKB暂时无法为您提供寻源服务': '정보 미비로 당분간 견적 의뢰 서비스를 제공하기 어렵습니다.',
  请详细说明您需要改动的地方: '변경하고 싶은 부분을 설명해주세요.',
  '如果需要改动的点已经在式样书中完全展现，可以略过，否则可做补充说明': '변경하고자 하는 부분을 이미 사양서에 표기하신 경우에는 입력 없이 문제 없습니다.',
  补充说明: '보충 설명',
  上传文件: '파일 업로드하기',
  请完善信息: '샘플을 아래 주소로 보내주세요.',
  请问您是否可以提供样衣邮寄: '귀사에서 샘플을 우송할 수 있습니까?',
  我有样衣: '샘플이 있습니다.',
  我没有样衣: '샘플이 없습니다.',
  'THE CKB地址': '직항편 주소',
  请填写物流单号: '추적번호를 기입해 주세요.',
  请选择您想要的OEM商品生产模式: '요청하신 OEM 상품 생산 패턴을 선택하십시오.',
  '我想生产只与产品图像或产品URL设计匹配的产品。': '상품 이미지 또는 상품 URL 디자인만 일치하는 상품을 생산하고 싶다.',
  '以对应速度为最优先，无需指定商品面料。': '대응 속도를 최우선으로 하며, 상품 원단 지정 없음.',
  '与其他方案相比，这是速度最快的应对方案。': '타 플랜 대비 속도 최우선으로 대응하는 플랜입니다.',
  '注重商品设计的一致性，样品确认不是实物确认，而是图片确认。': '상품 디자인이 일치하는 것을 중시하여 샘플 확인도 실물이 아닌 이미지로 확인합니다.',
  '商品仅保证款式一致，不保证面料和质感，敬请留意。': '상품은 디자인의 일치만을 보장하며 원단이나 질감은 보증되지 않으니 유의하시기 바랍니다.',
  '※如果有尺寸、布料指定，请选择B或C方案。': '※ 사이즈, 원단 지정이 있는 경우는, B 또는 C플랜을 선택해 주세요.',
  '有商品样品，希望生产面料、尺寸等与样品相同的产品。': '상품 샘플이 있고 원단, 사이즈 등 샘플과 동일한 상품을 생산하고 싶다.',
  '有商品样品，希望更设计、面料、尺寸等进行生产。': '상품 샘플이 있고 디자인, 원단, 사이즈 등을 변경하여 생산하고 싶다.',
  '没有商品样品，只有商品图片或商品URL。希望变更设计、面料、尺寸等。': '상품 샘플이 없고, 상품 이미지 또는 상품 URL만 있음.디자인, 원단, 사이즈 등 변경 요망 있음.',
  '请提供样品或说明书以供参考。如果没有规格说明书，也可以委托本公司制作规格说明书。': '참고가 되는 샘플품 또는 사양서를 제출해 주십시오.사양서가 없는 경우에는 당사에 사양서 작성 의뢰도 가능합니다.',
  请填写你想定制产品的基本信息: '예정된 본 발주에 관한 정보를 입력해 주세요.',
  请填写产品名称: '상품명을 입력해주세요',
  '由于信息不足，无法进行报价单委托': '정보 부족으로 견적서 의뢰할 수 없습니다.',
  '请填写商品的尺寸分类。如果有多个尺寸，请按行输入尺寸。例M, L, XL, 30 cm*40 cm*20 cm等。': '상품의 사이즈 분류를 기재해 주세요.사이즈가 여러개인 경우 행 추가하여 사이즈를 입력해 주세요. 예 M,L,XL,30cm*40cm*20cm 등',
  可以邮寄面料样布: '원단 샘플이 발송 가능합니다.',
  面料信息说明: '원단 정보 설명',
  请输入面料信息和颜色: '원단 정보와 색상을 입력하다',
  参考样品: '샘플에 참고하다',
  '请输入所需的面料信息(材质、颜色)': '원하시는 원단정보(소재,컬러)를 입력해주세요',
  请描述一下您对面料的需求: '원단을 지정해 주십시오',
  '请大致描述一下希望面料的外观或功能上的需求，如:弹性好，柔软等': '원단 설명을 해주세요, 예를 들어: 탄력성이 뛰어난 부드러운 원단',
  上传面料图片: '옷감의 이미지를 가져오다',
  '请大致描述一下希望改动哪些方面,如：材质、设计、颜色、尺寸等': '변경하고 싶은 부분을 설명해주세요, 예를 들어: 원단, 컬러, 사이즈, 디자인 변경 등',
  '能提供商品的详细尺寸吗?': '상품에 대한 자세한 사이즈 가이드를 제출할 수 있습니까?',
  输入尺寸信息: '크기 정보 입력',
  '根据服装生产标准，尺寸相差 1-3cm 都属于正常现象，不作为不良品判断，请知悉': '의류 견적 생산은 사이즈에 1-3cm 오차가 있을 수 있습니다 불량으로 취급하지 않으니 양해 바랍니다',
  请参考链接尺寸: '상품페이지 치수 참고',
  请提供尺码的具体尺寸: '상품상세사이즈를입력해주세요',
  尺码模板: '템플릿 파일',
  模板下载: '템플릿 다운로드',
  模板下载2: '템플릿 다운로드',
  上传模板: '임포트하다',
  '请先下载对应模板，填写完成后上传。': '템플릿 파일을 다운로드하고 세부 정보를 입력한 후 가져오십시오.',
  请输入产品的下单需求: '주문정보를 입력해주세요',
  'THE CKB的报价与希望起订量和价格是否匹配，是我们判定是否为您寻源成功的判断依据。请您客观的填写。如果您的希望和市场行情差异过大，我们会之后先联系您，提出修改建议，再开始为您寻源报价。': '입력하신 희망 로또수와 희망가격에 따라 공장을 찾으나, 요청사항이 실제 시장시세와 차이가 있을 경우 실제 시세에 따라 견적을 내겠습니다.',
  寻源备注: '비고',
  '如果您对本次寻源还有其他特殊需求，请在以下输入您的需求': '견적 의뢰에 필요한 사항이 있으시면 언제든지 입력해 주십시오',
  已成功创建寻源单: '견적서 의뢰필',
  '尚未开始对应。请在管理界面确认内容后提交申请。': '아직 대응이 시작되지 않았습니다.관리화면에서 내용확인 후 의뢰제출 부탁드립니다.',
  '式样书(例)': '사양서(예)',
  棉100: '면 100%',
  可多选: '복수 선택 가능',
  尺码信息: '크기',
  是否需要加logo: '로고각인,프린트할경우로고자료제출',
  期望交期时间: '희망 납기',
  期望最低起订量: '희망 로트 수',
  关闭: '닫기',
  关闭2: '닫기',
  客户补充部分: '고객 요망',
  附加说明: '설명',
  您可以点击此处: '사양서를 의뢰하다',
  产品图片: '상품 이미지',
  产品规格: '상품 규격',
  备注: '비고',
  附加费选项: '상품 옵션',
  订单标题: '주문 제목',
  品牌: '브랜드명',
  总计数量: '합계 수량',
  '总计(折扣前RMB)': '합계(할인전)',
  '总计(折扣后RMB)': '합계(할인 후)',
  估计金额: '견적 금액',
  购物车数量不能小于X: '최소추가수량(X)을채우지않습니다.',
  普通订单: '기성품 주문',
  组合商品订单: '조합 상품',
  OEM订单: '견적 상품',
  报价已过期: '견적서 유효기간이 지났습니다.',
  复购申请编号: '견적 갱신 의뢰',
  申请状态: '신청 상태',
  请填写: '입력해 주세요',
  请上传: '업로드하시기 바랍니다',
  请至少选择一种色卡或上传图片: '적어도 하나의 컬러 차트를 선택해 주세요.색상 차트가 없는 경우 사진을 업로드 해주세요.',
  链接和图片必须填一个: '링크 혹은 사진을 입력해주세요.',
  请提供面料材质和色卡信息: '원단재질과 컬러차트 정보를 제공해주세요',
  请填写具体的面料材质信息: '원단 재질 정보를 제공해 주십시오',
  '我没有数值，请参考样衣尺寸。': '샘플 치수 참고',
  '以上为参考报价，具体报价需要以最终报价为准 ': '어디까지나 참고견적이므로 실제견적은 실제조건에 따릅니다.',
  该订单不支持修改属性: '해당상품의 규격을 수정할 수 없습니다.',
  请至少选择或上传一种色卡: '1점 이상의 컬러차트를 선택해주세요',
  请填写款式说明: '원하시는 디자인 상세내용을 말씀해주세요.',
  请填写材质详细说明: '원하시는 원단 상세내용을 말씀해주세요',
  请填写尺寸详细说明: '원하시는 사이즈를 말씀해 주세요',
  请上传Logo: '브랜드 logo를 업로드 해주세요.',
  请上传尺码表: '사이즈 업로드 해주세요.',
  请填写期望价格: '원하는 가격을 입력해주세요.',
  请填写期望最低起订量: '최소 로트 수를 입력하십시오.',
  请选择期望交期时间: '희망납기를입력하세요',
  重新创建寻源单: '견적 갱신 의뢰',
  查看寻源单列表: '작성 완료 견적 의뢰는 "미제출" 페이지에서 확인해 주십시오.',
  请输入您想要的详细信息: '예정된 본 발주에 관한 정보를 입력해 주세요.',
  'THE CKB的款式推荐方案': '직항편 디자인 추천 방안을 봐주세요',
  'THE CKB的材质推荐方案': '직항편 원단 추천 방안을 봐주세요',
  'THE CKB的尺寸推荐方案': '직항편 사이즈 추천 방안을 봐주세요',
  印刷方案: '로고인쇄방안을선택해주세요',
  请输入您的订单信息: '희망사항을 입력해주세요',
  规格及起订量: '가격과 최저 주문수',
  '棉100%': '면 100%',
  '上次寻源未完成，是否继续': '작성 완료되지 않은 견적 의뢰가 있어 계속 조작합니까?',
  重新寻源: '재견적 의뢰',
  店铺不存在: '이 점포를 찾을 수 없었습니다.',
  没有更多了: '이것은 전부입니다',
  暂无平台: '플랫폼은 아직 없습니다.',
  输入FAQs关键词: '키워드 입력',
  收藏商品: '마음에 드는 상품',
  收藏店铺: '즐겨찾기매장에 추가',
  多为我推荐此类型商品: '추천상품으로 설정',
  多为我推荐此类型店铺: '추천매장으로 설정',
  不再推荐此商品: '추천상품에서 제외',
  不再推荐此店铺: '추천매장에서 제외',
  商品收藏成功: '즐겨찾기 상품에 추가완료',
  店铺收藏成功: '즐겨찾기 점포에 추가완료',
  '感谢反馈，我们将为你推荐更加准确的商品': '피드백 주셔서 감사합니다.앞으로 더 많이 관련 상품 추천드립니다.',
  '感谢反馈，我们将为你推荐更加准确的店铺': '피드백 주셔서 감사합니다.앞으로 더 많이 관련 점포 추천드립니다.',
  注销账号: '계정 삭제',
  提现: '서랍',
  无法注销帐户: '계정 삭제 불가',
  '您的账号中存在以下未处理完结事件，不能注销。': '처리중인 항목이 있어 계정 삭제는 불가능합니다.',
  账户余额X元: '잔고X위안',
  提现申请: '인출 신청',
  X笔采购订单: '주문수: X',
  X条充值任务未完成: 'X입금(확인중)',
  批量编辑附加项: '일괄 옵션 편집',
  工厂直营: '직항편 엄선',
  组合商品不能再组合: '세트조 대응 완료 중복된 세트조는 작성 불가',
  '订单已生成，请随时关注订单动态': '주문완료.주문상황에서진행상황을확인해주십시오.　',
  '5s后跳转订单详情': '5초 후에 주문 상황 화면으로 전환합니다.',
  '15s后跳转订单详情': '15초 후에 주문 상황 화면으로 전환합니다.',
  '通过插件，您可以直接在中国购物网站上，将商品添加到THECKB系统的购物车中购买。': '툴 이용으로 중국 주요 사이트에서 직접 THE 직항편 시스템으로 상품 구매 가능',
  '购买商品非常方便!': '상품 구매가 매우 편리해집니다!',
  立即安装KAERU插件: '즉시 [보조 툴(KAERU 툴)]을 추가하다',
  包邮: '중국내 무료배송',
  赠送退货运费险: '중국 국내반품 배송비 보험제공',
  新品: '최신 상품',
  正品保障: '정품',
  公益宝贝: '기부 포함 상품',
  '7+天内退货': '7일이내 사유에 관계없이 반품가능',
  折扣: 'sale',
  搭配满减: '조건을 충족하면 할인',
  满就减: '조건을 충족하면 할인',
  货到付款: '대금 상환',
  '48小时内发货': '48시간 이내 출하',
  实力商家: '우수 점포',
  超级工厂: '우수 공장',
  加工定制: 'OEM 생산',
  人气: '팔리는 순서',
  访问令牌: '액세스 토큰',
  请填写正确的访问令牌: '올바른 액세스 코드를 입력하십시오.',
  组合商品规格不能为空: '필수항목.세트조규격을입력하세요.',
  选择一张图片作为组合商品主图: '1개의 이미지를 선택해 주세요.',
  查看组合列表: '세트조 목록 확인',
  当前购物车共X种商品: '점장바구니내 상품수: X 개',
  X件商品已添加至购物车: 'X개 추가완료',
  '库存过低不能下单，请调整发货量或及时补充库存': '재고가 너무 적어서 주문할 수 없어요.발송 수를 조정하거나 재고를 보충해 주세요.',
  回到首页: '톱 페이지',
  同步商品: '상품 동기화',
  fnsku: 'FNSKU',
  asin: 'ASIN',
  '请输入Amazon sku': 'Amazonsku를 입력해주세요',
  '请搜索需要绑定的Amazon sku': 'Amazonsku를 입력해주세요',
  附加项未配置箱唛: ' 박스 라벨 옵션을 추가해주세요',
  附加项未配置贴标签: '상품 라벨 옵션을 추가해주세요',
  '海外仓sku(fnsku)': '일본창고SKU(FNSKU)',
  补货数量: '발송수',
  未提出: '미제출',
  已提出: '제출 완료',
  已作废: '폐기 대응 완료',
  'FNSKU/ASIN': 'FNSKU/ASIN',
  '商品名称/Amazon sku': '상품명/Amazon SKU',
  '品名/平台sku': '상품명/직행편SKU',
  计划发货量: '배송 건수',
  是否确认提出: '제출해도 될까요?',
  是否确认取消: '취소해도 될까요?',
  作废成功: '취소했습니다.',
  提交成功: '제출했습니다',
  提交成功2: '충전신청 했습니다 <br/> <div style="margin-top: 2px;"> 충전금액은 심사완료 후 반영됩니다 잠시만 기다려주세요 </div>',
  国际发货单标题: '제목',
  发货状态: '상태',
  发货类型: '배송 종류',
  批量加购: '일괄 구매',
  '点击完结 单品可以转普通商品库存': '점击완结 단품 상품으로서의 재고 보관으로 변경 가능',
  '存在待组商品 请尽快加购组合。': '존재 대련 상품 간진 쾌가 간합.',
  物流信息: '배송지 정보',
  国际单号回传后不可修改: '재편집 불가 출하 완료',
  收件人邮箱: '이메일 주소',
  选择订单时间: '주문일시 선택',
  订单付款日期区间: '지불 일시',
  未下单: '미발주',
  已下单: '발주 완료',
  店铺订单号: '고객주문번호',
  订单时间: '주문 일시',
  采购状态: '상태',
  订单金额: '합계액',
  收货信息: '목적지 주소',
  商品图: '화상',
  '商品名/sku': '상품명/SKU',
  采购链接sku: '직항편 SKU',
  同步订单数据: '주문수납입',
  一键下单: '발주',
  '编辑物流/地址': '주소를 편집',
  是否删除: '삭제해도 될까요?',
  发货附加项编辑成功: '발송용옵션 편집완료',
  编辑成功: '편집완료',
  留在此页: 'OK',
  开始时间: '시작일',
  质检中: '검품',
  待发货: '발송 대기',
  '当前申请取消的商品，存在多个商品状态，确认取消后：': '취소처리를 실행하면',
  '“X”状态商品，申请取消成功后，系统将自动取消商品的采购与发货，冻结金额在订单结算后返回至可用余额内。': '“X”상태의 상품은 상품의 매수 및 발송을 정지하고 예치금을 전액 환불해드립니다',
  '“X”状态，申请取消成功后，系统将自动取消商品的发货行为，并将商品保留库存。': '“X” 상태의 상품은 상품의 발송을 정지하고 재고 보관합니다',
  '请确认是否申请取消？': '취소를 실행하시겠습니까?',
  '“X”状态商品，系统将自动取消商品的采购，冻结金额在订单结算后返回至可用余额内；': '“X”상태의 상품 취소는 상품의 매수 및 발송을 정지하고 예치금을 전액 환불해 드립니다',
  '“X”状态商品，不可申请取消（系统将自动忽略）': '“X”상태의 상품은 취소할 수 없습니다.',
  '当前申请取消的商品，商品状态均为“X”状态,': '“X” 상태의 상품 취소',
  '申请取消成功后，系统将自动取消商品的采购与发货，冻结金额在订单结算后返回至可用余额内。': '취소처리를 실행하면 상품의 매수와 발송을 정지하고 예치금을 전액 환불해 드립니다.',
  '当前申请取消的商品，商品状态均为“X”状态，不可申请取消！': '“X”상태의 상품은 취소할 수 없습니다.',
  '当前申请取消的商品，商品状态均为“X”状态，申请取消成功后，系统将自动取消商品的采购，冻结金额在订单结算后返回至可用余额内': '“X”상태의 상품 취소는 상품의 매수를 정지하고 예치금을 전액 환불해 드립니다.',
  再次下单: '재구매',
  组合信息: '세트조 정보',
  结算中心查看明细: '계좌 목록에서 명세 확인',
  费用名称: '종류',
  '结算总价（元）': '합계액(원래)',
  问题联络: '문제 연락',
  冻结: '예치금',
  解冻: '예치금 환불',
  结算: '주문 절차로',
  重拍冻结: '예치금(교환)',
  销售单价: '단가',
  结算数量: '수량',
  结算总价: '청산 총 가격',
  点击上传凭证: '클릭하여 업로드하기',
  みずほ銀行: '하나은행',
  商品代金结算: '상품 대금',
  国际物流费用: '국제 배송료',
  国际物流费用退回: '국제 배송료 환불',
  国际运费重量差补扣: '국제배송비 차액만큼 환불',
  国际运费附加项补扣: '국제 배송비 추가 청구 총액',
  销毁费补扣: '폐기 수수료',
  偏远地区费补扣: '원거리 수송 수수료',
  仓储费补扣: '물류창고보관비',
  超长超重费补扣: '오버사이즈 요금',
  关税补扣: '관세',
  改派费补扣: '배달지 변경 수수료',
  特殊处理费补扣: '특별 대응 비용',
  扣件费补扣: '배송 정지 수수료',
  退件费补扣: '반송 수수료',
  冻结总价: '매수 가지급 금액 총액',
  解冻总价: '합계액',
  重拍冻结商品代金: '매입 가지급 금액 환불',
  冻结商品代金: '매입 가지급 금액',
  解冻商品代金: '예치금 환불',
  冻结总数量: '구입 총수',
  解冻总数量: '총수',
  手续费: '대행 수수료',
  次品重买总次数: '불량품 교환 횟수',
  纸箱总数量: '상자 수',
  装箱总数量: '발송수',
  气泡膜总数量: '뽁이 총수',
  托盘总数量: '팔레트 총수',
  箱子总数量: '상자 수',
  结算总数量: '총수',
  我的默认附加项: '기본 옵션 설정',
  我的类目附加项: '카테고리별 옵션 설정',
  商品总金额: '합계 금액',
  发货单: '패킹리스트',
  箱: '상자',
  钱包: '계좌 일람',
  收藏: '즐겨찾기',
  记录: '기록',
  足迹: '최근본 상품',
  浏览记录: '열람 이력',
  购买记录: '구입 이력',
  没有可优先发货的商品: '분납 발송 가능한 상품은 없습니다.',
  是否确认优先发货: '【확인하세요】이 상품을 분납 발송하시겠습니까?',
  优先发货成功: '분납 발송 설정했습니다',
  没有可申请取消的商品: '취소가능한 상품이 없습니다.',
  是否确认删除: '【확인해주세요】삭제해도 될까요?',
  搜索商品: '상품 검색',
  '您将要删除X条商品数据，删除后将无法恢复': '【확인하시기 바랍니다】선택한 ●건 상품 데이터를 삭제하면, 원래대로 되돌릴 수 없습니다.상품을 삭제하시겠습니까?',
  请输入商品名: '상품명을 입력해주세요',
  请输入商品名3: '상품명을 입력해주세요',
  选择收货地址: '목적지주소 선택',
  国际发货标题: '납품 타이틀',
  是否确定加购大货: '【확인하세요】이 상품을 양산하시겠습니까?',
  加购大货: '양산하다',
  确定加购样品: '샘플 발주',
  加购样品: '샘플 발주',
  库存还有X件商品或辅料: 'X건의 상품(자재)의 재고가 있습니다.',
  去处理: '상세',
  '账号注销后我们将不再保存您的任何账号信息，是否注销？': '[확인해주세요] 계정을 삭제하면 직항편 시스템의 모든 정보가 삭제되어 원래대로 되돌릴 수 없습니다. 계정을 삭제하시겠습니까?',
  直行台: '회원 센터',
  账户概览: '회원 센터',
  同步订单: '주문관리(API발주)',
  订单详情: '주문 상세',
  购买过: '구매했던 상품/매장',
  消息: '알림',
  商品管理: '상품 관리',
  关联商品库: '연결 관리',
  我的组合商品: '세트조',
  国际发货: '국제 배송',
  国际发货列表: '국제 배송 목록',
  国际发货详情: '상세',
  补货计划: '납품 타이틀',
  资金管理: '예치금 관리',
  授权管理: 'API 연계',
  再购入: '재구매',
  下单: '발주',
  同步商品信息: '점포 상품을 도입하여',
  库存数: '양품',
  可售: '재고 있음',
  可用库存: '사용가능',
  已锁定: '잠김',
  待处理次品数: '반품불가 불량품',
  导出成功: '다운로드 했습니다.',
  'THE CKB发货单号': '직항편 발송 의뢰 번호',
  复购: '재구매',
  筛选条件: '선별조건',
  '客户商品sku/海外仓sku': '귀사SKU/일본창고SKU',
  '平台客户sku/商品名称': 'SKU/상품명',
  更新: '갱신',
  平台商品信息: '상품 정보',
  'AMAZON库存(可售)': 'Amazon(재고 있음)',
  'AMAZON库存(入库)': 'Amazon(입고대기)',
  'AMAZON库存(不可售)': 'Amazon(판매 불가)',
  预计总库存: '합계',
  绑定: '연계하기',
  绑定1: '연계하기',
  解绑: '해제하기',
  确认签收: '수취',
  '是否确认签收？': '이 상품을 받으시겠습니까?',
  '是否确认取消国际发货？ 仓库已在作业中的发货单无法取消。': '취소불가 해당 배송의뢰는 창고작업중입니다 자세한 사항은 담당자에게 연락바랍니다',
  '小计（元）': '합계(元)',
  实际发货数量: '실제 배송수',
  提出: '제출',
  已确认: '처리 중',
  尺寸: '크기',
  寻源单号: '견적 의뢰 번호',
  样品单: '샘플 발주',
  大货单: '양산',
  预计可发货数: '최대 발송수',
  查看订单详情: '주문상세확인',
  购买数量不可为空: '필수항목 구매수량',
  '购买数量不足。': '구입 수량 미비',
  购买数量不可低于起订量: '구매 수량이 최소 로트 수를 충족하지 못했습니다.',
  子商品总数不能少于2件: '1세트조상품에는 단품상품이 2건이상 필요합니다',
  批量编辑商品附加项: '상품 옵션 일괄 편집',
  需要填写收货地址: '배송지 주소를 입력해 주세요.',
  添加收货地址: '배송지 추가',
  payoneer充值记录: 'Payoneer 충전 이력',
  我知道了: '닫기',
  '存入金额（USD）': '무통장입금금액(USD',
  待初审: '초회 심사 대기',
  待终审: '최종 심사 대기',
  已通过: '심사 종료',
  上传成功: '업로드 완료',
  参考单价: '단가',
  冻结数量: '구입수',
  扣费日: '계산일',
  上次扣费日: '재고 보관 기간(기수)',
  上架日: '보관 기산일',
  免费保管天数: '무료 보관 일수',
  计费天数: '계비 일수',
  请确认: '【확인하세요】',
  '当前账号下无店铺，': '점포 미등록',
  请创建店铺后再执行操作: '점포 작성 후 재시도 해주세요',
  普通发货: 'Amazon FBA 납품 이외',
  FBA发货: 'Amazon FBA 납품',
  收货仓: '납품처',
  '如果您当前存在部分订单未完成的话，您账户可用余额中我们将会自动为您留下当下账户冻结金额*1的金额，来确保账户有足够的金额来支付国际运费后顺利发货。': '대응중인 주문이 있는 경우는, 국제 배송료를 지불하기에 충분한 금액이 있는 것을 확보하기 위해서, 이용 가능액에서 (당 어카운트의 예치금*1)의 금액을 일단 이용 불가로 설정했습니다.',
  '所以您目前可转账的金额为：账户可用余额减去冻结金额': '현재 이체 가능액은 이용 가능액에서 예치금을 뺀 금액입니다.',
  本公司接受银行: '폐사 수취은행 미즈호은행',
  汇款人姓名: '무통장입금인 명의',
  汇款时间: '무통장입금 일시',
  汇款凭证: '입금·이체 증서',
  点击上传: '클릭하여 업로드하기',
  良品入库: '입고(양품)',
  不良品: '불량품',
  付费重拍: '유료 교환',
  本次重拍费用X円: '유료, 이번 교환수수료는 X엔',
  '接受次品/缺货自动付费重拍（接受自动重拍，有助于我们更快的为您完成订单采购）': 'D2C회원님은 교환을 권장합니다',
  更换尺码: '크기 변경',
  更换款式: '디자인 변경',
  '请输入链接(必填)': 'URL 입력(필수항목)',
  请输入链接: 'URL 입력',
  同款链接: '동일상품URL',
  点击可查看: '클릭하여 확인가능',
  类似款链接: '유사상품 URL',
  等待原链接: '원래 URL 대기',
  下单原链接: '원본 URL 구입',
  '下单原链接（多出数量保留库存）': '원본 URL 구입(남은 재고는 재고 보관)',
  申请成功: '신청 완료',
  申请成功2: '신청 완료',
  '提交售后补偿申请，处理完成需要2个工作日左右，请稍等。': 'A/S 보상 신청 제출했습니다, 처리 완료까지 영업일 기준 2일 정도 걸리니 잠시만 기다려주세요.',
  请确认尺码: '사이즈 확인',
  请确认颜色: '색상 확인',
  '请确认设计（款式）': '디자인 확인',
  '全网断货，建议取消': '모든 사이트 재고 소진, 취소를 권장합니다.',
  '原商品缺货，找到了类似商品，请确认': '원본 URL은 재고가 소진되었고 재고가 있는 유사 상품이 발견되었습니다.구매여부 확인 부탁드립니다.',
  '预售商品。预计下单后X天后能发货，要等吗？': '원본 URL은 예약상품으로 주문후 X천출고 가능합니다.구매여부 확인 부탁드립니다.',
  '找到新的现货链接，是否购买？': '재고 있는 URL을 찾았습니다.구매여부 확인 부탁드립니다.',
  '此商品的最小起订量是X件。请确认是否购买。': '해당 상품의 최소 로트수는 X건입니다.구매여부 확인 부탁드립니다.',
  '找到符合下单量的新链接，是否可以购买。': '원하는 구매 개수를 구입할 수 있는 URL을 찾았습니다.구매여부 확인 부탁드립니다.',
  '原商品质量不佳，推荐在新链接采购。': '여러번 교환해도 불량품이 도착했으니 새 URL로 발주를 권합니다.',
  到错货: '주문한 상품과는 다른 물건이 도착하였습니다',
  少件: '주문한 수량보다 더 많은 상품이 도착하였습니다',
  多件: '주문한 수량보다 적게 상품이 도착하였습니다',
  快递扫不出: 'QR 코드를 읽을 수 없습니다',
  '配件差异（口袋，腰带，纽扣，拉链，拉绳等）': '부속품 차이(포켓, 벨트, 단추, 지퍼, 당김줄 등)',
  '设计差异（压线，领口，袖口，花纹，衣服设计等）': '디자인 차이(압선, 네크라인, 소맷부리, 꽃무늬, 옷디자인 등)',
  '材质/面料差异': '옷감의 차이',
  '不良原因:有色差\n根据检查标准，判断为不良品。\n发生不良品时请指定处理方式。': '불량사유 : 색상차 있습니다,검품기준에 의하여 불량으로 판단되었습니다,불량품 발생시 대응을 지정하여 주십시오.',
  'THE CKB档口': '직항편 시장 점포',
  '我们的 OEM 仅适用于商务舱和头等舱成员。如果您想使用OEM，请从[会员信息]更改会员等级。如果您有任何问题，请联系我们的在线客服。': 'OEM 서비스는 비즈니스 이상의 고객님들께 제공합니다. 이용을 원하시는 고객님들은 회원등급을 변경해 주세요',
  充值会员: '회원센터로',
  购买数量不可低于X件: '최소 구매수는 X입니다!',
  '平台库存（处理中）': '준비중',
  '平台库存（已锁定）': '직항편 재고(이용 예정)',
  '平台库存（可用库存）': '사용가능',
  '平台库存（待处理次品数）': '직항편 재고 (반품 불가 불량품)',
  转账金额不能为0: '이체금액은 0元 이상의 금액을 입력해주세요',
  '同步中...': '받아들이는 중...',
  '同步完成-执行刷新': '취입 완료',
  我的工作台: '마이페이지',
  订单管理: '주문 관리',
  API同步订单: '주문관리(API발주)',
  库存管理: '재고 관리',
  寻源列表: '견적서 관리',
  OEM复购: '재견적 의뢰 목록',
  'API/子账号配置': 'API연계/점포작성',
  子账号配置: '점포관리',
  会员相关: '회원 센터',
  会员办理: '회원 신청',
  国际配送管理: '국제 배송 관리',
  FBA补货计划: 'FBA 납품 목록',
  国际发货管理: '국제 배송 목록',
  国际发货售后: '국제출하 A/S',
  主账号资金明细: '부모 계정 계좌 목록',
  店铺资金明细: '점포 계좌 목록',
  OEM寻源: '견적 의뢰',
  全部店铺数据: '점포 정보',
  '这是您与THE CKB相处的第X天': '입회일수: X일',
  升级会员: '회원 요금제 변경',
  钱包余额: '잔액',
  未关联的商品: '연결되지 않은 상품',
  API同步异常订单: '이상주문(API발주)',
  商品在库: '상품재고관리',
  在库辅料: '부자재 재고관리',
  下单金额: '주문 금액',
  API下单量: '주문수(API 발주)',
  订单数量: '주문수',
  采购金额: '주문 금액',
  采购量: '주문수',
  发货量: '발송수',
  待发库存数: '발송대기 상품수',
  待确认补货计划: '미확인재고계획',
  待确认补货计划1: '미확인재고계획',
  未绑定商品: '미관련 상품',
  对折: '반접기',
  不使用商品番号: '상품번호를 사용하지 않습니다.',
  不使用客户商品sku: '고객님 SKU를 사용하지 않습니다',
  关联商品库填写: '연결 내용 입력',
  请填写会社名: '회사명을 입력해주세요',
  请填写会社地址: '회사 주소를 입력해 주세요.',
  '图片格式支持jpg，png。': '업로드 가능한 형식은 jpg png뿐입니다.',
  'LOGO图片比例为1:1，在水洗标打印时转变为黑白色': '로고 화상의 화면 비율은 1:1로, 흑백으로 인쇄합니다.',
  缝制样式: '봉제 스타일',
  请选择商品番号填写方式: '상품번호입력방식을선택해주세요',
  '更新中...': '업데이트중...',
  '更新完成-执行刷新': '업데이트완료 - 새로고침',
  Amazon在庫数更新: 'Amazon 재고수 갱신',
  购买时间: '구입 일시',
  收藏时间: '추가 일시',
  更新时间: '갱신 일시',
  请选择需要复购的商品: '재구매하실 상품을 선택해주세요.',
  请选择需要优先发货的商品: '분할 발송하고자 하는 상품을 선택해 주세요.',
  请选择需要取消的商品: '취소하고 싶은 상품을 선택해 주세요.',
  请选择需要售后的商品: '수령 후 환불신청하실 상품을 선택해주세요',
  请选择需要导出的订单: '다운로드하고 싶은 주문을 선택해 주세요.',
  '自動発注をONにしました。': '자동 주문 오픈',
  '自動発注をOFFにしました。': '자동 발주 OFF로 했습니다.',
  店铺url和访问令牌不能为空: '점포 URL과 접속코드를 입력해주세요.',
  未关联sku数量: 'SKU 미끈 부착',
  星期一: '월요일',
  星期二: '화요일',
  星期三: '수요일',
  星期四: '목요일',
  星期五: '금요일',
  星期六: '토요일',
  星期日: '일요일',
  平台库存: '플랫폼 재고',
  AMAZON库存: 'Amazon',
  不可售: '판매 불가',
  入库: '입고',
  '商品“已上架”之前的状态下的总数量': '발주하고 아직 창고에 도착하지 않은 수량',
  已使用准备发给您的商品: '출고 대기 중인 상품',
  可使用的正品数量: '창고에 있는 재고 수',
  '仓库发现商品次品且无法退款，进入您的次品库存': '현재 창고에 있는 반품불가 불량품수',
  弊社受取銀行: '계좌은행',
  横浜駅前支店: '요코하마 역전 지점',
  店番292: '가게 번호 292',
  口座番号: '계좌 번호',
  '普通預金 4014779': '225-910083-85104',
  口座名: '계좌명',
  '株式会社 SNIFF JAPAN': '스니프코리아 주식회사',
  料金表: '요금표',
  国際配送依頼番号: '국제배송의뢰번호',
  收据: '입금 영수증',
  一键绑定: 'SKU 자동끈',
  导出: '다운로드',
  请确认售后信息: '사후 보상 신청',
  解冻数量: '수량',
  通过FBA补货计划发货: 'Amazon FBA 납품',
  海外仓sku不能为空: '일본창고SKU를입력하세요',
  缺货: '재고 소진',
  传输商品信息到店铺: '점포에 일괄 등록',
  '创建成功，并已为您自动创建关联': '작성완료,연결이자동으로작성되었습니다.',
  查看关联商品库: '연결 관리 확인',
  领收书下载: '영수증 다운로드',
  领收书: '영수증',
  流水: '명세',
  是否确定加购样品: '샘플 발주하시겠어요?',
  查看报价信息: '견적서 확인',
  加购成功: '카트추가완료',
  汇款金额必须大于0: '송금 금액을 제로 이상으로 해야 합니다.',
  确认取消: '확인',
  '请绑定 Amazon sku': 'Amazon SKU 미지정 상품 있음 Amazon SKU와 연결해 주십시오',
  换绑: '연결 변경',
  '绑定Amazon sku': 'Amazon sku 연동',
  '申请取消成功后，系统将自动取消商品的发货行为，并将商品保留库存。': '취소처리를 실행하면 최종 사용자에게 직송을 정지하고 재고 보관합니다<',
  是否确认取消授权: 'API 연계를 해제하시겠습니까?',
  申请月数: '신청 월수',
  转账成功: '이체 완료',
  银行转账: '은행 송금',
  '您的余额不足，请充值后再次支付': '계좌 잔액 부족, 자금 충전 후 재실행 부탁드립니다.',
  '5s后跳转充值页面': '5초 후에 자금 충전 화면으로 전환합니다.',
  '5s后跳转附加项配置': '5초 후에 옵션 설정 페이지로 이동합니다.',
  下单失败: '발주 실패',
  下单失败3: '발주 실패',
  请确认本次重拍费用: '교환수수료 확인',
  当前单价: '단가',
  商品关联列表: '연결 관리 목록',
  修改关联: '연결 변경',
  编辑附加项: '옵션 편집',
  '为您的商品编辑的附加项，会再API下单时直接使用。如需修改请点击此处。': '상품 옵션 설정이 완료되면 API 발주 주문 상품 옵션은 자동 설정 가능합니다. 편집 버튼을 클릭하면 재편집할 수 있습니다.',
  请选择发货附加项: '선택 발송용 옵션',
  请上传图片: '로고 이미지 업로드하기',
  一键删除: '일괄 삭제',
  店铺商品信息: '상품 정보',
  '如果是个人，请输入无': '개인의 경우 없음을 입력해 주십시오.',
  订单结算费用详情: '비용 명세',
  物流详情: '배송상황상세',
  订单搜索: '주문 검색',
  发货详情: '국제 배송 정보',
  输入你的登陆密码: '로그인 비밀번호 입력',
  是否确认复购: '카트에 상품을 추가하시겠습니까?',
  复购成功: '추가 완료!',
  不同意: '동의하지 않다',
  '请填写商品的尺寸分类。': '상품의 사이즈 분류를 기재해 주세요.',
  '如果有多个尺寸，请按行输入尺寸。': '크기가 여러 개인 경우 행을 추가하고 크기를 입력하십시오.',
  '例 M、L、XL、30cm*40cm*20cm等': '예 M,L,XL,30cm*40cm*20cm 등',
  '请输入正确的Amazon sku': '올바른 Amazonsku를 입력하십시오.',
  打印标签模板: '상품 라벨',
  预览: '프리뷰',
  设为默认地址: '기본 주소로 설정',
  'Amazon sku绑定成功': 'Amazon Sku 연결 성공',
  '未处理，请点击【提出】按钮': '미처리<br/>※정식 지원에는 제출 클릭',
  OEM报价: 'OEM오퍼',
  '处理中，需要1～2分钟': '처리중 소요시간 1~2분',
  我的OEM商品: 'OEM 상품',
  转到运输公司设置: '운송회사 설정으로',
  '点击上方按钮编辑你常用的<span>快捷功能</span>': '체크박스에서 화면표시 메뉴를 지정할 수 있습니다.',
  '拉动板块可<span>调整功能排序</span>哦！': '각 메뉴를 선택하고 구성을 변경하면 화면 표시 순서를 변경할 수 있습니다.',
  '编辑后的功能入口在上方显示，你需要的功能直接点击前往即可': '편집한 표시 메뉴는 화면 좌측상단에 표시됩니다<br/>시스템내의 각 메뉴 전이에 이용합니다',
  '<span>透明购</span>: 为首页，并为您推荐1688、淘宝、天猫的商品查找专区。<br/><span>市场购</span>: THE CKB扩展的市场采购货品更全，价格更低。<br/><span>我的频道</span>: 你在本平台的喜欢的商品都在这里。 <br/>任何情况下，点击<span>logo</span>回到本页面': '<span>EC사이트구매</span>:중국 주요 EC사이트(1688,타오바오,Tmall)에서 상품검색 및 매입을 실시합니다<br/><span>시장매입</span>:직행편이 제휴하는 도매시장에서 상품검색 및 매입을 실시합니다<br/><span>MY채널</span>:직행편으로부터의 추천구입지, 마음에 드는 상품등을 표시합니다<br/>※개구리 아이콘 클릭으로 EC사이트 구매로 전환됩니다',
  '选择你感兴趣的<span>平台</span>和<span>类目</span>，再输入关键词，搜索更精准': '검색EC사이트, 카테고리를 지정하고 상품검색키워드를 입력하면 관련상품을 시스템내에서 검색가능합니다.',
  '点击“X”在THE CKB平台搜索': '[X]클릭으로 지정 조건을 바탕으로 직항편 시스템 내에서 상품 검색을 합니다.',
  '点击“X”跳转你选择的平台搜索。': '[X]클릭으로 지정 조건을 바탕으로 지정 EC 사이트에서 직접 상품 검색을 실시합니다.',
  'THE CKB为你提供了多个选购平台。根据你的<span>采购类型迅速选品</span>。': '상품선정의 편리 사이트를 소개합니다',
  '点击上方切换你喜欢的品类，我们将根据该品类进行推荐。': '표시할 카테고리를 선택합니다<br/>선택 카테고리의 추천 상품을 표시합니다',
  '如果您有多个店铺可点击这里切换店铺，为不同的店铺采购。THE CKB也会为不同的店铺推荐不同的商品。': '여러매장전환후 매장마다 상품구매가능합니다<br/>매장마다 직항편부터 추천상품을 제시합니다',
  '你的专属担当根据你的采购习惯，为您甄选的店铺会展示在这里。': '전속 매니저로부터의 추천 숍을 표시합니다.',
  '此处由系统根据你的采购习惯，为你甄选的店铺会展示在这里。': '구매내역을 바탕으로 고객님께 맞는 추천샵을 표시합니다',
  '下方为商品的推荐，会根据你的购买习惯更新商品哦！！！': '시스템에서 구매내역을 바탕으로 추천상품을 표시합니다.',
  '你还没有店铺，快去创建一个你的店铺，用来采购你的商品。': '매장이 미작성입니다<br/>발주는 매장작성이 필요합니다',
  跳过: '가이드 종료',
  主钱包: '본계정',
  子钱包: '부계정',
  国际发货创建成功: '국제배송의뢰 작성완료',
  处理中的次品和异常: '불량품·이상(대응 중)',
  不可退货次品: '불량품(반품불가)',
  去查看采购订单: '주문상세히',
  资金明细: '상세내역',
  资金明细2: '계좌 일람',
  修改商品附加项: '편집',
  订单: '주문',
  申请取消成功: '취소 신청 완료',
  选择同款: '동일상품URL로발주',
  '是否确认取消国际发货？': '취소를 실행하시겠습니까?',
  '海外仓（fnsku）/asin': '일본창고(fnsku)/asin',
  'Amazon sku/AMAZON商品名称': 'Amazonsku/Amazon상품명',
  '搜索Amazon sku/FNSKU/ASIN/SKU': 'Amazon sku/fnsku를 입력해주세요',
  下单中: '주문 처리 중 잠시만 기다려 주십시오.',
  无效的URL: '유효한 URL을 입력해 주세요.',
  请选择打印模板: '상품라벨을선택해주세요',
  商品更新: '상품 갱신',
  最新价格为X元: '가격이 갱신된 상품이 있어 최신의 주문 가격에 X위안, 갱신이 완료되었습니다.',
  请选择要翻译的语种: '언어 선택:',
  '请输入THE CKB订单编号': 'THE CKB 주문번호',
  发货标题: '납품 타이틀',
  请设置商品附加项: '상품의 검품용 옵션을 설정해 주십시오.',
  通过点击关联符合您要求的sku: '클릭으로 대상 상품을 묶기',
  商品附加项要保存吗: '검품용 옵션을 저장하시겠습니까?',
  签收成功: '짐수취완료',
  已签收: '수취 완료',
  API状态: 'API 연계',
  请上传箱唛: '필수상자 라벨 업로드하기',
  箱唛文件: '상자 라벨',
  上传箱唛: '박스라벨 업로드하기',
  修改箱唛: '배송 라벨 변경',
  无法取消附加项: '취소할 수 없습니다.',
  商品情报: '상품 정보',
  箱番号: '상자 번호',
  请上传装箱清单: '포장 리스트 업로드 해주세요.',
  乐天: '라쿠텐',
  乐天sku: '라쿠텐SKU',
  上传文件只能是X格式: '업로드 파일은  “X”형식만 가능합니다',
  装箱明细: '포장 상세',
  档口手续费: '시장 매입 수수료',
  出库手续费: '출고 수수료',
  店铺仓库所在地: '점포창고 소재지',
  杭州仓: '항저우 루트',
  广州仓: '광저우 루트',
  不需要检品: '선택안함',
  附加项验证: '상품 옵션을 선택해 주세요',
  一键配置店铺配置商品附加项: '설정된 상품 옵션 이용',
  一键配置店铺配置发货附加项: '설정된 발송 옵션 이용',
  客户SKU: '고객 SKU',
  平台SKU: '직항편 SKU',
  复制成功: '복사 완료',
  'Amazon 库存': 'Amazon 재고',
  'Amazon 商品名称': 'Amazon 상품명',
  不可用: '판매 불가',
  关联商品信息: '구입처',
  仅良品数大于0的可创建国际发货单: '양품건수가 1건 미만일 경우 국제배송의뢰를 작성할 수 없습니다.',
  最终采购价: '최종 구매가격',
  '无法按拼团价进行采购，需按原价进行采购': '공동구매 매입기간 내에 구매조건 미달로 정상구매가격으로 구매하셔야 합니다',
  '我们会尽可能按拼团价为您购买，如无法按照拼团价购买，将会按照原价进行购买': '공동구매가격 지정조건 미달시 정상상품가격으로 구매합니다',
  '剩余XX天hh:mm:ss自动扣款': '자동인출까지 앞으로 XX일 hh:mm:ss',
  我的账单: '청구서',
  待支付总额: '미결제액',
  账单名称: '거래 내용',
  待支付: '결제대기',
  扣款说明: '상세',
  应付总额: '지불 금액 합계',
  钱包金额: '➆포금전',
  主账户账单: '본계정',
  子账户账号: '부계정',
  编辑组合商品: '세트세트상품을작성',
  请选择订单: '주문 미선택 주문을 선택해 주세요',
  统一编辑发货附加项: '일괄발송옵션편집',
  '成功扣款的情况下，就会发货。': '출금에 성공한 경우 상품을 발송해 드립니다.',
  '因余额不足无法扣款的情况下，会停止发货作业，并发送另行付款的通知。': '잔액 부족으로 인출이 불가능한 경우 출고 작업을 중지하고 별도 지불 안내를 보내드립니다.',
  '一旦确认到款，就会发货。': '입금 확인되는 대로 상품 발송해드리겠습니다.',
  '为了不影响发货，在发货前，请确保账户中有足够的余额。': '발송의 영향을 주지 않도록 상품 발송 전에는 시스템 계좌에 충분한 잔액을 준비해 두세요.',
  '点击【确定】按钮，系统将自动从余额扣除当前账单<br />应付总额XX元，确定支付吗': '확인 버튼을 클릭하시면 시스템 계좌에서 XX위안을 인출해 드려도 되겠습니까?',
  请输入拒绝原因: '거부하는 이유 입력',
  请选择清关地址: '미설정 IMPORTER 주소를 설정해 주세요.',
  请选择收货地址: '미설정 수령 주소를 설정해 주세요.',
  按原价采购: '정상구매가격으로 구매',
  拼团价: '공동구매가격',
  拼多多: 'Pinduoduo',
  '商品采购的最终价格，部分渠道如拼多多存在拼团失败需要按原价购买的情况': '최종구매단가 Pinduoduo에서는 조건에 미달하는 경우 공동구매가격이 아닌 일반단가로 구매할 수 있습니다.',
  最终采购价详情: '상세',
  取消类型: '분류',
  客户取消: '고객 사정 취소',
  系统取消: '직항편 사정 취소',
  提交并下载: '다운로트',
  请求对象姓名: '고객명',
  请求金额: '청구 요금',
  点击下载: '클릭하여 다운로드',
  请求书下载: '청구서 다운로드',
  请确认优先发货信息: '배송정보 상세내용',
  '余额扣费汇率全部以：XX円 = 1元，进行换算，请确认后再进行支付': '환율은 XX엔=1위안으로 계산하겠습니다.',
  编辑裁剪图片: '이미지 크기 변경',
  名称: '상자 번호',
  实际重量: '실중량',
  体积重: '용적 중량',
  长: '세로',
  宽: '가로',
  高: '높이',
  箱子: '골판지 상자',
  编辑剪切区域和移动图片: '크기 변경 이미지를 이동하다',
  适合正方形logo: '정사각형 디자인에 적합한 로그',
  适合长方形logo: '직사각형 디자인에 적합한 로그',
  '目前该运输方式暂时无法显示物流状态，烦请自主到物流公司网址进行查询': '해당 물류회사의 상태는 표기할 수 없으므로 번거로우시겠지만 아래 추적 URL에 확인해 주십시오.',
  '跟踪URL:': '추적 URL:',
  请以PDF格式上传各商品标签: 'PDF 형식으로 각 상품 라벨을 업로드 해주세요.',
  '详细步骤请参考这里。': '자세한 절차는 여기에 참고해 주십시오',
  '上传的数据和追加的商品SKU不同，请确认后再上传。': '업로드 데이터는 추가된 상품 SKU와 다르니 확인하시고 다시 업로드 해주세요.',
  商品SKU上传设置: '상품SKU업로드설정',
  所有商品一个文件上传: '전체 SKU 일괄 업로드하기',
  一个商品一个文件上传: 'SKU마다 하나의 파일로 업로드하기',
  请上传SKU文件: '파일을 업로드 해주세요.',
  '资料是需要事先准备的东西，没有库存的话无法为您处理。在没有库存的情况下，请先提交OEM估价委托。': '자재는 미리 준비가 필요한 것으로 재고가 없으면 대응할 수 없습니다.재고가 없는 경우는, 우선 OEM 견적 의뢰를 제출해 주세요.',
  '指定搜索的网站→输入日语关键词→跳转至指定网站搜索商品': '검색처 EC사이트 지정→일본어 키워드 입력→지정 사이트에서 상품 검색 가능',
  '更简单，更透明': '더 쉽게! 더 투명하게!',
  KAERU插件: 'KAERU 툴',
  插件下载: '확장기능추가',
  '更便捷地搜索&下单中国商品': '중국 상품 리서치 발주를 더 쉽게!',
  立即安装: '지금 바로 설치',
  站内搜索: '사이트 내 검색',
  外部搜索: '외부 검색',
  '在X系统中追加购买商品的购物车，正在选择中的系统是否符合顾客的意向，请再次确认': 'X시스템에서 매입상품 카트 추가가 실행되었습니다.선택중인 시스템이 고객님의 뜻에 맞는지 다시 확인해주세요',
  d2cb2b系统介绍: 'D2C / B2B 시스템 보충:',
  'D2C系统:支持从单点直接传输到最终用户的业务': 'D2C 시스템: 1점에서 최종 사용자에게 직송하는 업무 지원',
  'B2B系统:支持保留库存并将其交付到国内EC相关仓库和内部仓库': 'B2B 시스템 : 재고를 보유하고 국내 EC 관련 창고나 자사 창고에 납품하는 업무를 지원',
  '通过单击Top菜单右侧的B2B/D2C图标可以切换系统': 'Top 메뉴 우측 B2B / D2C 아이콘 클릭으로 시스템 전환 가능',
  'D2C系统是小批量交付前提。1配送单位的商品价格在X元 (约Y日元) 以上时，请使用B2B系统。': 'D2C 시스템은 소액 배송 전제입니다.1배송 단위의 상품 대금이 X위안(약 Y엔) 이상인 경우, B2B 시스템을 이용해 주십시오.',
  会员条约: '회원 규약',
  使用条约: '이용약관',
  会社情報: '회사 정보',
  隐私权政策: '개인정보보호정책',
  解除: '해소하다',
  商品类目: '카테고리',
  操作取消: '조작 취소',
  仅限输入英文字符: '영문자로만 입력해주세요',
  仅限输入英文和数字字符: '영숫자로만 입력해 주세요',
  无效的邮编: '유효한 우편번호를 입력해 주세요.',
  国际物流配置id不能为空: '미입력항목 있음 운송회사와 중량을 모두 입력하신후 계산해주세요',
  '输入的支店名格式不正确，请设置1-20位字符': '지점명 입력 오류 지점명은 1~20자 이내로 입력하십시오.',
  销售额取值范围: '주문 기간',
  返现类型: '환원 방식',
  返现: '고정 금액',
  返现2: '환원 금액',
  返点: '환원율',
  销售额区间: '주문 합계액대',
  '销售额X%': '주문 합계액 X% 환원',
  为期: '부여 계산 기간',
  X个月: 'X개월',
  返现发放时间: '현금 부여 시기',
  每月X日自动返: '매월 X일 자동부여',
  每季度自动返: '분기별 자동 부여',
  每半年自动返: '반년마다 자동 부여',
  充值记录: '충전내역',
  处理结果: '대응 상태',
  取消发货任务记录: '발송 취소 이력',
  取消采购记录: '매입 취소 이력',
  订单是否结算: '결제 여부',
  未结算: '미결제',
  结算中: '청산중',
  已结算: '결제완료',
  结算失败: '청산 실패',
  发货取消结果: '배송취소상황',
  查看异常联络处理记录: '처리 이력으로',
  结算时应退款金额: '환불액',
  '商品代金，订单结算后解冻至账户余额': '주문청산 완료 후 취소된 상품의 상품대금 및 상품옵션비용이 시스템 잔액으로 환불',
  取消原因: '취소 사유',
  '客户申请 (已取消发货)': '고객신청(발송취소 완료)',
  '客户申请 (已取消发货，成为库存)': '고객 신청 (발송 취소 완료 · 재고 보유)',
  颜色尺寸未知: '컬러 사이즈 불명',
  异常订单处理记录: '이상 주문 처리 이력',
  客户申请: '고객 신청',
  预约销售: '예약 판매',
  有最小订单批次: '최소주문로트수있음',
  '次品(即使达自动重拍次数上限，可发货的良品库存也不足)': '불량품(자동 재매입 횟수 상한선에 도달해도 배송 가능 양품 재고가 부족합니다)',
  '不良品 (在不良品对应设定中指定“退货退款”)': "불량품 (불량품 대응 설정에서 '반품 환불' 지정)",
  '缺货(即使达自动重拍次数上限，可发货的良品库存也不足)': '재고 소진 (자동 재매입 횟수 상한에 도달해도 배송 가능 양품 재고가 부족합니다)',
  全网断货: '전 사이트 재고 소진',
  ' 缺货重拍完了': '재고소진재발주완료',
  查看处理详情: '대응 상세 확인으로',
  主账号: '본계좌',
  子账号: '부계좌',
  '如果您想使用资料以外的OEM服务(服装、杂货等)，请先将会员升级为商务舱。': '자재 이외(어패럴, 잡화 등)의 OEM 서비스를 이용하고 싶다면 회원 플랜에서 비즈니스 클래스로 변경해 주십시오.',
  '除了资料之外，OEM产品的开发流程比资料更长更复杂。': '자재보다 자재 이외의 OEM 제품의 개발 흐름은 길고 복잡합니다.',
  '升级到商务舱以上，拥有丰富OEM经验的专业人员可为您提供更细致、更高效的服务，如果您对此感兴趣，请与我们联系。': '비즈니스 클래스에 대해 OEM 경험이 풍부한 전임 스탭을 두어 보다 세밀하고 효율적인 대응이 가능하오니 관심 있으신 분들은 꼭 검토하여 주시기 바랍니다.',
  模板效果预览: '템플릿 보기',
  检品标准: '검품 표준 목록',
  取消尺码变更: '취소',
  '填写尺码 如：Ｆ，XS，S，M，2XL等': '변경 후 사이즈 입력 예: F, XS, S, M, 2X',
  月销售额区间: '츠키요우구요우',
  活动有效期: '활유효기',
  次品退货退款并付费重拍: '교환 대응',
  '以后的商品为次品时，请都默认处理为次品退货退款并付费重拍。': "불량품 대응 설정 : <br/>향후 불량품 발생시 모두 '불량품 반품환불, 유료재발주하는' 방식으로 대응함",
  '因原商品质量不佳，我们为您重拍时自动寻找了以下新链接，但新链接价格不符合您的预期，请您确认': "지정샵 URL 불량률 높음<br/>교환하셔도 불량 개선 가능성 없음 (로트생산으로 인해)<br/>유사상품 대체샵에서 매입가능<br/>→구매단가 상한초과이므로 매입여부를 확인바랍니다<br/>대체샵 URL:<ahref='H' target='_blank'>H</a><br/>단가:X위안",
  '因原商品质量不佳，我们为您自动寻找了以下新链接，请您确认是否需要再新链接下重拍': "지정샵 URL 불량률 높음<br/>교환하셔도 불량품 개선 가능성 없음 (로트생산으로 인해)<br/>유사상품 대체샵에서 매입가능<br/>대체샵 URL:<ahref='H' target='_blank'>H</a><br/>단가:X위안",
  '以后的商品为次品时，请都默认处理为原商品退货退款并取消商品采购。': "불량품 지원 설정 : <br/> 향후 불량품 발생 시 모두 '불량품 반품 환불, 매입 취소' 방식으로 대응하는",
  确认尺码: '지정 사이즈로 매입 불가<br/>구매 사이즈를 다시 확인하시기 바랍니다.',
  确认颜色: '지정 컬러로 매입 불가 <br/> 구매 컬러를 다시 확인해 주십시오.',
  确认款式: '지정 디자인으로 매입 불가 <br/> 구매 디자인을 다시 확인하시기 바랍니다.',
  '原商品缺货-推荐同款-价格不符合客户预期': "지정 URL 재고 소진 대체샵 매입 가능 <br/>구매 단가 상한선 초과이므로 매입 여부를 확인하시기 바랍니다<br/>대체샵 URL:<ahref='H' target='_blank'> H</a><br/> 단가: X위안",
  '原商品缺货-推荐类似款': "지정 URL 재고 소진 대체샵 매입 가능 <br /> 대체샵 URL : <ahref='H' target='_blank'> H</a><br/> 단가 : X위안",
  '预售商品-推荐同款商品': "해당상품은 예약주문으로 X일후 출고예정<br/>당일 출고 가능한 대체샵 있음<br/>대체샵 URL: <ahref='H' target='_blank'>H</a>",
  '预售商品-无同款商品推荐': '해당상품은 예약주문으로 X일후 출고예정',
  '不满足最小起量-推荐同款商品': "최소주문로트를채우지않았습니다<br/>최소로트:X건 주문수 : Y건<br/>※지정주문수로 구매 가능한 대체샵 있음<br/>대체샵 URL:<ahref='H' target='_blank'>H</a>",
  '不满足最小起量-无同款商品推荐': '최소주문로트를채우지않았습니다<br/>최소로트:X건 주문수: Y건',
  '更换同款链接-价格不符合客户预期': "지정샵 URL 불량률 높음<br/>교환후에도 불량품 개선이 보이지 않습니다<br/>대체샵에서의 매입권장<br/>대체샵URL:<ahref='H' target='_blank'>H</a>",
  颜色差异: '상품 색상 차이 있음<br/>교환시 불량 개선 가능성 없음(로트생산으로 인해)<br/>※문제 상품 수가 많아 납기지연 가능성 대',
  logo差异: 'Logo가 달라 <br/>교환해도 불량품 개선 가능성 없음(로트생산으로 인해)<br/>※문제상품수가 많아 납기지연 가능성 대',
  '材质、面料差异': '원단이 달라<br/>교환해도 불량품 개선가능성 없음(로트생산으로 인해)<br/>※문제상품수가 많아 납기지연가능성 대',
  配件差异: '부속품이 달라<br/>교환해도 불량품 개선 가능성 없음(로트생산으로 인해)<br/>※문제상품수가 많아 납기지연 가능성 대',
  商品上有中文: '중국어 표기<br/>교환해도 불량품 개선 가능성 없음(로트생산으로 인해)<br/>※문제 상품 수가 많아 납기지연 가능성 대',
  尺码差异: '사이즈가 달라<br/>교환해도 불량품 개선가능성 없음(로트생산으로 인해)<br/>※문제상품수가 많아 납기지연가능성 대',
  设计差异: '디자인이 달라<br/>교환해도 불량품 개선가능성 없음(로트생산으로 인해)<br/>※문제상품수가 많아 납기지연가능성 대',
  '不良原因:其他\n根据检查标准，判断为不良品。\n出现不良品时请指定对应措施。': '불량 사유 : 기타<br/>검품기준에 의해 불량으로 판단되었습니다<br/>불량품 발생시 대응을 지정해 주십시오',
  '不良原因:有污渍水渍\n根据检查标准，判断为不良品。\n发生不良品时请指定对应措施。': '불량사유 : 오염·기미·물 얼룩 있음<br /> 검품기준에 의해 불량으로 판단되었습니다<br />불량품 발생시 대응을 지정해 주십시오',
  '不良原因:损坏\n根据检查标准，判断为不良品。\n发生不良品时请指定对应措施。': '불량사유 : 파손있음<br/>검품기준에 의해 불량으로 판단되었습니다<br/>불량품 발생시 대응을 지정해주시기 바랍니다',
  '不良原因:有线头、脱线\n根据检查标准，判断为不良品。\n发生不良品时请指定对应措施。': '불량사유 : 실밥, 올뜯김 있음<br />검품기준에 의해 불량으로 판단되었습니다<br />불량품 발생시 대응을 지정해 주십시오',
  '不良原因:接缝不良\n根据检查标准，判断为不良品。\n发生不良品时请指定对应措施。': '불량사유 : 접사불량<br/>검품기준에 의해 불량으로 판단되었습니다<br/>불량품 발생시 대응을 지정해주시기 바랍니다',
  '不良原因:有导线\n根据检查标准，判断为不良品。\n发生不良品时请指定对应措施。': '불량사유 : 올트임 있음<br/>검품기준에 의해 불량으로 판단되었습니다<br/>불량품 발생시 대응을 지정해 주십시오',
  '不良原因:有针孔\n根据检查标准，判断为不良品。\n发生不良品时请指定对应措施。': '불량사유 : 바늘구멍 있음<br/>검품기준에 의하여 불량으로 판단되었습니다<br/>불량품 발생시 대응을 지정하여 주십시오',
  '不良原因:发霉\n根据检查标准，判断为不良品。\n发生不良品时请指定对应措施。': '불량사유 : 곰팡이 있음<br /> 검품기준에 의해 불량으로 판단되었습니다<br />불량품 발생시 대응을 지정해 주십시오',
  '不良原因:有锈\n根据检查标准，判断为不良品。\n发生不良品时请指定对应措施。': '불량사유 : 녹 있음<br/>검품기준에 의해 불량으로 판단되었습니다<br/>불량품 발생시 대응을 지정하여 주십시오',
  '不良原因:中文表示\n根据检查标准，判断为不良品。\n发生不良品时请指定对应措施。': '불량사유 : 중국어 표기<br/>검품기준에 의해 불량으로 판단되었습니다<br/>불량품 발생시 대응을 지정해주시기 바랍니다',
  '不良原因:纽扣损坏\n根据检查标准，判断为不良品。\n发生不良品时请指定对应措施。': '불량사유 : 하단 파손 있음<br /> 검품기준에 의하여 불량으로 판단되었습니다<br />불량품 발생시 대응을 지정하여 주십시오',
  '不良原因:拉链有破损\n根据检查标准，判断为不良品。\n发生不良品时请指定对应措施。': '불량사유 : 지퍼파손 있음<br/>검품기준에 의해 불량으로 판단되었습니다<br/>불량품 발생시 대응을 지정해주시기 바랍니다',
  '不良原因:附件缺陷\n根据检查标准，判断为不良品。\n发生不良品时请指定对应措施。': '불량사유 : 부속품결함<br/>검품기준에 의하여 불량으로 판단되었습니다<br/>불량품 발생시 대응을 지정하여 주십시오',
  '不良原因:有气味\n根据检查标准，判断为不良品。\n发生不良品时请指定对应措施。': '불량사유 : 냄새 있음<br/>검품기준에 의해 불량으로 판단되었습니다<br/>불량품 발생시 대응을 지정하여 주십시오',
  '原URL缺货，新的URL内商品是X元，请确认': "지정 URL 재고 소진 대체샵 매입 가능 <br/>→구매 단가 상한선 초과이므로 매입 여부를 확인하시기 바랍니다<br/>대체샵 URL:<ahref='H' target='_blank'> H</a><br/> 단가: X위안",
  请在我指定的新链接购买: '아래 주소로 매입 희망<br/>URL::',
  取消商品采购: '매입 취소',
  '取消商品采购+商品发送': '매입 및 최종 사용자 발송 취소',
  请在我指定的新链接下采购: '아래 주소로 매입 희망<br/>URL::',
  '请在THE CKB为我推荐的此链接下采购': '대체샵 URL로 구매',
  '可以等待，请继续在原链接采购': '지정샵 URL로 구입<br/>→발송대기시간 허용',
  '我接受起订量，请继续在原链接采购': '최소롯트수로 주문수량 변경하여 원샵에서 구매<br/> (남은 재고는 일단 직항편창고에 보관되었다가 새주문으로 이용될 예정입니다) <br/>→최소롯트수 허용',
  '我接受起订量，请继续在原链接采购（多采部分商品无异常上架后将作为库存在THE CKB仓库代为保管，并可匹配其他直发订单发出）': '최소롯트수로 주문수량 변경하여 원샵에서 구매<br/> (남은 재고는 일단 직항편창고에 보관되었다가 새주문으로 이용될 예정입니다) <br/>→최소롯트수 허용',
  '问题不大，我能接受，请当成良品入库': '위 상품 문제를 허용하여 양품으로 입고',
  '此问题我不能接受，请依然当成不良品处理': '색차 허용불가 불량으로 반품환불,매입취소',
  '我有可能有货的采购链接，请在这个链接再尝试购买': '아래 주소로 매입 희망<br/>URL::',
  '我等不及，请在我指定的新链接下采购': '이하 샵에서 매입희망<br/>→발송대기시간 허용 안되고<br/>URL:',
  '我等不及，请在THE CKB为我推荐的此链接下采购': '대체샵 URL로 구매<br/>→발송대기시간 허용 안되고',
  '我不接受起订量，请在我指定的新链接下采购': '아래샵에서 매입희망<br/>→최소로트수 허용안되고<br/>URL:',
  '我不接受起订量，请在THE CKB为我推荐的此链接下采购': '대체샵 URL로 구매 <br/>→최소롯트수 허용 안되고',
  'THE CKB推荐的链接价格等不合适，请在我指定的新链接下采购': '아래 샵에서 매입희망<br/>→대체샵URL의 가격을 허용할 수 없으며<br/>URL:',
  '此问题我不能接受，请依然当成不良品处理，并在我指定的新链接购买': '위 상품문제를 허용하지 못해 불량으로 반품환불하며 아래샵에서 매입희망',
  我还是要继续在原链接采购: '지정샵 URL로 구매 <br/>→불량품률 허용',
  取消商品重拍: '재매입 취소',
  '取消商品重拍+商品发送': '재매입 및 최종사용자 발송 취소',
  次品退货退款并取消商品采购: '불량품으로 반품환불하고 매입취소',
  '次品退货退款并取消商品采购+商品发送': '불량품으로 반품환불하고 매입 및 최종사용자 발송취소',
  确定后将按照新的货代进行发货: "확인' 버튼을 누르면 변경 후 운송사에서 출고됩니다.<br/> 괜찮으신가요?",
  '确定后将取消您的国际发货单，您需重新创建': '취소를 실행하면 해당 국제 배송 의뢰가 취소되고 다시 국제 배송 의뢰를 작성해야 합니다.<br/>취소를 실행하시겠습니까?',
  关闭后将不再向您店铺同步物流单号及订单状态: '추적번호 자동반영을 해제하면 자사 사이트 국제추적번호 및 발송현황 자동반영이 정지됩니다<br/>추적번호 자동반영을 해제하시겠습니까?',
  关闭提醒: '확인 부탁드립니다.',
  批量搜索: '일괄 검색',
  '每行输入一个，按Enter键换行': '한 줄에 하나씩 입력하고 Enter 키를 눌러 줄을 고친다',
  可以直接粘贴Excel数据: 'Excel 데이터 직접 페이스트 가능',
  '※最多可同时搜索100个': '※최대 100건까지 검색 가능합니다',
  双击批量搜索: '더블클릭으로 일괄검색',
  选择类似款: '대체 상점 매입',
  '此问题我不能接受，请依然当成不良品处理，并取消商品采购': '위 상품문제 허용불가 불량 반품 환불,매입취소',
  '此问题我不能接受，请依然当成不良品处理，并取消商品采购+商品发送': '위 상품문제 허용불가 불량 반품 환불,매입 및 최종유저 발송취소',
  后台导入: '이행된 데이터',
  确认重拍: '교환 대응',
  '使用高强度耐用的瓦楞纸箱进行国际运输，质量好，库存充足': '국제 배송용 고강도 견고한 골판지 상자 사용, 고품질로 재고도 충분',
  '$THE CKB发货袋说明$': '국제운송용 고강도 견고한 발송봉투 사용, 고품질로 재고도 충분',
  $厂家原箱说明$: '파손, 국제 발송 강도에 적합하지 않을 수 있으며 배송 속도에 영향을 미칠 위험 있음',
  纸箱类附加项必须选择一种: '다음 중 배송 박스를 선택해 주세요.(필수)',
  发货袋附加项必须选择一种: '아래 중 원하시는 발송봉투를 선택하셔야 합니다.',
  如想变更为商务舱以上: '비즈니스 이상으로 변경하고 싶다',
  和日本工作人员在Line上商量: '일본인 스탭과 Line으로 상담',
  取消发货: '발송 취소',
  '同意一个包裹无法装下商品时，THE CKB将为您拆成多个包裹进行发货': '포장중량이 소액수입규정을 초과한 경우, 주문하신 상품을 분할하여 발송해 드립니다.',
  '由于该订单商品无法在一个包裹中装下，我们为您拆成了多个包裹进行发货': '포장중량이 소액수입규정을 초과하여 주문하신 상품을 분할 발송하였습니다.',
  拆: '자동 분납',
  优: '분납',
  下单提醒: '주의',
  下次不再提醒: '다음 번부터 표시하지 않는다',
  人气购物网站: '인기 쇼핑 사이트',
  '发现海量中国商品，助您更简单，更透明地下单购物！': '더 많은 상품을 찾을 수 있고, 중국 구매를 더 쉽게!',
  使用tips: '사용법',
  '1.指定采购来源': '1. 검색처 구입처 지정',
  '2.选择商品类目或输入关键字': '2. 일본어 키워드 입력 & 카테고리 선택',
  '3.即可前往指定采购来源站点搜索相关商品': '3. 지정 구매처 사이트에서 상품검색 가능',
  '抱歉，订单正在打包中，不允许修改地址': '이미 포장중이므로 상품 배송지를 변경할 수 없습니다.',
  联系我们: '문의',
  失效: '유효기간 만료',
  '很抱歉！您的店铺（X）因token失效需重新绑定，如需帮助请联系客服': 'API연계실효(X)연계를해제하고재연계를해주세요',
  所选日期区间长度不可超过X天: '시작일을 포함하여 X일 이내의 날짜만 선택할 수 있습니다.',
  能够在中国找到丰富的供应商: '다양한 루트로 중국 매입 가능',
  '按照日本质量标准进行检验（隶属于日本公司）': '엄격한 검품기준으로 상품품질 확보',
  '最低国际运费保证，可运往23个国家/地区': '국제배송비 업계 최저가, 각지에서 상품 발송',
  可靠的支持和即时的客户服务: 'C/S상담원 상시대기, 원활한 소통 가능',
  会员中心: '회원 센터',
  我的会员: '마이플랜',
  最低: '최저가',
  会员规则变更通知: '회원 플랜 개정 공지',
  '尊敬的用户，THE CKB团队经过谨慎考虑，为了更好的为用户提供服务，决定在经历了一段时间的免费运营后，于2023/1/11开始只对付费会员提供服务。': "THE 직항편을 이용해 주셔서 대단히 감사합니다.<br/>THE 직항편에서는 시스템 품질 향상을 도모하고 고객 만족스러운 서비스 제공을 위해 <br/> 정말 죄송하지만 아래와 같이 '0엔 회원 플랜'의 유료화를 진행하게 되었습니다<br/>갑자기 변경되어 진심으로 죄송합니다만, 양해 부탁드립니다<br/><br/>변경일: <span style='color: #eb45'>2023/1/11</span><br/>변경내용: <span style='color: #eb45'>이코노미플랜 br0엔 →",
  '您也不用担心，您是陪伴我们成长的首批用户，我们已为您自动升级到新会员，并且免费送您会员到1月31日（原价1980日元/月)！赶快去试用体验吧！': '요금제 유료화에 따른 주요 변경사항 및 고객님의 협조를 부탁드리고 싶은 사항은 다음과 같습니다<br/>★휴대폰전용앱 서비스 개시★2023년 3월<br/>★2023년 1월중 회원비 무료&Line 친구등록으로 30일간 회원비 무료★<br/><br/><시스템기능의 변경사항>※향후 순차적으로 추가예정<br/>★휴대폰전용앱 서비스 개시★2011년 3월 <br/>★새로운 시스템 연계처 추가(야프쇼, 멜카리, Stores 등)→2020년 <',
  '到期后会员将失效，将无法享受下单服务，欢迎随时充值新会员。': '<협조해 주셨으면 하는 사항><br/>새로운 이코노미 플랜 무료기간 이후(무료기간:~2023/01/31), 고객님께서 직접 변경 후 플랜 선택을 부탁드립니다<br/>※새로운 플랜 선택을 하지 않을 경우 시스템 이용이 불가합니다.주의하세요.',
  新会员权益介绍: '>자세한 내용은 이쪽.',
  开通新会员: '새로운 회원 요금제를 바꾸세요.',
  查看新会员: '새 회원 플랜 목록으로',
  '开通会员，立享下单代买服务。请联系主账号开通。': '신규회원가입으로 중국매입 가능!회원가입은 부모계정에서 조작해주세요.',
  '开通会员，立享下单代买服务': '신규회원가입으로 중국매입 가능!',
  '开通会员，即可享受下单代买服务。': '신규회원가입으로 중국매입 가능!',
  '请联系主账号开通。': '회원가입은 부모계정에서 조작해주세요.',
  '即可享受下单代买服务。': '즉가향유하차오후쿠후쿠요우',
  '有效期：': '회원자격종료일:',
  已失去会員: '회원 자격 정지 중',
  未登録: '미등록',
  未登录: '로그아웃 상태',
  '会员等级变更！': '회원 플랜 변경 완료 안내',
  您当前的会员等级已变更为V: '이용 요금제가 V로 변경되었습니다.',
  立即享用会员: '시스템 TOP으로',
  '您的会员已到期！': '회원 요금제 종료 알림',
  '您当前的会员已到期，为了不影响正常下单和使用，请及时开通哦！（不影响历史订单集账户余额充值）': '사용중이던 회원 요금제가 종료 되었습니다. 시스템 사용을 원하시는 분은 요금제 결제를 부탁드립니다.',
  查看会员: '회원 요금제 목록으로',
  'THE CKB会员，为您的买卖生活提供一切所需。': 'THE CKB 회원 플랜, 중국 구입을 더 쉽게!',
  入会优享超多服务: '회원가입으로 중국수입을 쉽게 할 수 있는 다양한 서비스를 이용 가능!',
  开通会员: '회원 가입하러 가기',
  有效期至: '회원 유호 기간',
  自动续费已开启: '회원비 자동지급: ON',
  自动续费已关闭: '회원비 자동지급: OFF',
  成为: '로 변경 예정',
  去续费: '회원 연기하러 가기',
  当前自动续费不可开启: '회비 자동이체 설정이 안됩니다.',
  '您在持有预充会员【XX】期间，暂不可开启自动续费。在该预充会员正式开启后，我们会自动为您开启会员的自动续费，敬请谅解。': '【XX】 요금제 변경을 예약하여 회비 자동납부 설정이 불가합니다<br/> 해당 요금제가 활성화되면 자동으로 회비 자동납부를 켜드립니다',
  知道了: '닫기',
  '请及时关闭PayPal账户内不需要的自动续费，如未关闭，我们会将这笔钱充值到您的余额，可能需要您承担部分手续费。': 'Paypal 자동 결제를 설정해 놓으신 분들은 자동 결제를 해제해 주세요.<br/>해제하지 않은 경우 매월 비용이 자동으로 충전이 됩니다. <br/>잘못된 비용 충전에 대한 환불은 수수료가 부과되오니 이점 유의하시길 바랍니다.',
  关闭PayPal自动续费教程: '자동 지불 해제 매뉴얼에 연결된 페이지에 내용이 없음',
  关闭paypal自动续费教程: '자동 지불 해제 매뉴얼에 연결된 페이지에 내용이 없음',
  续费提示: '회원자격 연장에 관한 공지',
  '续费后，会在XX开始自动延长YY时间': '결제완료시 선택하신 플랜의 회원 YY 유효기간은 XX에서 연장됩니다.',
  '检测到您当前有T1至T2的预充会员，续费成功后，会取消原来预充的会员，预充会员的<span style="color:#EB4545;">钱款不予退还</span>。': "고객님은 이미 [V] 플랜 (유효기간 :T1~T2) 변경을 예약했기 때문에 플랜 갱신은 실시하지 마십시오.<br /> 만일, 플랜 갱신된 경우, 예약 완료의【V】는 무효가 되어 <span style='color: #EB4545;'> 사전 지불 완료 비용의 환불이 불가합니다</span>.",
  升舱提示: '회원 플랜업에 관한 공지',
  '您当前为V1，想开通V2，您想选择何时生效？开通成功后，选择将不可更改': '현 플랜은V1입니다. V2으로 변경할 경우, <br/>“즉시V2으로 변경” OR “V1회원기간 종료 후V2활성화” 중 선택할 수 있습니다.',
  '检测到您当前有T1至T2的预充会员，降仓成功后，会取消预充会员，预充会员的<span style="color:#EB4545;">钱款不予退还</span>。': "고객님은 이미 [V1] 플랜(유효기간:T1~T2) 변경을 예약했기 때문에 플랜 갱신은 실시하지 마십시오.<br /> 만일, 플랜 갱신이 된 경우, 예약 완료의【V1】는 무효가 되어 <span style='color: #EB4545;'> 사전 지불 완료 비용은 환불 불가합니다</span>.",
  降舱提示: '회원 플랜 다운에 관한 공지',
  '续费后，会在T开始自动延长V时间': '회원님의 V 종료일이 T에서 연장됩니다.',
  '您当前为V1，想开通V2，为保障您当前的会员权益，会等原会员套餐到期（TT）后开始实行降仓会员，是否要进行降仓？': '현 플랜은 V1입니다.V2로 변경할 경우 V1 유효기간 종료 후 V2를 활성화합니다.',
  '检测到您当前有2段会员，升舱成功后，会取消当前会员和预充会员，钱款不予退还。': "회원 요금제 변경시 [V1] 과 [V2] 회원 자격은 무효가 됩니다. <span style='color: #EB45;'> 회원비는 환불이 불가하오니 이점 양해 부탁드립니다. </span>",
  '检测到您当前有2段会员，升舱成功后，会取消当前会员和预充会员，<span style="color:#EB4545;">钱款不予退还</span>。': "회원 요금제 변경시 [V1] 과 [V2] 회원 자격은 무효가 됩니다. <span style='color: #EB4545;'> 회원비는 환불이 불가하오니 이점 양해 부탁드립니다. </span>",
  '检测到您当前有T1至T2的预充会员，升舱成功后，会取消预充会员，预充会员的钱款不予退还': "고객님은 이미 [V] 플랜 (유효기간 :T1~T2) 변경을 예약했기 때문에 플랜 갱신은 실시하지 마십시오.<br /> 만일, 플랜 갱신이 된 경우, 예약 완료의【V】플랜은 무효가 되어 <span style='color: #EB4545;'> 사전 지불 완료 비용은 환불 불가합니다</span>.",
  '检测到您当前有T1至T2的预充会员，升舱成功后，会取消预充会员，预充会员的<span style="color:#EB4545;">钱款不予退还</span>': "고객님은 이미 [V] 플랜 (유효기간 :T1~T2) 변경을 예약했기 때문에 플랜 갱신은 실시하지 마십시오.<br /> 만일, 플랜 갱신이 된 경우, 예약 완료의【V】플랜은 무효가 되어 <span style='color: #EB4545;'> 사전 지불 완료 비용은 환불 불가합니다</span>.",
  立即生效: '즉시 변경',
  '{time}开始生效': '{time}부터 활성화',
  定时升舱: '플랜업 예약',
  利用期间: '신청 월수',
  '%off': '% 할인',
  '折合X円/月': '할인후가격₩ X/월',
  已成功开通预充会员: '회원비 지불완료',
  已成功开通会员: '회원비 지불완료',
  '已为您开启预充会员V，有效期为Y': 'V의 회원비 지불이 완료되었습니다<br/>유효기간 : Y',
  '已为您开启V，有效期为Y': 'V의 회원비 지불이 완료되었습니다<br/>유효기간 : Y',
  '为了不影响您的后续使用，请保持PayPal内开启自动续费。': 'PayPal 자동 지불 설정을 권장하고 있습니다, 미등록자는 꼭 설정하세요!',
  已优惠: '₩ X OFF',
  确认协议并立即支付: '약관에 동의하고 결제하기',
  会员服务协议: '회원 이용 규약',
  自动续费服务规则: '자동 지불 규약',
  高级会员专享服务: '카카오톡 상담',
  '如需开通商务舱或头等舱会员，请先用line扫描右侧二维码联系我们，获取专属咨询服务。': '※ [퍼스트 플랜] 오른쪽 QR코드를 스캔하시면 카카오톡을 통해 1:1 상담을 받으실 수 있습니다.',
  恭喜成功开通: '이용해 주셔서 감사합니다.',
  '为了更好地帮您履行下单履约，您需要提前填写以下信息。': '주문에 관한 대응을 원활하게 진행하기 위해, 이하 숍 설정을 사전에 대응해 주세요.',
  添加店铺: '매장추가',
  采购设置: '매입 설정',
  国际配送设置: '국제 배송 설정',
  暂不设置: '지금은 설정하지 않는다',
  保存设置: '보존',
  请填写完成国际配送设置: '국제배송설정을해주세요',
  请填写完成采购设置: '구입 설정을 실시해 주십시오',
  请填写完成店铺信息: '매장정보를 입력해주세요',
  去开通: '신청',
  是否要关闭自动续费: '확인 부탁드립니다.',
  '关闭自动续费后，您的V将于T到期。关闭后会影响您后续的正常使用，请谨慎关闭。是否现在关闭？': '회원비 자동납부를 해제하면 현 회원 요금제 V 이용이 T로 종료됩니다.',
  '为了能正常关闭自动续费，请务必前往paypal关闭自动续费。': '※ Paypal의 회비 자동 지불을 설정한 경우, 회원 요금제 변경을 실시하는 경우, Paypal의 자동 지불 설정을 해제해 주십시오.<br/>해제되지 않을 경우 자동으로 비용충전이 실시됩니다.<br/>잘못된 비용충전분 환불은 환불 수수료 부담 부탁드리오니 유의하시기 바랍니다.',
  '已为您开启V自动续费，记得保持余额充足。': '계좌에서 자동이체 설정을 한 경우:<br/>잔고부족으로 자동지급이 실패한 경우에는 발주가 불가하므로 계좌에 충분한 잔액을 준비해 주시기 바랍니다.',
  '为了能正常打开自动续费，请务必前往PayPal开启自动续费。': 'PayPal 자동지급을 선택한 경우:<br/>paypal 공식 사이트에서 자동결제를 설정해주세요.',
  支付金额: '합계액',
  円: '₩',
  '支付金额(円)': '합계액(₩)',
  '尊敬的用户，您需办理会员后，方可下单，请联系主账号办理': '발주기능을 이용하실 경우 먼저 회원가입을 하셔야 합니다<br/><b>부모계정으로 회원가입을 해주세요</b>',
  办理会员: '회원가입에',
  '尊敬的用户，您于T变更为非会员用户，我们已发站内信告知您：开启自动同步下单功能及按钮已关闭（变为非会员后，不影响历史订单及账户余额提现）': 'T로부터 회원 자격이 정지되어 API 자동발주 기능을 일시적으로 정지하였습니다(기존에 대응된 주문 및 잔액 인출에는 영향이 없으니 안심하시기 바랍니다)<br/>자세한 내용은 시스템 내 메시지에서 확인 부탁드립니다.',
  '尊敬的用户，您需办理会员成功后，方可同订单数据': '주문접수 기능을 이용하실 경우 회원가입을 먼저 하셔야 합니다.',
  '尊敬的用户，您需办理会员成功后，方可开启自动同步下单，请联系主账号办理': '자동발주기능을 이용하실 경우 회원가입을 먼저 하셔야 합니다<br/><b>부모계정으로 회원가입을 해주세요</b>',
  '尊敬的用户，您需办理会员成功后，方可开启自动同步下单': '자동발주 기능을 이용하실 경우 회원가입을 먼저 하셔야 합니다.',
  '尊敬的用户，您于T变更为非会员用户，已授权的API被禁用，需办理会员成功后，方可同步订单数据，请联系主账号办理': 'T에서 회원 자격이 정지되어 연계된 상태의 API 기능을 사용할 수 없게 되었습니다.계속 이용을 희망하는 경우는, 우선 회원가입을 실시해 주셔야 합니다<br/><b>부모계정에서 회원가입을 해 주세요</b>',
  '尊敬的用户，您需办理会员后，方可授权绑定子店铺，请联系主账号办理': 'API 연계 기능을 이용하실 경우 회원가입을 먼저 하셔야 합니다<br/><b>부모계정으로 회원가입을 해주세요</b>',
  '尊敬的用户，您需办理会员成功后，方可授权绑定子店铺': 'API 연계 기능을 이용하실 경우 회원가입을 먼저 하셔야 합니다.',
  授权店铺API绑定变更: 'API연계상태변경공지',
  '尊敬的用户，您于T变更为非会员用户，已授权店铺绑定的API变更为禁用状态（不影响历史订单及账户余额提现）': 'T로부터 회원 자격이 정지되어 제휴 완료 상태의 API 기능을 이용할 수 없게 되었습니다(기존에 대응된 주문 및 잔액 인출에는 영향이 없으므로 안심하시기 바랍니다.',
  '已授权（禁用）': '연계제(이용불가)',
  '円/月': '원/달',
  '/月': '{currency}/월',
  '{currency}/月': '{currency}/월',
  绑定信用卡支付: 'PayPal 신용카드 추가',
  你还没有绑定信用卡: '현재 사용할 수 있는 카드가 없습니다.',
  有効期限: '유효 기간',
  请选择信用卡: '신용카드를 선택해 주세요',
  '是否删除信用卡？': '이 신용카드 정보를 삭제하시겠습니까?',
  信用卡卡号: '신용카드 번호',
  信用卡安全码: '보안 코드',
  仅限数字: '숫자만 입력 가능',
  '仅限输入3-4位数字安全码': '3-4자리 숫자만 입력 가능',
  '仅限数字，例：05/2022': '숫자만 입력 가능 예: 05/2022',
  请检查卡信息是否有误: '신용카드 정보가 올바른지 확인해 주세요',
  '支付失败，请重新操作！': '지불 실패, 다시 시도해 주십시오',
  paypal信用卡: '신용카드',
  充值失败: '차지 실패',
  请联系主账号更改: '부모계정부터 조작해주세요',
  已为您开启自动续费: '회원비의 자동 지불을 ON으로 했습니다.',
  已失去会员: '회원 자격 정지 중',
  未入会: '비회원',
  设为默认支付方式: '디폴트 결제 방법으로 설정하다',
  支付失败: '지불 실패의 통지',
  '余额不足，请先充值余额后重试。': '계좌잔액 부족, 월 회원비 자금 충전 부탁드립니다.',
  每次询问我处理次品方式: '매번 확인',
  '尊敬的用户，您需办理会员后，方可下单': '발주 기능을 이용하실 경우 회원가입을 먼저 하셔야 합니다.',
  会費: '회비',
  PayPal加载中: 'PayPal로드중',
  '余额不足，请先绑定店铺后充值，再重试': '계좌잔고부족,매장추가하여자금충전후다시시도해주세요',
  '信用卡-由PayPal提供，支持Visa、MasterCard、AMEX、JCB等类型': '비자, 마스터카드, AMEX, JCB 등 페이팔 계정에 등록된 신용카드 브랜드를 이용하실 수 있습니다.',
  次品处理: '반품불가 불량품 대응',
  处理时间: '대응 일시',
  '处理中(转正品)': '대응 중 (양품으로 입고)',
  已转正品: '양품으로 입고 완료',
  所属订单编号: '직항편 주문 번호',
  次品图片: '화상',
  次品原因: '원인',
  次品数: '수량',
  次品共: '반품 불가 불량품:',
  '次品转正品后，产生的商品附加项费用，可在子钱包（费用流水）页面，使用订单编号查询费用记录，': '양품으로 입고되면 발생한 수수료는 점포 자금 명세에서 확인할 수 있습니다.직항편 주문번호를 검색 조건으로 검색도 가능합니다.',
  '去查询>': '명세 확인을 위해',
  批量作废: '일괄로 폐기하다',
  批量转正品: '일괄적으로 양품으로 입고',
  '您确定转正该批次的次品吗？': '선택한 상품을 양품으로 입고하겠습니까?',
  '次品转正后，平台将按正品处理相关业务流程，且不可再次打次，请慎重操作！': '양품으로 입고되면 양품대응방식으로 대응해드리고 다시 불량으로 판단할 수 없습니다 선택하신 상품을 양품으로 입고하겠습니까?',
  '您确定作废该批次的次品吗？': '【확인하세요】',
  '次品作废后将不可转正品，不可退还，': '폐기처리를 의뢰하면 고객님께서 해당 상품의 소유권이 포기된 것으로 간주됩니다',
  'THE CKB平台有权自行处理，且无任何经济纠纷，': '이 경우 다시 양품으로 고객님께 배송의뢰를 할 수 없습니다.',
  '请慎重操作！': '선택한 상품을 폐기해도 될까요?',
  '已申请转正品！<br />我们将尽快处理，转正品成功后将有站内信通知到您': '양품으로 입고되는 신청을 확인하고 신속하게 처리해 드리겠습니다<br/>조작이 완료되는 대로 시스템내의 메시지를 통해 통지하오니 유의해 주십시오.',
  已作废成功: '폐기 의뢰 완료',
  作废: '폐기하다',
  转正品: '양품으로 입고',
  含次品转正品: '반품불가 불량품이 양품으로 입고 완료',
  '次品经您转为正品后，可视为正品下单，存在消费者不可接受的风险，请谨慎操作！平台不承担相关责任。': '양품으로 입고 후 다른 양품으로 최종 사용자에게 배송합니다.최종 사용자가 받아들일 수 없는 점 양해 부탁드립니다.',
  '查看转正记录>': '반품불가 불량품 대응내역으로',
  会员开通记录: '회원비 지불 이력',
  活动赠送: '무료 체험',
  自动续费: '자동 지불',
  自动续费2: '회원비 자동 결제',
  开通失败: '지불 실패',
  开通成功: '지불필',
  待生效: '대생효',
  会员套餐: '회원 등급',
  '支付价格（日元）': '금액(₩)',
  会员有效期: '회원 자격의 유효 기간',
  导出记录: '다운로드',
  会员订单编号: '주문번호',
  类型2: '종류',
  '如果您现在更改会员计划，您当前的会员资格将失效。请注意，会员费不可退还。': "‘즉시 변경’ 시 현제 사용중인 회원플랜의 효력은 사라집니다. <span style='color: #EB4545;'> 해당 회원비는 환불이 불가하오니 이점 참고해 주시면 감사하겠습니다. ",
  '请重新选择商品附加项，您之前选择的附加项可能失效或价格发生变化': '상품옵션 미선택 주문시 선택하신 상품옵션의 가격이 변경되거나 이용불가 할 수 있으니 다시 상품옵션을 선택해주세요',
  历史选择商品附加项: '주문시 선택하신 상품 옵션',
  附加项总价: '합계액(개산)',
  开通会员2: '회원비 지불',
  状态2: '상태',
  '请重新选择商品附加项，': '상품 옵션 미선택',
  您之前选择的附加项可能失效或价格发生变化: '주문시 선택하신 상품옵션의 가격이 변경되거나 이용불가 될수 있으니 다시 상품옵션을 선택해주세요',
  请选择附加项后再提交: '상품 옵션 미선택 내용을 선택하신 후 다시 시도해 주세요',
  色差: '색차',
  '污渍/斑点/水印': '얼룩·얼룩·수흔',
  破损: '파탄',
  线头: '실밥·풀림 처리',
  接缝不良: '솔기선',
  抽丝: '전선',
  针眼: '바늘구멍',
  霉菌: '곰팡이',
  生锈: '녹',
  商品有中文: '중국어 표기',
  纽扣破损: '단추 파손',
  拉链破损: '지퍼 파손',
  附属品缺陷: '부속품 결함',
  有气味: '냄새 있음',
  其他不良: '기타',
  处理状态: '상태',
  请输入订单编号: '직항편 주문번호 입력',
  银行卡便捷支付: '은행 송금(반영스피드UP)',
  '线下汇款至我们指定的银行账户，点此查看': '폐사 지정 계좌로 이체',
  收款账户信息: '지정 계좌 정보 보기',
  绑定您的支付行信息: "무통장입금원계좌정보 입력<br/><span style='font-size:12px'>※입력오류에 주의해주세요</span>",
  提交支付信息: '무통장입금 금액을 입력하여 제출',
  绑定银行卡信息: '무통장 등록',
  '系统确认中的状态是指银行到账通知时间存在差异，如超过3天状态未变更，请先联系当地银行确认打款是否成功，再联系客服处理': '입금시간은 금융기관에 따라 다릅니다.단, 만약 영업일 기준 3일 이상 아직 입금이 확인되지 않았다면 먼저 결제 성공 여부를 은행과 확인하신 후 온라인 고객에게 연락해 주십시오.',
  银行名称2: '폐사 수취 은행',
  银行账号2: '계좌 번호',
  支店名2: '무통장입금원 지점명',
  支店号: '무통장입금원지점번호',
  账户持有人: '무통장 명의',
  设为默认支付方式2: '기본 지불 방법으로 설정',
  系统确认中: '입금확인중',
  '系统确认中~预计1-3个工作日到账，后续可在充值记录查看资金入账情况！': "입금확인중 <p style='margin-top: 10px'> 1~3영업일 착금예정이며 착금하시면 충전내역 화면에서 상세정보를 확인하실 수 있습니다!</p>",
  '复制收款银行信息，去线下银行转账至我们的收款银行': '폐사 지정 계좌로 지정 금액',
  '线下银行转账成功后，您可以在这里绑定您自己的银行卡信息': '무통장 입금 완료 후 고객님의 무통장 입금 정보 입력',
  '输入金额，点击“确定”按钮，提交支付信息': "무통장입금 금액을 입력한 후 '확인' 버튼을 클릭",
  '请先确认线下汇款成功后再提交，否则审核会被拒绝': '은행 송금은 고객 자신에 의해 당사가 지정하는 은행 계좌로의 이체 수속을 실시해야 합니다.<br/> 충전신청을 제출하기 전에 무통장입금이 완료되었는지 확인해주세요.',
  '请输入1-20位银行名称': '은행명칭은 20글자 이내로 입력해주세요',
  请输入7位数字银行账号: '계좌번호는 7자리로 입력해주세요.',
  '请输入1-20位支店名': '지점명은 20글자 이내로 입력해주세요.',
  请输入3位支店号: '지점번호는 3자리로 입력해주세요.',
  '请输入1-20位账户持有人': '명의인은 20자 이내로 입력해 주십시오.',
  不可代购: '매입 불가',
  '输入的密码格式不正确，请设置6-32个字符，字母和数字的组合，字母区分大小写': '패스워드 입력 오류, 패스워드는, 6~32 문자의 영숫자 혼재로 설정해 주세요(영문자는 대문자, 소문자를 식별하므로 주의해 주세요).',
  '是否修改密码？': '시비수 개밀벽?',
  '系统检测到您当前的密码过于简单，存在安全风险，建议您修改密码。': '패스워드의 변경이 필요합니다. 패스워드의 안전성이 낮은 부정 액세스를 막기 위해서 보다 복잡한 패스워드로 변경할 것을 권장합니다.',
  '注册或登录后，将为您推荐更多个性化内容。': '신규등록 OR 로그인하여 고객의 취향에 맞는 콘텐츠 확인 가능',
  '注册或登录后，可查看更多相似商品': '신규등록 OR 로그인하여 더 많은 유사상품 확인 가능',
  删除成功: '삭제 성공',
  完成以下配置才可使用表格导入创建订单功能: 'Excel 일괄주문을 이용하실 경우 아래 주문관련 설정을 사전에 처리하셔야 합니다.',
  默认商品附加项配置: '기본 옵션 설정',
  默认发货附加项配置: '발송시옵션설정',
  默认国际物流配置: '운송 회사 설정',
  前往配置: '설정으로',
  注意事项: '주의사항:',
  '1.表格数据最多为1000行，超过请分多个表格导入': '1. 한번 업로드 할 수 있는 것은 최대 1,000줄까지입니다.건수가 넘을 경우, 여러 엑셀 파일로 나뉘어 진행해 주세요.',
  '2.仅支持.xlsx、.xls文件，且小于20M': '2. 업로드 파일은 .xls, .xlsx 형식이어야 하며 파일당 크기는 20MB까지입니다.',
  '3.导入成功后，请前往「待付款」，进行付款后完成下单': "3. 업로드 완료되는 대로 '주문관리' → '주문내역'의 '지불대기' 화면에서 결제해주세요",
  订单创建中: '주문 생성중',
  下单失败提示: '주문실패 알림',
  本次导入成功X个订单: '업로드 된 건수 : X',
  失败X个订单: '실패 건수: X',
  失败订单请重新导入: '아래 업로드에 실패한 주문을 다운로드하여 수정 후 다시 업로드 해주세요.',
  失败订单下载: '업로드 실패 주문 다운로드',
  我已知晓: '닫기',
  下载: '다운로드',
  'THE CKB SKU': 'THE CKB SKU',
  // 表格下单字段改不得
  order_客户订单号: '주문 번호',
  order_直行便SKU: 'THE CKB SKU',
  order_数量: '수량',
  order_收件人姓名: '수신인',
  order_联系电话: '연락처',
  order_都道府县: '시',
  order_市: '구',
  order_详细地址: '상세주소',
  order_邮编: '수신 우편번호',
  order_国家: '국가',
  good_直行便SKU: 'THE CKB SKU',
  good_数量: '수량',
  good_客户SKU: '고객님 상품 SKU',
  '表格数据最多为1000行，请分多个表格导入': '한번 업로드 할 수 있는 것은 최대 1,000줄까지입니다.건수가 넘을 경우, 여러 엑셀 파일로 나뉘어 진행해 주세요.',
  '表格数据最多为200行，请分多个表格导入': '한번 업로드 가능한 것은 최대 200줄까지입니다.건수가 넘을 경우, 여러 엑셀 파일로 나뉘어 진행해 주세요.',
  客户订单号不能为空: '고객님 주문번호를 입력해주세요',
  客户订单号最长为100个字符: '고객님 주문번호 최대 입력문자수는 100글자입니다',
  商品SKU不能为空: '직항편 SKU를 입력해 주세요',
  '请输入6~100个字符的商品SKU': '직항편 SKU는 6~100자 이내로 입력해주세요.',
  '第X行，同一个客户订单号SKU有且仅能有一行': 'X행, 같은 고객 주문번호와 직항편 SKU가 이미 존재합니다.',
  请输入7位数字的邮编: '우편번호는 숫자 7자리로 입력해주세요.',
  表格导入创建订单: '엑셀 일괄 주문',
  表格导入中: '업로드 중',
  表格导入创建商品: '엑셀 일괄 업로드하기',
  批量付款: '대량지불',
  客户订单号: '고객주문번호',
  RMB: 'CNY',
  '(RMB)': '(CNY)',
  '商品总额(￥)': '상품 합계액(CNY)',
  商品总额: '상품 합계액',
  '附加项总额(￥)': '상품옵션 합계액(CNY)',
  附加项总额: '상품옵션 합계액',
  '总计(￥)': '합계액(CNY)',
  '单价(￥)': '단가(CNY)',
  '附加项金额(¥)': '상품옵션 합계액(CNY)',
  附加项金额: '상품옵션 합계액',
  '小计(￥)': '소계(CNY)',
  确认订单信息: '주문 내용을 확인하다',
  商品创建中: '업로드 중',
  请勿上传空文件: '빈 파일은 업로드할 수 없습니다.내용을 입력하신 후 다시 시도해 주십시오.',
  请勾选订单: '주문을 선택해 주십시오',
  表格下单: '엑셀 일괄 주문',
  数量不能为空: '수량을 입력해주세요',
  请输入大于等于1的整数: '1이상의 정수를 입력해 주세요.',
  收件人姓名不能为空2: '수취인명을 입력해 주세요',
  '请输入1-50个字符的商品SKU': '수취인명은 1~50자 이내로 입력해주세요',
  联系方式不能为空: '전화번호를 입력해주세요',
  '请输入8-11字符的联系方式': '전화번호는 숫자 8~11자리 이내로 입력해주세요.',
  都道府县不能为空2: '도도부현을 입력해 주세요',
  '请输入1-50字符的都道府县': '도도부현은 1~50문자 이내로 입력해 주세요.',
  '请输入1-50字符的市': '시는 1~50자 이내로 입력해 주십시오.',
  都道府县与市不匹配: '도도부현 이름과 시가 일치하지 않습니다',
  详细地址不能为空2: '상세주소를 입력해주세요',
  邮编不能为空2: '우편번호를 입력해주세요',
  '请输入1-50个字符的收件人姓名': '수취인명은 1~50자 이내로 입력해주세요',
  '相同订单下，收件人信息与第X行不一致': '동일주문번호이며 배송지정보가 X행 정보와 불일치합니다.',
  '订单创建成功，完成付款后下单成功': '업로드 완료, 「주문 관리」→「주문 내역」의 「지불 대기」화면에서 지불해 주십시오.',
  第X行: 'X행선',
  数据不完整: '입력 데이터 미비 내용을 확인하신 후 다시 시도해 주십시오.',
  数量需为大于0的整数: '수량은 1이상의 정수를 입력해 주세요.',
  第X行SKU重复: 'X행 같은 직항편 SKU가 이미 존재합니다.',
  上传失败请重试: '업로드 실패 다시 시도해주세요.',
  客户订单号最长为32个字符: '고객님 주문번호 최대 입력문자수는 32글자입니다',
  没有该都道府县: '해당하는 도도부현이 존재하지 않습니다.',
  请上传文件: '파일을 선택해주세요.',
  '文件大于20M,请重新上传': '업로드 파일은 .xls, .xlsx 형식이어야 하며 파일당 크기는 20MB까지입니다.',
  表格导入商品: '엑셀 일괄 업로드하기',
  '1.表格数据最多为200行，超过请分多个表格导入': '1. 한번 업로드 할 수 있는 것은 최대 200줄까지입니다.건수가 넘을 경우, 여러 엑셀 파일로 나뉘어 진행해 주세요.',
  '请输入1-200字符的详细地址': '상세주소는 1~200자 이내로 입력해주세요.',
  删除成功2: '삭제에성공했습니다.',
  '会员才可查看我的收藏、足迹、购买过内的商品哦': '즐겨찾기 목록, 열람 내역, 구입하신 상품/점포 열람에는 회원가입이 필요합니다.',
  会员登录: '회원센터로',
  '货物发出去之后不要在亚马逊后台再打开这个补货计划，避免调用api失败': '납품 플랜의 처리를 원활하게 하기 위해 <br/> 상품이 발송되기 전에 아마존 셀러 센트럴에서 다시 납품 플랜을 열지 마십시오.',
  '订单读取中，预计需要1-3分钟，请稍后刷新页面查看读取结果': '주문수거중입니다 <br/>1~3분 경과후 다시 페이지를 업데이트하여 주문결과를 확인해주세요',
  处理详情: '대응 상세',
  文件大小不超过10M: '업로드할 수 있는 파일 사이트는 10MB까지입니다.',
  'PayPal加载中，请稍等': '페이팔 결제 페이지를 읽는 중 잠시만 기다려주세요.',
  由PayPal提供服务: '페이팔을 통한 서비스 제공',
  '请求超时，请稍后重试': '현재 접속이 안됩니다, 잠시 후 다시 시도해 주세요.',
  '预计到账CNY：X元': '예상 입금액 CNY: X위안',
  '支付中，请稍等': '결제 처리 중입니다, 잠시만 기다려 주십시오.',
  '您填写的信息受到加密保护，请安心填写': '입력하신 정보는 암호화되어 보호되오니 안심하고 입력해주세요.',
  再试一次: '다시 읽기',
  保留自动续费: '아니오',
  关闭自动续费: '예',
  继续保留自动续费: '취소(자동지급설정ON)',
  提交并关闭自动续费: '답변제출(자동지급설정OFF)',
  升级成商务舱及以上就可享用更多寻源服务: '해당 조작은 비즈니스 클래스 이상의 회원가입이 필요합니다.',
  电话: '전화번호',
  充值撤回: '충전 취소',
  请选择银行卡: '지불할 은행 계좌를 선택하십시오.',
  费用合计: '총비용',
  已失效: 'URL 끊김',
  已下架: '재고 소진',
  商品不存在: '삭제 완료 상품 있음',
  '存在已失效商品，请调整商品': '[주의해주세요] <br/> 재고가 소진된 상품이 있기 때문에 구입할 수 없습니다.',
  '存在已下架商品，请调整商品': '[주의해주세요] <br/> 재고가 소진된 상품이 있기 때문에 구입할 수 없습니다.',
  '存在库存过低商品，请调整发货量或及时补充库存': '[주의해주세요] <br /> 직항편 재고가 부족한 상품이 있어 구입할 수 없습니다',
  '多个商品有异常，请重新调整商品': '【주의하시기 바랍니다】<br />복수상품에 이상이 발생하여, 대응 후 다시 시도해 주십시오',
  '商品已下架，请调整商品或发货量': '재고가 소진된 상품이 있어 <br/>발송수를 조정하거나 재고 보유 주문에서 재고를 보충해 주세요',
  '商品已失效，请调整商品或发货量': 'URL이 만료된 상품이 있으므로 <br/>발송수를 조정하거나 재고 보유 주문에서 재고를 보충해 주십시오.',
  库存不足: '직항편 재고 수 부족',
  '当前订单包含需采购的商品，如遇到商品无法采购等情况导致取消时，将通过异常联络通知您，您可在xx中更改默认项': '당전긍포함수채택적상품,여우도상품무법채택등정황치취소촉,장통협상렌트통지문,장가재x중경개묵묵문',
  '组合不可，1次订购单品商品最多可组合30中SKU': '세트조 불가 1주문으로 단품상품 최대 30SKU까지 세트조 가능합니다',
  商品链接: '상품 URL',
  '希望以订单为单位，确认是否可以取消': '취소가능여부 주문단위 확인바랍니다.',
  '同意THE CKB直接取消该商品发货，剩余商品正常发货，无需询问': '자동발송 취소허가, 동일주문으로 다른상품이 있을경우 타상품만 발송',
  '组合商品：希望以订单为单位，确认是否可以取消': '<strong> 세트조 상품 : </strong> 취소가능여부 주문단위로 확인바람',
  '组合商品以外：同意THE CKB直接取消该商品发货，剩余商品正常发货，无需询问': '<strong> 세트조상품외:</strong> 자동발송 취소 허가, 동일 주문으로 다른 상품이 있을 경우 타상품만 발송',
  '无法发送商品时，设置是否可以取消自动发送 (直发订单)': '<strong> 상품발송 불가시 자동발송 취소 지원여부 설정(최종사용자 직배송 주문)</strong>',
  '※有「全网断货」OR「超出自动重拍次数上限」的商品的场合等': "<sub style='color:#999'> ※'모든 사이트 재고소진'OR '자동 재구매 횟수 상한 초과'의 상품이 있는 경우 등 </sub>",
  异常订单设置: '이상 주문 설정',
  '当前订单包含需采购的商品，如遇到商品无法采购等情况导致取消时，将通过异常联络通知您，您可在中更改默认项': '저희 회사 대응시 문제사항은 이상주문 메뉴로 알려드리겠습니다.이상 주문 발생 시 디폴트 대응 설정은 아래 메뉴에서 대응 가능합니다.',
  '店铺配置->发货设置': '「점포 관리」→「이상 주문 설정」',
  '该商品取消采购和发货，订单下其余商品（若有）正常发货': '해당 오류 상품은 발송 취소, 동일 주문으로 다른 상품이 있을 경우 타상품만 발송',
  '该商品取消采购和发货，订单下其余商品（若有）也取消发货，转为库存': '해당오류상품은 발송취소, 동일주문으로 다른상품이 있을경우 타상품은 재고보관',
  '该商品取消采购和发货，订单下其余商品（若有）自定义发货或转为库存': '해당 오류상품은 발송취소, 동일 주문으로 다른 상품이 있을 경우 상품별 개별 대응 지시',
  '该商品不取消采购和发货，在我指定的新链接继续购买': '해당 오류상품은 아래 지정샵에서 재구매 희망',
  '「已取消」或「已发货」或「待发货」或「触发异常联络未处理」的商品无法再次选择': "'취소완료', '발송대기', '발송완료', '이상주문판단대기' 상품은 대응지시 변경 불가",
  继续发货: '통상 발송 희망',
  取消发货转为库存: '발송취소, 보관재고로 변경',
  选择结果: '대응 지시 내용',
  最终组合结果: '세트 구성 내역',
  选择: '변경 없음',
  次品重拍达到上限: '자동 재매입 횟수 상한에 달했다',
  '已达到自动重拍次数上限，取消建议': '자동 재매입 횟수 상한에 도달한 취소 권장',
  '由于您选择次品退货退款，未触发次品重拍': '『반품환불』의 불량품 대응을 지정하기 때문에, 불량품이 발생하는 대로 자동으로 매장에 반품 및 상품대금을 지급합니다',
  商品组合信息: '상품 정보',
  请选择规格后再追加: '필수 항목 상품 속성',
  商品已存在: '추가불가 동일상품 이미 추가완료',
  请创建关联关系后再选择: 'SKU 끈을 맞춘 후 다시 시도해주세요',
  组合或oem商品不允许编辑尺码变更: '组合 혹은 oem 상품불윤编码척辑경래',
  请编辑附加项后保存: '필수항목<br/>자상품의 상품옵션을 선택해주세요',
  '主商品无库存时下直发单，附加项将不执行': '※D2C-최종사용자 직송주문의 경우 세트조 옵션 설정이 비활성화됩니다.',
  请补充手机号信息: '핸드폰 번호를 입력해주세요.',
  '为了更好的为您服务，我们建议您补充手机号信息': '보다 나은 서비스를 제공할 수 있도록 휴대폰 번호 보충이 필요합니다.',
  不写区号: '기타',
  补充手机号: '보충합니다',
  '活动赠送(推广联盟)': '소개 앰배서더 혜택',
  经济舱: '이코노미 플랜',
  标准舱: '스탠더트 플랜',
  商务舱: '비즈니스 플랜',
  头等舱: '퍼스트 플랜',
  温馨提示: '확인을 부탁합니다',
  去升级: '비즈니스 회원으로 변경하기',
  暂不升级: '이대로 구매',
  '当前提交的订单商品数量达X件，升级标准舱预计本单可节省Y元手续费(入库手续费&出库手续费)，是否升级后再下单？': "해당 주문하신 상품 수가 X점 초과되었습니다. <span style='color: #EB45;'> 스탠다드회원으로 변경시 합계 Y원의 수수료가 무료입니다.</span>(입고수수료&출고수수료).<br/> 스탠다드회원으로 업그레이드 해드릴까요?",
  '出库手续费(预估)': '출고 수수료',
  '入库手续费(预估)': '입고 수수료',
  '可节省手续费合计(预估)': '스탠다드 회원으로 변경하시면 X위안을 받으실 수 있습니다.',
  件1: '점',
  是否拦截: '출하 보류',
  拦截状态: '출하 보류',
  关闭拦截: '보류 해제',
  开启拦截: '출하 작업을 보류',
  出荷保留不可: '출하 보류 불가',
  '首次加入会员，尊享首月': '신규회원 첫달 회원비',
  立即入会: '회원 가입하러 가기',
  首次加入会员: '신규 회원 가입 시로',
  尊享首月: '첫달 이용요금이',
  首次入会: '신규 가입자 한정!',
  试用: '특별 할인 체험 중',
  '新客优惠活动还剩：': '신규 입회 캠페인 응모 기간 : 나머지',
  首月: '첫달',
  名额仅剩X名: '정원 X명 남았습니다.',
  '次月续费X円/月': '기존 가격:￦X/월',
  '※对于新用户专享活动，如果在会员到期前关闭自动续费，则不会产生使用费。只要没有办理关闭自动续费，就会从下个月开始以正常价格续费。': '※ 신규회원 할인 이벤트는 첫달에만 적용이 됩니다. 첫 달 이후 사용을 원하시는 분들은 기존가격으로 결제가 됩니다. 자동이체 설정 및 해지는 회원정보 페이지에서 변경이 가능합니다.',
  新客A円: '₩ ',
  新客1円: '₩ 10',
  '新客{A}円': '첫달 {A}원',
  新客X折: 'X%할인',
  '新客{x}折': '첫달{x}%',
  新人试用活动: '회원비 지불(할인가)',
  推广联盟: '소개 앰배서더',
  '恭喜您已成为THE CKB专业推广者': '일반 소개 앰배서더가 되었습니다!',
  '恭喜您已成为THE CKB普通推广者': '프로 소개 앰배서더가 되었습니다!',
  我的专属推广码: '당신의 소개 코드',
  '复制邀请码或者链接，即可进行推广': '소개코드 또는 소개용 URL을 복사하여 지인이나 친구와 공유하세요.',
  复制: '카피',
  开启推广之旅: '확인',
  '欢迎来到THE CKB！': '더 직항편에 오신 것을 환영합니다.',
  '成功邀请了您，恭喜您获得': '소개 등록 특전',
  '天会员免费试用！': '일간 무료체험 가능!간단 중국 구입을 경험하세요!',
  我也要推广: '소개 앰배서더가 되다',
  '邀请码(选填)': '초대코드입력',
  邀请码错误: '잘못된 추천코드 입니다.',
  '邀请码无效，请重新输入': '잘못된 추천코드 입니다.',
  '在既成品的基础上，我有一些改良的需求': '완성품을 기준으로 몇가지 개선이 필요합니다',
  '既无参考图片也无式样书的情况，无法发起寻源，请联系对应担当提供制作式样书服务': '참고사진도 약식서가 없으면,견적서 개시를 할 수 없습니다.양식서 제작은 담장자에게 연락해주세요',
  '请问你对本次服装OEM的初步需求是怎样的？': '이번 의류OEM의초기 수요는 어떠십니까?',
  '只需要生产出和图片或链接看起来一样的产品，对面料没有任何要求，且不需要有任何设计上的改动。': '원단이나 디자인 변경 없이 사진이나 링크와 같은 모양의 제품을 만들기만 하면 됩니다',
  '风险告知：A的情况，此选项不寄实物样品给客户，只通过样衣图片在线上进行确认。此选项优点为出样快，缺点为THE CKB只保证成衣外观和客户提供的图片接近一致无法保证和原链接衣服材质保持一致。请知悉！': '위험알림:A의경우 이 옵션은 고객에게 실제 샘플을 보내지 않고 샘픙 사진은 통해 온라인으로 확인만 하는 옵션입니다.이 옵션의 장점은 샘플을 빠르게 제작할 수 있다는 점이며,단점은 기성복의 외관이 고객이 제공한 그림과 비슷하다는 점만 보장할 뿐 원본 링크의 소재와 일치한다는 보장이 없습니다.알아주세요!',
  '我有样衣，希望THE CKB帮我生产出和样衣一模一样的衣服。': '나는 샘플을 가지고 있고,THE직항편에서 샘플과 정확히 같은것을 생산해 줬으면 좋겠다.',
  '我有样衣，但我对设计/面料/尺寸等，有希望改动的地方。': '샘플은 있는데 디자인/소재/사이즈 등을 변경하고 싶은 부분이 있습니다',
  '我只有参考图片或链接，且我有需要改动的地方或我对面料有拘泥。': '참고 사진이나 링크만 있고,바꿀것이 있거나 원단에 집착한다',
  '此种情况您需要尽可能提供一件样衣到THE CKB作为参考，或者您需要提供详细的式样书，如果您没有式样书，可以联系THE CKB使用式样书制作服务': '이 경우, 가능한 THE직항편에 견본 옷을 제공해야 합니다,혹은 당신이 상세한 양식서를 제공해야 합니다.만약 양식서가 없다면,THE직항편에 연락해 양식서제작서비스를 이용할 수 있습니다',
  '我没有样衣或参考图片/链接，但我有式样书，希望THE CKB根据式样书帮我进行生产。': '나는 샘플이나 참고사진/링크는 없지만 양식이 있으니, THE직항편에서 양식서에 맞게 생산해주길 바랍니다',
  '既无参考图片也无式样书的情况，无法发起寻源，请联系对应担当提供制作式样书服务；式样书必须包含产品的色卡、尺寸、特殊工艺、面料信息等': '참고그림/양식도 없는 상황에서는 견적서를 작성할수 없습니다.담당자와 연계하여 양식서제작서비스를 이용해주세요(양식서는 상품색상카드,사이즈.특수공예,원단정보들을 반드시 포합해야 합니다)',
  请至少填写一条完整的产品信息: '적어도 하나의 완전한 상품 정보를 기입해 주세요',
  产品信息说明: '제품정보 설명',
  '不知道，但是我可以邮寄面料样布，希望THE CKB帮我找到和样布一样的面料': '모르겠어요. 하지만 제가 샘플 천을 우편으로 보낼수 있으니,THE직항편에서 샘플과 같은 원단을 찾아주세요',
  '请问你是否知道面料具体信息？': '원당정보를 알고잇나요?',
  '知道，我可以提供面料信息和具体的色卡信息': '알고잇습니다,원단 정보와 구체적인 색상카드정보를 제공할수 있습니다',
  '不知道，希望THE CKB帮我找到和样衣或参考图片一样的面料': '모르겠어요. THE직항편에서 샘플이나 참고그림과 같은 원단을 찾아주세요',
  '不知道，希望THE CKB可以根据我的需求，给我推荐合适的面料': '모르겠어요, THE직항편에서 내에게 맞는 원단을 추천해주세요',
  请提供具体的色卡信息: '구체적인 생상 정보를 제공해주세요',
  '请大致描述一下希望布料的外观或功能上的需求，如': '원단의 외관이나 기능상의 요구를 대략적으로 묘사해 주세요',
  '请大致描述一下希望改动哪些方面,如': '어떤 점을 바꾸기를 원하는지 대략 묘사해 주세요',
  '请问你能够提供尺码的具体尺寸吗？': '구체적인 사이즈를 제공해 주실 수 있나요?',
  '我有尺码对应的尺寸数值。': '사이즈에 맞는 사이즈 수치가 있어요',
  '根据服装生产标准，尺寸相差': '의류 생산 기준에 따라 사이즈 차이',
  '我没有数值，请参考链接尺寸。': '나는 수치가 없으니 링크 사이즈를 참고하세요',
  '我没有数值，请THE CKB提供。': '나는 수치가 없으니 THE직항편에서 제공해주세요',
  '请先下载对应模板，填写完成后上传': '참고양식을 다운로드 후,빈칸을 완성하여 업로드해주세요',
  创建寻源单说明: '견적서 설명만들기',
  '以上为参考报价，具体报价需要以最终报价为准': '이상은 참고 견적서입니다,구체적인 견적은 최종견적을 기준으로 해야합니다',
  '系统检查到，您未安装采购扩展程序，现在安装采购更方便直接在1688，天猫，淘宝官网THE直达商品可以添加到采购系统购物车中。现在马上安装': '시스템검사 결과 구매 확장 프로그램이 설치되어 있지 않습니다. 지금은 설치를 하시면 구입이 더 편하고 직접1688,T-MALL,TAOBAO홈페이지에서 THE직항편 구매시스템 카트에 추가할 수 잇습니다. 바로 설치 하겟습니까?',
  请输入Amazon: 'Amazon을 입력하세요',
  请搜索需要绑定的Amazon: '결합이 필요한Amazon 검색',
  '商品名称/Amazon': '상품명/Amazon',
  点击完结: '완결클릭',
  存在待组商品: '대체상품존재',
  購入数量が最低ロット数を満たしていません: '',
  '存在不足起订量的商品，请修改数量': '주문량이 부족한 상품이있습니다,수량을 수정해 주세요',
  '当前账号下无店铺，请创建店铺后再执行操作': '현재계정에 매장이없습니다,매장을 만든 후 작업을 수행하십시오',
  '如果您当前存在部分订单未完成的话，您账户可用余额中我们将会自动为您留下当下账户冻结金额*1的金额，来确保账户有足够的金额来支付国际运费后顺利发货。所以您目前可转账的金额为：账户可用余额-冻结金额': '현재 진행중인 주문이 있는 경우, 귀하의 계정의 사용 가능한 잔액에 현재 계좌의 동결금액 만큼의 금액을 자동으로 남기어 국제 배송비 지불 후 원활하게 배송할 수 있도록 합니다. 그래서 현재 계좌이체 가능 금액은 잔액-동결금액입니다.',
  申込月数: '신용월수',
  銀行振込: '은행송금',
  '请填写商品的尺寸分类。如果有多个大小，请添加行并输入大小。例M、L、XL、30cm*40cm*20cm等': '상품의 사이즈 구분을 기입해 주세요,여러개의 크기가 있으면 행을 추가하고 크기를 입력하십시오.예)M,L,XL,30cm*40cm*20cm등)',
  例: '예',
  '<span>透明购</span>': '<span>투명구매</span>',
  搜索Amazon: 'Amazon검색',
  剩余XX天hh: '남은xx일hh',
  '点击【确定】按钮，系统将自动从余额扣除当前账单<br': '[확인]버튼을 클릭하면 시스템에서 자동으로 현재 청구서가 잔액에서 차감됩니다<br',
  余额扣费汇率全部以: '잔액공제환율:15엔',
  请输入中文: '중국어 입력',
  '注册成功后国家/地区无法更改，请谨慎选择': '등록 성공 후 국가를 변경할 수 없습니다. 신중하게 선택하십시오.',
  新增银行转账方式大幅提高入账速度: '이체 방식을 추가하여 입금 스피드 올라가기',
  未选择检查选项: '검수 항목 미선택',
  '没有检查工作就可以寄出产品吗？': '검품을 안 하면 배송할수 있습니까?',
  请检查一下: '확인해 주시기 바랍니다',
  在有色的情况下: '색깔 있는 물건의 경우는',
  洗涤后颜色可能会轻微褪色: '세탁 시 색상이 옅어질 수 있습니다',
  '请避免与其他衣物混用。': '다른 세탁물과의 혼입은 피해 주십시오',
  再次: '다시',
  由于汗水或潮湿条件下的摩擦: '땀이나 습한 상태에서의 마찰로 인해',
  可能会发生变色: '변색될 수 있습니다',
  洗后有一定缩水: '세탁후 약간의 수축이 있습니다',
  米白色: '아이보리',
  '对于浅色产品，请使用不含荧光增白剂的洗涤剂。': '담색 제품에는 형광증백제가 들어있지 않은 세제를 사용해 주십시오',
  // 尺寸: '사이즈',
  相同的: '똑같은',
  在产品中: '상품중에',
  测量点: '상품중에',
  '如果您想对所有产品进行测量，请联系客服。': '모든 상품 치수를 원하시면 고객 서비스로 연락하십시오',
  淘宝: '타오바오',
  官网搜索: '공식 사이트 검색',
  提供多种支持中国采购的强大功能: '중국 구매를 강력하게 지원하는 많은 기능을 사용할 수 있습니다',
  '如果您是THE CKB会员': 'THE CKB 회원인 경우',
  提供更丰富的中国代购服务: '더 다양한 중국 구매 서비스를 이용할 수 있습니다',
  而且: '그리고',
  满满的会员专享福利: '회원 혜택 팡팡팡!',
  // 汇率: '환율',
  'THE CKB汇率': 'THE CKB 환율',
  API链接指南: 'API 링크 가이드',
  '什么是付款申请表？': '지급의뢰서는 무엇입니까?',
  发生系统账户自动提款以外的费用时: '시스템 계좌 자동납부 이외의 요금이 발생할 경우',
  '这是一份要求用户额外付费的文件。': '이용자에게 추가로 요금을 청구하는 서류입니다',
  '当用户批准付款请求时，该费用将从系统余额中扣除。': '이용자가 지불 청구를 승인한 시점에 시스템 잔액에서 요금을 이체해 드립니다',
  自签发之日起: '발행일로부터',
  如果无法在几天内确认付款: '일 이내에 지불이 확인되지 않을 경우',
  我们会自动扣除费用: '자동으로 요금을 인출해 드립니다',
  使用工具: '사용 도구',
  '产品可以直接从官网加入购物车，比如': '다음과 같은 공식 사이트에서 직접 장바구니에 제품을 추가할 수 있습니다',
  店铺已经准备好: '입력하신 스토어가 준비되었습니다',
  因为它与商店链接: '스토어와 연결되어 있어',
  无法变更为其他店铺并再次链接: '다른 스토어 및 링크를 다시 변경할 수 없습니다',
  '由于系统维护，系统服务将无法使用。': '시스템 유지 관리로 인해 시스템 서비스를 사용할 수 없습니다.',
  自动下单: '자동으로 발주',
  做好了: '완료되었습니다',
  什么是工具: '도구는 무엇입니까?',
  安装方法: '설치 방법',
  在以下位置搜索工具: '아래 위치에서 도구 찾기',
  // 下载: '다운로드',
  固定工具: '고정 도구',
  点击下单: '클릭하여 발주하기',
  点击进行产品搜索: '클릭하여 상품 찾기',
  带翻译功能: '번역 기능 포함',
  点击: '클릭',
  同类产品研究: '같은 상품을 조사하기',
  具有图像搜索功能: '이미지 검색 기능 포함',
  'THE CKB系统': 'THE CKB 시스템',
  站点: '사이트',
  该工具是: '이 도구는 ',
  'THE CKB开发的产品研究和订购的便捷工具': 'THE CKB 개발한 제품 조사 및 주문을 위한 편리한 도구',
  '如果您在THE CKB系统中使用此工具，': 'THE CKB 시스템에서 이 도구를 사용한다면',
  中国的: '중국의',
  用日语搜索产品: '한국어로 상품 찾기',
  您可以一键下单: '클릭 한 번으로 주문할 수 있습니다',
  具有同类产品研究功能: '유사한 제품 연구 기능 포함',
  '也可以比较价格，降低成本。': '또한 단가를 비교하고 비용을 절감할 수 있습니다.',
  打开网上商店: '온라인 가게를 열어주세요',
  工具: '도구',
  输入: '입력',
  // 搜索: '검색',
  添加: '추가',
  添加扩展名: '확장자 추가',
  按顺序点击: '순서로 클리하세요',
  安装: '설치',
  安装后: '설치 후',
  在地址栏的右边: '주소란 오른쪽에',
  销标记: '无需翻译',
  建议您点击置顶: '핀으로 고정하려면 클릭하는 것을 추천합니다',
  '·中国': '·중국',
  在网站上研究的产品: '사이트에서 조사된 제품들은',
  单击即可进行系统内订购: '클릭하시면 시스템 발주를 진행할 수 있습니다',
  打开官网: '공식 사이트를 열다',
  选择所需产品: '원하시는 상품을 고르세요',
  在产品详细信息页面上: '상품 상세 페이지에서',
  '添加到THE CKB购物车': 'THE CKB 장바구니에 추가',
  点击按钮: '버튼을 클릭합니다',
  '可以添加到THE CKB系统内的购物车': 'THE CKB 시스템 장바구니에 추가',
  返回系统购物车页面: '시스템 장바구니 화면으로 돌아가기',
  '我们将继续进行订购​​流程': '주문절차를 계속 진행하겠습니다',
  点击首页右上方的图标: '메인 오른쪽 상단에 있는 아이콘을 클릭하기',
  输入关键字后: '키워드를 입력 후에',
  单击搜索按钮: '검색 버튼을 클릭하세요',
  显示搜索结果: '검색 결과 표시',
  点击产品研究: '제품 조사를 클릭',
  '・直接输入日语即可用中文': '・한국어를 입력해 주세요',
  您可以在网站上研究产品和商店名称: '사이트에서 제품 및 스토어 이름을 검색할 수 있습니다',
  输入产品关键词后: '상품 키워드를 입력 후에',
  在我们的系统中注册后: '저희 시스템을 가입하신 후에',
  可用的工具: '사용 가능 도구',
  '・THE CKB系统 ・日本': '・THE CKB 시스템・한국',
  '网站・中国': '웹사이트・중국',
  与网站上的产品相似的产品: '사이트에 표시된 것과 유사한 제품',
  产品: '상품',
  可以使用图像搜索功能进行研究: '이미지 검색 기능으로 조사',
  '一键搜索THE CKB相似商品': '직행편 시스템에 표시된 상품의 유사상품을 클릭 한 번으로',
  研究可能: '리서치 가능',
  '登录THE CKB系统': '직행편 시스템 로그인',
  在产品图片的左上角: '상품이미지 왼쪽 상단에 있어',
  铲子: '삽',
  单击图标: '아이콘 클릭',
  前往官方网站: '공식 사이트로 이동하여',
  显示相似产品搜索结果: '비슷한 제품 검색 결과 보이기',
  一键点击搜索与网站上产品相似的产品: '사이트에 표시된 상품의 유사상품을 클릭 한 번으로',
  研究: '리서치',
  在目标产品图像的左上角: '대상 상품 이미지 왼쪽 상단의',
  可以研究: '리서치 가능',
  从产品搜索结果列表: '제품 검색 결과 목록에서',
  找不到您要查找的页面: '찾으려는 페이지를 찾을 수 없습니다',
  // 返回首页: '홈 페이지로 돌아가기',
  输入值的长度为: '입력값 길이:',
  目标字段可能太短或太长: '대상 필드가 너무 짧거나 길 수도 있습니다',
  请重新输入正确的内容: '정확한 내용을 다시 입력해 주세요',
  您输入的内容格式错误: '입력한 내용 형식이 잘못되었습니다',
  瑞穗银行: '미즈호 은행',
  '节假日·调休的汇款会在第二个工作日处理。': '공휴일·이동휴가 송금은 2영업일에 처리합니다',
  将在下一个工作日处理: '다음 영업일에 처리하겠습니다',
  接收人姓名: '수취인 성함',
  '请提供包含转账金额信息的图片。': '이체 금액 정보가 포함된 이미지 부탁드립니다.',
  注册转账来源账户: '계좌이체출처계정',
  输入片假名: '명칭 입력',
  必须与实际转账名称相同: '실제 계좌이체 이름과 동일해야 합니다',
  请注意输入错误: '입력 오류에 주의하시기 바랍니다',
  // 注意: '주의',
  当你取消: '취소할 때',
  '所有输入的信息将被删除。': '입력한 정보는 모두 삭제될 겁니다',
  山吹支店: '야마부키 지점',
  花旗银行: '씨티은행',
  北美: '북미',
  目前没有可用的卡片: '현재 사용할 수 있는 카드가 없습니다',
  汇款金额必须大于等于零: '송금 금액은 0 이상이어야 합니다',
  // 请选择: '선택해주세요',
  // 必填: '필수 입력 사항',
  当您输入的预定转帐日期与付款日期不符时: '입력하신 무통장입금 예정일과 착금일이 불일치할 경우',
  '收到款项后，需要办理会计复核手续。': '착금 후 경리 재심사 절차가 필요합니다',
  '请注意，付款可能需要一些时间才能到账到系统帐户中。': '시스템 계좌 입금 반영까지 시간이 걸릴 수 있으니 유의해주세요.',
  // 充值记录: '충전 이력',
  没有数据: '데이터 없음',
  '找不到银行名称，请手动输入': '은행 이름을 찾을 수 없어 수동으로 입력해 주세요',
  输入转账银行名称: '무통장입금원 은행명 입력하십시오',
  // 取消: '취소',
  报价请求: '견적 요청',
  采购现成商品: '완제품 구매',
  市场产品采购: '시장 상품 매입',
  样品订单: '샘플 발주',
  产品组合: '상품 세트',
  洗衣标签创建: '워싱라벨 제작',
  仅表: '표만',
  纽扣孔开口: '버튼 홀 열기',
  缝上布标: '천태그 재봉',
  缝上洗衣标签: '워싱라벨 재봉',
  摘除原始标签: '원택 제거',
  洗衣标签: '워싱라벨',
  布标: '천 태그',
  吊牌: '행잉 태그',
  附加项更换: '부가 항목 교체',
  放入感谢卡: '상품 감사카드 넣기',
  检查时将其放入每个产品中: '검품 시 각 상품에 넣기',
  彩带包装: '리본 포장',
  衣架: '옷걸이',
  刮刮卡盒: '스크래치 카드 박스',
  优惠券: '쿠폰 카드',
  保证卡: '보증 카드',
  使用说明书: '사용 설명서',
  替代品: '교체품',
  自己的品牌: '개인 브랜드',
  专用储物袋更换: '전용 수납 봉투 교체',
  其他配件: '기타 악세사리',
  气泡膜包装: '뽁뽁이 포장',
  拉伸膜包装: '스트레치 필름 포장',
  缓冲包装: '쿠션 포장',
  线程锁: '실록스',
  去除布标: '천태그 제거',
  去除洗涤标签: '세탁 태그 제거',
  摘除吊牌: '행잉 태그 제거',
  调整尺寸: '크기 변경',
  缝上尺码标签: '사이즈 태그 재봉',
  尺寸标签: '사이즈 태그',
  松动检查: '느슨애 대해 검품',
  包装时放入每个包装: '검품 시 각 상품에 넣기',
  丝带包装: '리본 포장',
  纸板箱: '골판지 외부 상자',
  纸板包装工作: '골판지 포장 작업',
  标签: '태그',
  托盘包装: '팔레트 포장',
  刮刮卡: '스크래치 카드',
  自有品牌运输袋: '개인 브랜드 운송 봉투',
  箱子标签: '상자 라벨',
  洗衣标: '워싱라벨',
  附加项安装更换: '부가 항목 교체',
  去除吊牌: '행잉 태그 제거',
  调整大小: '크기 변경',
  转账申请表: '이체 청구서',
  充值资金: '충전 자금',
  资金转账到各店铺: '각 스토어로의 자금 이체',
  仅限会员支付: '회원만 지불 가능',
  订单将在该店铺下单: '발주는 매장에서 진행하기 때문에',
  订购前: '주문 전에',
  '首先，您需要通过转账的方式将资金转入店铺。': '우선 이체를 통한 스토어로 자금을 옮겨야 합니다.',
  加载失败: '로드 실패',
  继续: '계속',
  请重新加载页面: '페이지를 다시 로드하십시오',
  加载中: '로드 중',
  请稍等: '잠시만 기다려주세요',
  马来语: '말레이어',
  泰语: '태국어',
  // 返回: '돌아가기',
  检查更多: '더 체크',
  演员博客: '无需翻译',
  '扣款成功的话，会发货': '출금에 성공한 경우 상품을 발송해 드립니다',
  '由于余额不足的原因无法提款的情况下，我们会停止发货作业并发送另外支付的通知。': '잔액부족의 원인으로 인출이 불가능한 경우 출고작업을 정지하고 별도 지불 안내를 보내드립니다.',
  一旦确认付款: '입금확인 되는대로',
  我们将运送产品: '상품을 발송해 드립니다',
  以免影响发货: '발송의 영향을 주지 않도록',
  '请在发货前在系统账户中准备足够的余额。': '상품 발송 전에는 시스템 계좌에 충분한 잔액을 준비해 두세요.',
  如果提现成功: '출금에 성공한 경우는',
  模板: '템플릿',
  商品管理代码: '상품관리코드',
  因为无法标明相关物流公司的状态: '해당 물류회사의 상태는 표기할 수 없으므로',
  '对不起，麻烦您了': '부탁 드립니다',
  在下面的参考文件中追踪: '아래 참고파일 추적',
  请检查: '확인해 주십시오',
  参考文件: '참고 파일',
  // 首页: '홈 페이지',
  还没有: '아직',
  未开始对应: '대응 개시되어 있지 않습니다.',
  确认管理页上的内容后: '관리화면에서 내용확인 후',
  请提交您的需求: '의뢰 제출 부탁드립니다',
  '如果您想订购多种款式，': '복수 바리에이션을 발주할 희망이 있는 경우는',
  请务必输入每个产品的详细信息: '반드시 각각의 상품 상세 정보를 입력해 주세요.',
  如果我不: '안 한다면',
  您可能无法订购多种规格: '여러 종류를 발주하지 못할 수도 있습니다.',
  感谢您的理解: '양해 부탁드립니다',
  模板文件: '템플릿 파일',
  包括相关网站说明: '无需翻译',
  同意并继续: '동의하고 계속 진행하기',
  是的: '네',
  不: '아니에요',
  等待购买: '구매 대기',
  // 已入库: '입고완료',
  有存货: '재고',
  等待入库: '입고대기',
  根据我们的检验标准判断为有缺陷: '无需翻译',
  如果您在订购时选择检验选项: '无需翻译',
  仅限新会员: '신규 회원 한정',
  您可以在以下网址体验中国进口代理服务: '아래 사이트에서 중국수입대행서비스 체험가능',
  关于以上内容: '위 내용에 대하여',
  '确认/同意': '확인/동의합니다',
  以下产品是: '아래 상품은',
  '请注意，我们无法处理': '처리할 수 없음을 주의하시기 바랍니다',
  '如有疑问，请在购买前': '의문이 있다면 구입 전에',
  请每次检查: '매번 확인 부탁드립니다.',
  侵犯专利权: '특허권을 침해합니다',
  鸦片: '아편',
  罂粟籽: '경색',
  手枪: '검총',
  这些弹药和手枪零件: '이들 총포탄 및 건총 부품',
  // 客户申请: '고객 신청',
  发货取消: '발송 취소 완료',
  '发货已取消/有货': '발송 취소 완료 · 재고 보유',
  '未知颜色/尺寸': '컬러 사이즈 불명',
  // 缺货: '품절',
  有最小订货批号: '최소 주문량이 있습니다',
  即使自动回购次数已达到上限: '자동 재매입 횟수 상한에 도달해도',
  可出货的可用库存不足: '출하 가능 양품 재고가 부족합니다',
  不良商品处理设置: '불량품 대응 설정으로',
  指定的: '지정',
  所有网站都缺货: '전 사이트 재고 소진',
  缺货补货完成: '재고소진재발주완료',
  购买已取消: '매입 취소 완료',
  有最小订货量: '최소 주문량이 있습니다',
  '您已达到最大自动回购次数。': '자동 재매입 횟수 상한에 달했습니다',
  后自动解除: '보류를 자동 해제',
  在指定时间自动解除: '지정 시간에 자동 해제',
  可以手动提前解除: '수동으로 조기 해제 가능',
  '已处于发货状态的商品不能转为库存。': '이미 출하한 상태인 상품은 출하 보류가 불가능합니다.',
  订单的所有产品状态: '주문한 전부 상품 상태',
  已经取消: '취소 완료',
  当改为: '로 변경해서',
  已清算订单: '주문을 청산합니다',
  请确认商品的作业记录: '상품의 작업이력을 확인하실 수 있습니다',
  已设置为自动下单: '자동발주를 했습니다.',
  自动排序: '자동발주를 했습니다.',
  登录我的Paypal后: '마이페이팔 로그인 후',
  单击屏幕右上角的齿轮图标: '화면 우측 상단의 톱니바퀴 아이콘을 클릭합니다.',
  在屏幕顶部: '화면 상단의',
  // 支付: '지불',
  管理自动付款: '자동 지불을 관리하기',
  在这个屏幕上: '여기 화면에서',
  您可以添加或取消定期付款: '정기결제 추가 및 취소가 가능합니다.',
  如果你想取消: '취소할 경우에는',
  从左边的菜单: '왼쪽 메뉴에서',
  单击要取消的定期付款: '취소하고자 하는 정기결제를 클릭하여',
  在右边的屏幕上: '오른쪽 화면의',
  被选中: '을 선택하셨습니다.',
  请再次确认: '재확인해 주십시오',
  '超过 10% 的用户设置': '할인된 이용자가 설정',
  会员月费: '매월의 월액 회원비는',
  我们推荐: '을 추천드립니다',
  如果是: '의 경우',
  需要进行以下操作: '이하의 조작이 필요합니다.',
  每个月必须自己支付会员费: '매월 자체 회원비 지불 작업이 필요',
  不采取行动: '대응을 하지 않고',
  会员到期后: '회원 유효기간이 경과하면',
  所有会员服务不可用: '모든 회원 서비스 이용 불가',
  再次需要办理入会手续: '다시 회원 수속이 필요',
  '不可续费功能，过了有效期就不能使用了': '지속 없음 유효기간 경과 후 이용불가 기능',
  直接从网站购物车购买: '사이트에서 직접 카트 매입',
  按图片搜索产品: '이미지로 상품 검색',
  直接购买中国产品: '중국상품 직구입',
  业界最快的物流服务: '업계에서 가장 빠른 물류 서비스',
  国际航运最低价: '최저가 국제 발송',
  其他站点合作: '기타 사이트 콜라보',
  这样的: '등',
  送货等: '납품 등',
  如果取消自动付款: '자동지불이 해제된 경우',
  您的订单将自动停止处理: '주문처리가 자동정지되어',
  导致交货延误: '배송지연으로 이어집니다.',
  会员费自动支付: '정말 회원비 자동납부를',
  可以吗: '으로 해도 될까요?',
  问卷调查: '앙케이트 조사',
  感谢您使用它: '이용해주셔서 감사합니다.',
  为了未来的服务改进: '향후 서비스 향상을 위해',
  请配合问卷调查: '앙케이트에 협력해 주십시오',
  请填写投诉内容: '불만 사항에 대해 기입해 주십시오',
  取消自动支付会员费的原因: '회원비 자동납부를 해제하는 이유',
  我想更改会员费支付方式: '회원비 지불 방법을 변경하고 싶습니다.',
  我对会员费自动续费服务功能不满意: '회원비 자동 지불 서비스 기능에 불만이 있다',
  '我想取消使用THE CKB会员': '직항편 이용을 중지하고 싶다',
  // 请填写: '기입해 주십시오',
  请告诉我你选择的理由: '에서 선택한 이유를 알려주세요.',
  不经常使用: '이용 빈도가 낮다',
  我对支持和查询的响应不满意: '서포트나 문의 등의 대응에 불만이 있다',
  我没有得到我正在寻找的服务: '자신에게 맞는 서비스가 별로 제공되지 않았다',
  '如果您想使用任何其他服务，请告诉我们。': '다른 이용하고 싶은 서비스가 있으면 기입해 주세요.',
  '如果您有任何意见或要求，请随时填写。': '의견·요망 등이 있으시면 자유롭게 기입해 주십시오.',
  请选择所需项目: '필수항목을선택해주세요',
  几个月: '개월',
  从余额中支付: '잔고에서 지불',
  付款方式: '지불 방법',
  '会员费可在到期前自动从账户中扣除。': '유효기간 만료 전 회원비 자동이체 가능',
  取消自动续费设置: '자동 인출 설정 해제는',
  可以从会员页面更改: '회원정보페이지에서변경가능',
  信用卡: '신용카드',
  '※汇率按照“xx日元=xx元”计算': "환율은 'x엔=x위안'으로 계산하겠습니다.",
  服务: '서비스',
  // 收据下载: '입금영수증다운로드',
  会员计划: '회원 플랜',
  line客服: '카카오톡 문의',
  计划更改为: '로 변경 예정',
  // 国际化
  国際料金表: '国際料金表',
  保留中: '보류중',
  国内运费2: '중국국내 운송비',
  $商品基础信息$: '商品基础信息',
  'THE CKB': 'THE CKB',
  'LINE 查询': 'kakao talk 문의',
  新限量: '신규한정',
  '您输入的值的长度对于目标字段来说可能太短或太长。 请再次输入正确的内容': '입력한 값의 길이가 대상 필드에 너무 짧거나 길 수 있습니다. 정확한 내용을 다시 입력해 주세요',
  您输入的值格式错误: '입력한 값의 형식이 잘못되었습니다.',
  错误请联系客服: '오류는 고객센터로 연락 바랍니다',
  '*汇率以“”计算': '*환율은 ""로 계산',
  我确认并同意以上内容: '위의 내용을 확인하고 동의합니다.',
  您已选择关闭自动付款: '자동결제 해제를 선택하셨습니다.',
  '★请再次确认★': '★다시 한번 확인해 주세요★',
  '[推荐设置！ 超过90%的用户设定]': '[자동결제 추천! 90%가 넘는 사용자 자동결제 중]',
  '我们建议您自动支付支付每月的会员费。': '회원비 <자동결제>설정을 하는 것을 추천합니다',
  '*如果自动付款设置为“关闭”，则需要采取以下措施。': '*자동결제가 “해제”로 설정이 되어 있는 경우 다음과 같은 조치가 필요합니다.',
  '① 每月需要缴纳会费工作': '① 회원비는 매달  직접 결제',
  '（2）如果会员有效期满而未采取第（1）项中的措施，则将无法使用所有会员服务。': '(2) 자동결제 설정을 하지 않고, 회원 기간이 만료되면 모든 서비스를 이용할 수 없습니다.',
  '→需再次办理入会手续': '→ 재입회 절차 필요',
  '不可续费功能，超过有效期后无法使用': '자동결제 해제 후 회원 기간 만료 시, 다음과 같은 기능을 사용할 수 없습니다.',
  '· 直接从中国EC网站购买购物车': '· 중국 도매 사이트에서 상품을 시스템 장바구니로 추가',
  日语和图片产品搜索: '한국어 검색 기능',
  产品订单: '제품 주문',
  '· 直接采购中国产品，最高品质检验': '· 중국 제품 직접 구매, 최고 품질 검사',
  '·行业最快的物流服务': '·업계에서 가장 빠른 물류 서비스',
  '最快、最便宜的国际运输': '가장 빠르고 저렴한 국제 운송',
  '如果取消自动付款，过期后将不会自动续充会员': '자동결제 해제 후 회원기간 만료 시 자동으로 회원갱신이 되지 않습니다. ',
  '您的订单将自动停止处理，这可能会导致交货延迟。': '고객님의 주문은 자동으로 처리가 중지되어 배송에 영향을 줄 수 있습니다.',
  '您确定要关闭会员费自动续费功能吗？': '회원 자동결제 기능을 해제하시겠습니까?',
  '感谢您使用它。 请帮助我们今后改进我们的服务。': '이용해 주셔서 감사합니다. 앞으로 저희 서비스를 개선할 수 있도록 도와주세요.',
  必需的: '필수선택',
  '取消自动缴纳会费的原因（可多选）': '회비 자동납부 취소 사유(복수응답)',
  我想按照自己的节奏使用会员服务: '개별 결제를 하고싶습니다.',
  '我对会员费自动缴费服务功能不满意（焦虑）': '회원비 자동 결제 서비스 기능에 불만족을 느낍니다.',
  我想取消乘坐直飞航班: 'THE CKB 서비스를 더 이상 이용하고 싶지 않습니다.',
  其他的: '기타',
  '请告诉我们您选择“我想取消直飞航班”的原因（可多选）': 'THE CKB를 취소하고 싶습니다"를 선택한 이유를 말씀해 주세요(복수응답 가능)',
  不常使用: '자주 사용하지 않음',
  昂贵的: '비싼',
  系统可操作性差: '시스템 운용성이 떨어짐',
  对运送速度不满意: '운송 속도 불만족',
  对产品质量不满意: '제품 품질 불만족',
  我对支持和询问的答复不满意: '저는 지지와 문의에 대한 답변이 만족스럽지 않습니다.',
  我没有得到我想要的服务: '저는 제가 원하는 서비스를 받지 못했습니다.',
  '如果您想使用任何其他服务，请告知我们。': '다른 서비스를 이용하시려면 말씀해 주세요.',
  '如果您还有其他意见或要求，请随时填写。': '또 다른 의견이나 요청사항이 있으시면 언제든지 작성해주세요.',
  '请选择需要的项目。': '필요한 항목을 선택하세요.',
  结束日期: '종료 일자',
  chrome插件: 'chrome 플러그인',
  插件简介: '플러그인 소개',
  未读: '미확인',
  请求失败: '처리 실패!',
  对应情报: '구매정보',
  '确认要追加商品吗？': '장바구니에 상품을 추가하시겠습니까?',
  该用户名已被注册: '이미 사용중인 아이디 입니다.',
  '验证码正在发送，请注意查收': '인증 코드를 발송했습니다. 귀하의 이메일을 확인해 주세요.',
  合計: '합계',
  商品SKU: '상품SKU',
  整单确认: '전체 확인',
  按SKU确认: 'SKU로 확인',
  纸板外箱: '판지박스',
  涉及药事法: '약사법 관련',
  涉及食品法: '식품법과 관련된',
  带电池: '배터리',
  木制品: '목제품',
  侵权产品: '침권 제품',
  '粉末，液体，以及易燃易爆物品': '분말, 액체, 가연성 및 폭발성 품목',
  '武器配件，管制刀具等': '무기 액세서리, 제어 칼 등',
  动植物产品: '동식물 제품',
  不满足发货重量要求: '배송 중량 요건을 충족하지 않음',
  价格过高: '비싼',
  様: '님',
  系统使用手册: '시스템 이용가이드',
  视频: '동영상',
  '订单仍在进行中，当前产生的费用并不是最终实际费用': '주문은 여전히 진행중이며 현재 발생하는 비용은 최종 실비가 아닙니다',
  市场商品采购费: '시장상품 구입비',
  既成品采购费: '기성품 구입비',
  次品重买: '불량품 재 사려',
  商品组合: '상품 조합',
  入库费: '입고비',
  商品オプション設定: '상품 옵션 설정',
  '{member}に変更予定': '{member}로 변경 예정',
  保管料: '보관료',
  吊り札掛け: '걸쇠걸이',
  段ボール外箱: '골판지 외부 상자',
  自社ブランド発送袋: '자사브랜드발송봉투',
  $接受次品重拍文案$: "『상품교환』을 지정하면, 각 상품당 X회까지 무료로 교환 대응 가능합니다.<br/>X회 이상은 매번 기존물품 매수수수료가 발생합니다(최대 교환횟수는 3회).<br/> 자동 교환 횟수가 상한(3회)에 이를 경우 대응 방식은 <br/> '이상 주문 설정'에 의해 설정 가능합니다. 시장 구매 상품의 교환은 재구매 횟수에 포함되지 않습니다.",
  $次品退货退款文案D2C$: '『반품환불』지정 시 불량품 발생 즉시 매장으로 반품 및 상품대금을 자동 환불해드리며, <br/>주문 상품이 자동 취소됩니다.',
  '当您采购的商品价格出现变化时，或不能采购时我们将为您寻找其他相同的商品，所以请告诉我您能接受的价格变动幅度。': '상품 상한가를 설정해 주십시오.선택하신 상품이 품절 등의 이유로 구매할 수 없는 경우, 설정된 상한가 내에서 똑같은 제품을 다른 매장에서 구매합니다',
  '接受次品重拍，有助于我们更好的为您完成C端订单': '정상품 재구매를 선택하시면 C단 오더를 더 잘 해드릴수 있도록 도와 드리겠습니다.',
  通常出荷: '통상 출하',
  '入金反映：約1営業日': '입금반영: 약 1영업일',
  '※週末、祝日・振替休日の振込は、翌営業日扱いとなります。': '※주말, 공휴일, 대체 휴일의 입금은 다음 영업일에 처리됩니다.',
  '振込日、振込依頼人、お受取人名、振込金額の情報が含まれる画像をお願いします。': '이체일자, 이체의뢰인, 수취인명, 이체금액 정보가 포함된 이미지 부탁드립니다.',
  '※資金チャージ、各店舗への資金振替、会員費支払いのみ対応可能': '※예치금 충전, 각 점포로 자금이체, 회원비 결제만 가능',
  '発注は店舗で行いますので、': '발주는 매장에서 진행하기 때문에',
  'ご注文前に、まず振替による店舗へ資金を移動する必要があります': '주문 전 먼저 이체를 통한 매장으로 자금을 이동하셔야 합니다.',
  $商品组合信息$: '상품 정보',
  '※同じsku商品の中で1点を採寸します': '※ 같은 sku 제품 중 1 개를 측정합니다.',
  skuの全商品採寸を希望する場合はカスタマーサービまでご連絡してください: 'sku의 모든상품 치수를 원하시면 고객서비스로 연락주세요',
  'ご注意ください：': '*주의*',
  '新商品確認サービスでは、サンプルの撮影と採寸を行います。': '사진촬영 서비스에서는 샘플 치수 및 촬영을 실시합니다.',
  '同じSKUで複数の商品をご購入の場合でも、確認対象は一つの商品に限定されます。': '선택하신 수량 내 확인 대상은 하나의 상품으로 한정됩니다.',
  '商品与运输方式不匹配，THE CKB为您推荐了更合适的运输方式，需要您进行确认': '직항편에서 배송사 변경제안 있음 지정배송사로 배송불가 (미취급상품 있음) OR 별배송사에서 좋은 조건 있음 확인 바랍니다',
  主: '본',
  子: '부',
  料金詳細: '요금 및 수수료',
  'で中国輸入代行サービス体験可能！': '중국 수입대행 서비스 체험!',
  不可展示多于X个选项: '최대 X개 전시',
  '请输入THE CKB发货单号': 'THE CKB 발송번호를 입력하세요',
  次品退货退款: '즉시 반품/환불',
  '订单中所有商品的状态为“已检品”或“已取消”时，清算订单': '주문서의 모든 상품이 정상적인 구매 OR 취소가 된 후에, 일괄적으로 정산을 합니다.',
  発送: '상품배송',
  余额支付: '예치금 결제',
  请阅读: '읽어주세요',
  请选择需要的项目: '필요한 항목을 선택하십시오',
  发货设置: '발송 설정',
  '当直发单中存在「全网断货」或「次品重拍到上限」的商品时，是否允许THE CKB直接取消发货任务': '직송 주문서에 "온라인 품절" 또는 "불량 재촬영 상한" 상품이 있을 경우 THE CKB에서 직접 발송 작업을 취소하는 것이 허용됩니까?',
  '遇到该场景时，需要每次都通过异常联络联系': '해당 장면의 경우 매번 비정상적인 연락을 해야 합니다',
  '遇到该场景时，若商品为普通商品则无需询问，剩余商品正常发货；': '해당 장면의 경우 상품이 일반상품일 경우 문의할 필요가 없으며, 나머지 상품은 정상적으로 발송됩니다.',
  '若为组合商品的子商品，则需要每次都通过异常联络联系': '결합상품의 자상품일 경우 매번 이상연락으로 연락주셔야 합니다',
  '采购商品时，没有指定类目附加项时，使用全部附加项，两者不重复': '상품 구매 시 품목별 부가사항이 지정되지 않은 경우 전체 부가사항 사용, 양자가 중복되지 않음',
  '当您订单下有该类目商品时，我们将默认为您添加以下附加服务': '주문하신 상품 중 해당 카테고리 상품이 있는 경우,아래의 옵션 설정 기본으로 합니다.',
  '規格：M': '규격 : M',
  規格: '규격',
  サイズ: '사이즈',
  '表地：綿100％': '겉감:면100%',
  '表地：': '겉감:',
  '綿100％': '면100%',
  注意事項: '주의사항',
  '1.色物の場合は、洗濯時に多少色落ちすることがありますので、他の洗濯物との混入はお避け下さい。また、汗や湿った状態での摩擦により、色落ちが生じる恐れがあります。': '1.색상의 경우 세탁시 다소 물빠짐이 있을 수 있으니 다른 세탁물과의 혼입을 피해주십시오.또한 땀이나 습한 상태에서의 마찰로 인해 물빠짐이 발생할 수 있습니다.',
  '2.洗濯後多少の縮みがあります。': '2.세탁 후 약간의 수축이 있습니다.',
  '3.生成り、淡色製品には蛍光増白剤が入っていない洗剤をご使用下さい。': '3. 생성되거나 연한색 제품에는 형광증백제가 들어있지 않은 세제를 사용하십시오.',
  明細: '회원 충전 기록',
  入金領収書ダウンロード: '입금 영수증 다운로드',
  组合名称: '조합명',
  创建附加项组合: '옵션 조합하기',
  附加项数量: '옵션 수',
  商品附加项组合: '상품 옵션 조합',
  发货附加项组合: '배송 옵션 조합',
  出库费: '출고비',
  未設定: '설정되지 않음',
  '支払依頼書とは、<br/>システム口座自動引落以外の料金が発生した場合、利用者に対して追加で料金を請求する書類です。<br/>利用者が支払いの請求を承認した時点でシステム残高から料金をお引き落としいたします。<br/>※注意点：発行日から7日以内にお支払いがご確認できない場合、自動で料金をお引き落としさせて頂きます。': '청구서는 <br/>시스템 계좌 자동이체 이외의 비용이 발생할 경우 이용자에게 추가 요금이 부과되는 서류를 말합니다.<br/>사용자가 결제 요청을 승인하면 시스템 잔액에서 비용을 차감하겠습니다.<br/>※주의사항 : 발행일로부터 7일 이내에 결제가 확인되지 않을 경우 자동으로 요금이 차감됩니다.',
  韩文名: '한글명',
  英文名: '입력하세요',
  请输入手机号: '핸드폰 번호를 입력하세요',
  都道府县英文: '선택하세요',
  市区町村英文: '시구정촌 영문',
  请输入邮编: '우편번호를 입력하세요',
  请输入英文详细住所: '자세한 주소를 입력해 주세요(영어)',
  请输入韩文详细住所: '자세한 주소를 입력해 주세요(한글)',
  追跡番号自動反映: '추적번호 자동반영',
  '每一个商品需要上传一个对应的标签文件，格式为PDF，参考如下': '각 상품마다 해당하는 라벨 파일을 업로드해야 하며, 형식은 PDF로 아래와 같습니다.',
  配送: '배송',
  国际发货合计额: '국제배송 합계액',
  '部分图片读取失败，请按需手动下载，正在开启自动下载': '일부 이미지를 읽는 데 실패했습니다. 수동으로 다운로드하십시오. 자동 다운로드를 켜는 중입니다.',
  店铺: '점포',
  中国買付を強力にサポートする機能を多数利用可能: '여러 기능을 모두 갖추고 있어 중국 제품 구매를 강력하게 지원합니다.',
  'THE CKB会員なら': 'THE 직항편 회원이라면',
  'もっと充実した中国仕入れサービスを利用可能！さらに、お得な会員限定特典満載！': '더욱 알찬 중국 구입 서비스를 이용 가능! 또한 유익한 회원 한정 혜택이 가득!',
  箱规: '상자 정보',
  已支付: '지급필',
  编辑类目附加项: '카테고리 옵션 편집',
  使用客户商品sku: '고객 상품 sku 사용',
  $次品退货退款文案$: '[반품/환불] 선택 시 불량품 발견 즉시 자동으로 해당 매장으로 반품 및 환불을 합니다.<br/> [매번 확인] 선택 시 불량품 발견 시 매번 대처 방법을 확인 합니다.특별한 조치가 있기 전까지 해당 상품은 대기상태가 되어, 배송지연으로 이어질수도 있으므로, 빠른 조치를 권장합니다.',
  '$THE CKB通用纸箱说明$': '국제배송용 고강도 견고한 판지박스를 사용하여 고품질이며 재고가 충분함',
  范围: '범위',
  全检: '전수검사',
  抽检: '추출검사',
  '发货费用总额(元)': '발송비용총액(위안)',
  发货费用总额: '발송비용총액',
  国际发货详情2: '국제출하내역',
  '金额（元）': '금액(위안)',
  重量差补扣: '중량차이공제',
  国际运费补扣总和: '국제운임공제합계',
  退款: '환불',
  '※运输公司称重比我司称重的情况下，需要补扣差额。': '※운송회사가 우리 회사의 무게를 재는 경우 차액을 공제해야 합니다.',
  '該当物流会社のステータスは表記できないため、お手数ですが、下記参考ファイルに追跡URLをご確認くださいませ': '해당 물류회사의 상태를 표기할 수 없으니 아래 참고문서에서 추적 URL을 확인해주시기 바랍니다.',
  '参考ファイル：': '참고 파일:',
  国際送料: '국제 배송료',
  本次实付商品代金: '금번 실납한 상품 대금',
  待支付商品代金尾款: '미지급 상품 대금',
  'クリックすると、商品の作業履歴をご確認いただけます！': '클릭하시면 상품 작업내역을 확인하실 수 있습니다!',
  快递公司: '물류회사',
  按照建议运输方式发货: '권장 운송 방식에 따라 발송합니다.',
  保持原运输方式发货: '원래의 운송 방식을 유지하여 발송합니다.',
  '如果此单使用多种运输方式，提交后将会拆分成多个国际发货单子单': '한 주문서가 여러 운송 방식을 사용한다면, 제출 후 여러개 국제발송 송장로 분할될 겁니다.',
  批量处理: '일괄처리',
  此国际发货单已取消发货: '이 국제 송장은 이미 발송이 취소되었습니다.',
  '成功，此国际发货单将按照建议运输方式发货': '성공하였습니다. 이 국제 송장은 건의 운송방식에 따라 발송될 것입니다.',
  '成功，此国际发货单将保持原运输方式发货': '성공하였습니다. 이 국제 송장은 건의 운송방식에 따라 발송될 것입니다.',
  物流公司不能为空: '물류 회사를 선택해야 합니다.',
  ダウンロード: '다운로드',
  '已上架(已清算)': '출고 가능(청산 완료)',
  展开全部数据: '모든 데이터 펼치기',
  单品数量: '단품 수량',
  单品落单数: '단품 낙단수',
  '库存发生变更，请重新提交订单': '재고가 변경되었으니 주문서를 다시 제출해주세요',
  成品区库存重组需收取组合费用: '완제품 지역의 재고를 재구성하려면 조합 비용이 부과됩니다.',
  使用库存会收返工费: '재고 사용 시 재작업비가 부과됩니다.',
  成品区可用的库存数量: '완제품 코너에서 사용 가능한 재고 수량',
  组合返工费用: '조합 재작업 비용',
  质检区落单的库存数量: '품질 검사 구역에서 낙제된 재고 수량',
  X期金额: 'X회분 금액',
  本期冻结总价: '당기 총 동결 가격',
  支持英文搜索: '영어 검색 지원',
  '每行一个（支持excel复制黏贴）': '한 줄에 하나씩 (excel 복사 붙여넣기 지원)',
  'お客様申請(発送キャンセル済)': '고객신청(발송취소 완료)',
  'お客様申請(発送キャンセル済・在庫保有)': '고객 신청 (발송 취소 완료 · 재고 보유)',
  'カラー・サイズ不明': '컬러 사이즈 불명',
  異常注文処理履歴: '이상 주문 처리 이력',
  在庫切れ: '재고 소진',
  予約販売: '예약 판매',
  最小注文ロット数あり: '최소 주문 로트수 있음',
  '不良品(自動再仕入れ回数上限に達していても、出荷可能良品在庫が足りません)': '불량품(자동 재매입 횟수 상한선에 도달해도 배송 가능 양품 재고가 부족합니다)',
  '不良品(不良品対応設定で「返品返金」ご指定)': "불량품 (불량품 대응 설정에서 '반품 환불' 지정)",
  '在庫切れ(自動再仕入れ回数上限に達していても、出荷可能良品在庫が足りません)': '재고 소진 (자동 재매입 횟수 상한에 도달해도 배송 가능 양품 재고가 부족합니다)',
  全サイト在庫切れ: '전 사이트 재고 소진',
  在庫切れ再発注完了: '재고 소진 재발주 완료',
  不良品返品完了: '불량품 반품완료',
  '在庫切れ(自動再仕入れ回数上限に達した)': '재고 소진(자동 재매입 횟수 상한에 도달)',
  '不良品(自動再仕入れ回数上限に達した)': '불량품(자동 재매입 횟수 상한에 도달)',
  出荷保留解除方式: '출하 보류 해제 방식',
  手動解除: '수동 해제',
  '指定時間に自動解除（手動で早期解除可能）': '지정 시간에 자동 해제(수동으로 조기 해제 가능)',
  解除時間: '해제 시간',
  '※実振込の名義と同一である必要あり。入力間違いにご注意下さい': '※실제 송금 명의와 동일해야 합니다.잘못 입력한 것에 주의해 주십시오',
  お知らせ: '알려드립니다',
  'キャンセルすると、入力した内容が全て削除されます<br/>続行してもよろしいでしょうか': '취소하시면 입력하신 내용이 모두 삭제됩니다<br/>계속 진행합니까?',
  '銀行振込(従来)': '무통장 입금(기존)',
  偏远地区费: '원거리 수송 수수료',
  超长费: '오버사이즈 요금',
  改派费: '배대지 변경 수수료',
  扣件费: '배송 정지 수수료',
  退件费: '반송 수수료',
  销毁费: '폐기 수수료',
  仓储费: '물류 창고 보관비',
  退差价: '환불',
  关税: '관세',
  特殊处理费: '특별 대응 비용',
  快递公司请求重量: '물류회사 청구중',
  我司请求重量: 'THE CKB 청구 중량',
  补扣: '추가 요금',
  订单应冻结金额: '주문에 따라 동결되어야 할 금액 ',
  名: '명',
  利用规约: '이용 규약',
  次转正提醒: '불량품 정상전환 알림',
  隐私条款: '프라이버시 조항',
  OEM条款: 'OEM약관',
  抽检比例: '추출 검사 비율',
  '抽检数量根据比例向上取整；选择抽检如发生次品，则无法发起售后': '주의해 주세요:<br/>·발취검사의 샘플수는 비율에 따라 절상하여 정수를 취합니다.<br/>·발취검사를 실시한 경우 불량품이 발생해도 A/S는 이용할 수 없습니다.<br/>·발취검사서비스 선택시 검사샘플에 불량이 검출되어도 검품되지 않은 상품은 재검사가 불가하여 모두 양품으로 입고됩니다.',
  请填写抽检比例: '추출 검사 비율을 기입해 주십시오',
  '銀行名が見つからない 手動で入力': '은행 이름을 찾을 수 없다 수동으로 입력',
  データなし: '데이터 없음',
  分期付款: '지불하러',
  '({time}に保留を自動解除)': '({time}로 보류 자동 해제)',
  KAERU工具: 'THE CKB EASYBUY',
  API連携: 'API 연동',
  に到着予定: '에 도착 예정',
  '配達が遅れています。': '배달이 늦어지고 있습니다.',
  '現在催促中でしばらくお待ち下さい。': '현재 재촉중이니 잠시만 기다려주세요.',
  何かご問題があればカスタマーサービスまでお問い合わせ下さい: '무슨 문제가 있으면 고객 서비스로 문의해 주십시오',
  '支持韩文/英文搜索': '한글/영문 검색 지원',
  到着予定時間: '도착 예정 시간',
  中国国内運送追跡番号: '중국 국내 운송 추적 번호',
  輸送中: '운송 중',
  配達済み: '배달 완료',
  '商品は受け取り済みで、入庫手配中です。1営業日以内に入庫完了予定です。暫くお待ちください。': '상품은 수령하셨고 입고 준비 중입니다.영업일 기준 1일 이내에 입고 완료 예정입니다.잠시만 기다려주세요.',
  荷物: '화물',
  クリックすると配送状況を確認: '클릭하면 배송상황 확인',
  '現時点では追跡情報を取得できません。暫くしてからもう一度お試し下さい': '현시점에서는 추적 정보를 취득할 수 없습니다.잠시 후 다시 시도해 주십시오',
  箱唛: '상자 라벨',
  '引き落としに成功した場合は、商品を発送いたします。': '출금에 성공한 경우 상품을 발송해 드립니다.',
  '残高不足の原因で引落できなかった場合は、出荷作業を停止して別途支払のご案内をお送りいたします。': '잔액 부족으로 인출이 불가능한 경우 출고 작업을 중지하고 별도 지불 안내를 보내드립니다.',
  'ご入金確認ができ次第、商品を発送いたします。': '입금 확인되는 대로 상품 발송해드리겠습니다.',
  '発送の影響を与えるないように、商品発送前にはシステム口座に十分な残高を用意しておいて下さい。': '발송의 영향을 주지 않도록 상품 발송 전에는 시스템 계좌에 충분한 잔액을 준비해 두세요.',
  商品条码上传方式: '상품 SKU 업로드 설정',
  点击查看更多: '자세한 절차는 여기에 참고해 주십시오',
  '此单包含X种运输方式，生成了Y个国际发货单': '이 송장은 X가지 운송수단을 포함하고 있으며, Y개 국제송장 생성되었습니다.',
  サービス: '서비스',
  无相关搜索结果: '관련 검색 결과 없음',
  请选择解除方式: '해지 방식을 선택하세요',
  '抱歉，当前直播内容暂不支持观看': '죄송합니다. 현재 라이브 콘텐츠는 시청할 수 없습니다.',
  请选择时间: '시간을 선택하세요',
  // 1688货盘
  下面的检索结果都是1688官方的精选商品: '아래 결과는 1688 공식 선별 상품입니다',
  '搜索1688官方精选供应商以外的店铺时，请使用URL直接搜索或KAERU工具进行对应': '1688 공식 선별 공급업체 이외의 상점을 찾을 때는 URL 직접 검색이나 Easybuy 도구를 사용하시기 바랍니다.',
  '「1688官方精选，指根据以下内容内部选定的商店」': "「1688 공식 선별'은 아래 내용을 기반으로 한 가게를 의미합니다」",
  '·良品率高·价格竞争力高于其他店·1688畅销商品': '· 품질이 우수함 · 다른 가게보다 가격 경쟁력이 높음 · 1688 인기 상품 소유',
  '『精选供应商的保证条件』': '「선별 공급업체 보증 조건」',
  '·购买后48小时内店铺发货・7天无理由退货・比其他店铺更快速退款': '· 구매 후 48시간 이내 가게 발송 · 7일 이내 무조건 반품 · 다른 가게보다 빠른 환불 처리',
  '1688原价': '정가',
  '当前会员等级享无水印图片{X}次/月，剩余{Y}次': '현재 회원 등급은 매달 워터마크 없는 이미지 {X}회 다운로드를 제공하며, 남은 횟수는 {Y}번입니다.',
  '※无水印图片次数说明': '※워터마크 없는 이미지 다운로드 횟수 설명',
  无限使用: '무제한 사용',
  '{X}次/月': '매달 {X}회',
  '6次/月': '매달 6회',
  '4次/月': '매달 4회',
  升级会员享无限次: '회원 변경',
  '抱歉，您的无水印次数已达上限，升级会员享受无限次。': '죄송합니다, 워터마크 없는 이미지 다운로드 횟수가 상한에 도달했습니다. 회원 등급 업그레이드로 무제한 이용이 가능합니다.',
  '您当前的会员等级，可享无限次“无水印”图片下载。': "회원 등급에 따라 무제한 'NO 워터마크' 이미지 다운로드를 즐길 수 있습니다.",
  无水印: 'NO 워터마크',
  有水印: '워터마크 포함',
  同款商品: '통일 상품',
  暂无相关搜索结果: '관련 검색 결과가 없습니다',
  去站外搜更多: '외부 사이트 검색',
  重新上传图片搜索: '이미지 다시 업로드하여 검색',
  '监测到您当前尚未安装KAERU插件，【站外搜】功能需要配合KAERU插件才可正常使用哦。': '현재 Easybuy 플러그인이 설치되지 않았음을 감지했습니다. 【외부 검색】 기능을 사용하려면 Easybuy 플러그인이 필요합니다.',
  '什么是KAERU插件？': 'Easybuy 플러그인이란 무엇인가요?',
  去安装: '설치하러 가기',
  暂不安装: '일시적으로 설치하지 않음',
  '1688严选': '1688 선별',
  去1688严选搜: '1688에서 엄선품로 검색',
  查看1688官方精选供应商商品: '1688 공식 선별 공급업체 상품 찾아보세요',
  'THE CKB官方精选商品': 'THE CKB 회원 공식 선별 상품',
  收起: '접기',
  展开: '더 보기기',
  '1. 1688什么是官方精选供应商': '1. 1688 공식 선별 공급업체란 무엇인가요',
  '是1688官方选定的价格更具竞争力的人气供应商。': '1688 선정 가격보다 경쟁력 있는 인기 공급업체다.',
  精选供应商的特点: '선별 공급업체의 특징',
  良品率高: '품질이 우수함',
  价格比其他店铺有优势: '가격 방면에서 다른 가게들 보다 우세함.',
  拥有人气畅销商品: '인기 상품을 보유함',
  '1688严格挑选的供应商保证以下条件': '1688 엄선된 공급업체는 다음 조건을 보장합니다.',
  '48小时内店铺发货': '48시간 이내 상품 출하',
  '7天无条件退货': '7일간 무조건 반품',
  加快退款速度: '빠른 환불속도',
  '2. 什么是受欢迎的商品': '2. 인기 있는 상품이란 무엇인가요',
  '1688根据公式保留的内部数据，我们分析客户的购买历史，偏好，趋势等，并预测客户可能感兴趣的产品。': '1688에 보관된 내부 데이터를 기반으로 고객의 구매 이력, 선호도, 추세 등을 분석하고 고객이 관심을 가질 수 있는 제품을 예측합니다.',
  '3. 为什么我们可以给予低价?': '3. 왜 저렴한 가격을 제공할 수 있는 것일까요?',
  '严格挑选的特别价格只对特定合作伙伴、企业共享。': '엄선된 특별 가격은 특정 파트너, 기업에만 공유됩니다.',
  'THE CKB通过与1688的业务合作，作为特定企业可以以特别价格购买商品，也可以提供给THE CKB的会员': 'THE CKB는 1688과의 업무제휴를 통해 특정업체로서 특별가격으로 상품을 구매하실 수 있으며 CKB 회원님께도 제공 가능',
  '4. 优点是什么': '3. 장점은 무엇인가요?',
  '根据1所描述的精选供应商的内容和条件，可以缩短订单的交货期，提高良品率。': '1에 기술된 선별된 공급업체의 내용과 조건에 따라 주문의 납기를 단축하고 상품의 품질을 높일 수 있습니다.',
  提醒: '알림',
  找同款: '동일 상품 찾기',
  'THE CKB会员特惠价': 'THE CKB 회원특가 ',
  价格竞争力高于其他店: '가격 경쟁력이 다른 가게보다 높음',
  '1688畅销商品': '1688 인기상품',
  线下: '공장 직영',
  暂无数据: '데이터 없음',
  '由于没有可用的运输方式，需要您取消发货': '사용 가능한 운송 방식이 없기 때문에, 발송을 취소해야 합니다.',
  此订单已取消发货: '이 주문서는 이미 발송을 취소했습니다.',
  无可用运输方式: '운송방식 없음',
  $国际运单号$: '국제 배송 요청 번호',
  必须: '필수 입력',
  '国家/地区': '국가/지역',
  用户协议: '동의합니다',
  登录名: '아이디',
  返回上一步: '뒤로가기',
  注册完成: '가입 완료',
  邀请码: '추천인 코드',
  '登录名/邮箱': 'ID',
  邮箱登录: '이메일 로그인',
  '注册并绑定您的THE CKB账户': 'THE CKB 계정을 등록하고 연결해 주세요',
  '只需绑定一次，后续可用{platform}直接登录': '한번만 연계하고 이후에는 {platform}로 직접 로그인 가능합니다.',
  确认绑定: '연계 확인',
  '还没有CKB账户，现在去注册并绑定': 'THE CKB 계정 미등록이므로 지금 바로 등록 및 연계를 진행해 주십시오.',
  去注册: '회원가입',
  '绑定您的THE CKB账户': 'THE CKB 계정을 가입과 연계를 실시해 주세요.',
  只看精选会员折扣价: '엄선된 공급원 할인 가격만 봅니다.',
  '抱歉，该商品暂不支持购买': '죄송합니다만, 이 상품은 구매대행이 불가능합니다.',
  '使用插件，您可以将1688等平台产品直接添加到THE CKB购物车中。': 'EASYBUY를 이용하여 1688 등의 플랫폼 제품을 THE CKB 장바구니에 직접 추가할 수 있습니다.',
  国际料金表提示: '국제 배송비에 관하여 아래의 포인트를 확인해 주시기 바랍니다:<br/>· 국제배송비는 당사 창고 실측에 따라 요금이 인출됩니다.<br/>· 당사의 측정과 물류회사의 측정 사이에 오차가 발생할 수 있습니다.<br/>· 출고 후에는 원격지 요금, 배달지 주소 변경 수수료, 크기 및 중량 초과 요금 등 추가 요금이 발생할 수 있습니다.<br/>· 물류회사로부터의 청구서를 확인하고 차액이 있는 경우에는 익월에 청구할 수 있습니다.<br/>또한, 국제 배송비 인출 시 잔액이 부족할 경우 출고가 일시 정지되고 별도 결제 안내가 발송됩니다.<br/>입금 확인 후 상품 발송이 진행됩니다.<br/>영향을 피하기 위해 상품 발송 전 시스템 계좌에 충분한 잔액을 준비해 주시기 바랍니다.',
  个人: '개인',
  企业: '사업자',
  邮箱不能为空: '※ 필수 항목입니다',
  会社编号不能为空: '※ 필수 항목입니다',
  公司名不能为空: '※ 필수 항목입니다',
  // 三方登录
  首页: '홈페이지 가기',
  '已经注册的邮件地址。请登录，进行{A}关联。': '등록된 메일 주소입니다.{A} 공동 작업을 수행하려면 로그인하십시오.',
  同意用户协议: '이용 규약에 <span>동의합니다</span>',
  '注册成功后登录名将无法更改。': '영문과 숫자의 조합',
  '6-32个字符': '6-32글자',
  '字母和数字的组合(字母区分大小写)': '문자와 숫자의 조합 (대소문자 구분)',
  '已有CKB账户，去【登录并绑定】': '이미 THE CKB 계정을 가지고 계신 경우 <span>【로그인하여 연계】</span> 해 주십시오.',
  '还没有CKB账户，现在去【注册并绑定】': 'THE CKB 계정 미등록이므로 지금 바로 <span>【등록 및 연계】</span>를 진행해 주십시오.',
  三方登录管理: '제삼자 로그인 관리',
  绑定您的CKB账户: 'THE CKB 계정을 로그인과 연계를 실시해 주세요.',
  '是否解绑{A}账户': '{A} 계정을 해제하시겠습니까?',
  绑定失败: '연계 실패',
  '您的账户已被其他账号绑定，无法绑定当前账号。': '지금 계정은 이미 다른 계정으로 연계되어 현재 계정을 연계할 수 없습니다.',
  授权回调中: '조회중...',
  授权成功: '연계 성공',
  绑定成功: '연계 성공',
  '我还没有CKB账户，现在': '',
  企业通关号码: '사업자 통관번호',
  个人通关码: '개인 통관번호',
  通关码: '통관번호',
  通关名义: '통관방법',
  '企业通关号码/个人通关码': '사업자 통관번호/개인 통관번호',
  通关码不能为空: '※ 필수 항목입니다',
  order_个人通关码: '개인 통관번호',
  个人通关码不能为空: '개인통관 번호 입력 필수',
  '相同订单下，通关码信息与第X行不一致': '동일한 주문에는 통관번호 정보가 제X행과 불일치',
  同一个订单只能存在一个OEM商品下单: '동일한 주문에 하나의 OEM 상품 주문만 있습니다.',
  '根据韩国海关的要求选择附加项：': '',
  '最终选择用企业通关来国际发货时-': '더 편리한 통관을 위해 부가항목을 선택하십시오',
  '如果是纺织品（例：衣服/被子等）': '사업자 통관으로 하시는 분들은 방직품(예:옷.이불 등).상품이라면',
  '在下单时一定需要选择水洗标制作和水洗标缝制服务！': '<span style="color:#D81515">반드시 개당 워싱라벨 제작봉제 옵션</span>을 선택해 주시길 바랍니다!',
  '如果是杂货（例：发卡/文具等）': '잡화 상품이라면(예: 머리핀/문구등) ',
  '一定在发货时选择贴原产地标服务！': '<span style="color:#D81515">반드시 국제 발송시 개당 "made in china스티커" 선택하시기 바랍니다! </span>',
  '如果不能确认请联系页面右方的客服中心服务！': '이해가 안되시는 분들은 오른쪽 아래 고객센터에 문의해주세요!',
  不再提示: '다시 표시하지 않음',
  我知道了2: '확인',
  によるサービス提供: '에서 서비스를 제공합니다.',
  注册信息隐私说明: '로그인 정보 프라이버시 설명',
  为了告知介绍大使会员的用户名: '소개한 앰배서더 회원에게 사용자 이름을 알리기 위해',
  '请不要在用户名中注册包含能够识别个人身份的信息，比如真实姓名等。': '사용자명은 본명 등 개인을 식별할 수 있는 정보를 등록하지 않도록 부탁드립니다.',
  '如果用户名中包含您的个人信息，请事先同意提供给推广者会员。': '아이디에 귀하의 개인정보가 포함되어 있는 경우 프로모터 회원에게 제공할 수 있도록 사전 동의 부탁드립니다.',
  'お客様申請(仕入れキャンセル済)': '고객신청(구매취소 완료)',
  中国国内運送状況: '중국 국내 운송 상황',
  登录失败: '아이디나 비밀번호가 5번 이상 틀려서 1시간 후에 다시 로그인해주세요.',
  // 1688国家货盘---start
  手机验证码: '핸드폰 인증번호',
  邮箱验证码登录: '이메일 인증번호 등록',
  手机号验证码登录: '핸드폰 인증번호 등록',
  使用手机号找回密码: '핸드폰 번호로 비밀번호 찾기',
  使用邮箱找回密码: '이메일 주소로 비밀번호 찾기',
  手机号验证码: '핸드폰 인증번호',
  '该手机号已被注册，请重新输入': '해당 핸드폰 번호는 이미 등록되어 있습니다. 다시 입력해 주세요.',
  '手机号验证码不正确，注册失败': '휴대폰 번호 인증번호가 틀렸습니다, 가입에 실패했습니다.',
  '手机号格式不正确，请重新输入': '번호를 확인한 후 다시 입력해 주세요.',
  '手机号验证码不正确，登录失败': '휴대폰 번호 인증번호가 틀렸습니다, 등록에 실패했습니다.',
  '验证码正在发送，请注意查收。': '인증코드를 등록 이메일 주소로 보냈습니다.',
  '已发送验证码请求，请勿重复发送请求': '요청을 보내는 중입니다. 잠시 기다려 주십시오.',
  手机号登录: '핸드폰',
  // 1688国家货盘---end
  // 为了防止冲突，最后一行不要修改，添加的翻译写在之上
  订单商品总数量: '주문상품 총수',
  '该地区不支持访问，请求地址': '이 지역에서는 액세스가 지원되지 않습니다. 주소가 요청되었습니다',
  用户IP: '사용자 IP',
  点这里给我们发送错误报告: '버그 보고서를 보내려면 여기를 클릭하세요',
  '很遗憾，这个商品不符合日本代购条件，可以看看其他商品': '죄송합니다.  이 상품은 구매대행 조건에 맞지 않습니다! 다른 상품 구매하세요',
  折扣价: '할인가격',
  未授权_: '미승인',
  已授权_: '승인됨',
  已失效_: '무효',
  品牌集: '브랜드 컬렉션',
  查看更多_: '더 보기',
  '请输入主营类目、品牌名称或风格': '메인 카테고리, 브랜드명 또는 스타일을 입력하세요!',
  什么是品牌集: '브랜드 컬렉션이란?',
  主营类目: '메인 카테고리',
  品牌_: '브랜드',
  风格_: '스타일',
  采购市场_: '구매 시장',
  可授权形式: '승인 가능 형식',
  全部_: '전체',
  普通授权: '일반',
  独家授权: '독점',
  均价范围: '평균값 범위',
  自定义_: '사용자 정의',
  已授权__: '권한 있음',
  申请中: '신청중',
  未授权__: '승인됨',
  已失效1: '무효',
  地址: '주소',
  平均客单价: '평균고객단가',
  授权类型: '유형',
  品牌风格: '브랜드 스타일',
  产品理念: '제품 이념',
  品牌说明书: '브랜드 설명서',
  授权申请: '승인 신청',
  收起筛选: '필터 접기',
  展开更多: '더 보기',
  '距离授权到期仅剩{day}天': '승인 만료까지 {day}일 남았습니다',
  品牌授权已过期: '브랜드 승인이 만료되었습니다.',
  '品牌店铺已关注，请前往商品管理-我的收藏中查看': '브랜드 점포 팔로우 성공!  상품관리-내 찜 리스트에서 확인하세요!',
  品牌店铺已取消关注: '브랜드 점포 팔로우 취소 완료',
  所有商品: '전체 상품',
  类目1: '카테고리',
  '7日上新': '업데이트(일주일 단위)',
  请输入商品名称: '상품명을 입력하세요',
  '请前往进行品牌授权后，方可购买': '브랜드 승인을 받으신 후에 구매 가능합니다!',
  新增授权任务: '새로운 승인 부여 작업',
  品牌图片: '브랜드 사진',
  品牌信息: '브랜드 정보',
  品牌名称: '브랜드명',
  品牌链接: '브랜드 링크',
  授权条件: '승인 조건',
  可授权类型: '승인 가능 유형',
  申请授权类型: '승인 신청 유형',
  请选择1: '선택하세요',
  用途: '용도',
  销售平台: '판매 플랫폼',
  平台链接: '플랫폼 링크',
  '预计月采购额（円）': '예상 월 구매액（₩）',
  '预计年采购额（円）': '예상 년 구매액（₩）',
  其他补充说明: '기타 보충 설명',
  是否需要联名: '연동이 필요합니까',
  联名需求描述: '연동 요구 설명',
  保存1: '저장',
  保存并发布: '저장 및 제출',
  授权条件1: '승인 조건',
  提示1: '안내',
  '提交授权申请后，THE CKB工作人员会在{day}个工作日内联系您。可在工作台-品牌管理查看授权进度': '신청한 후 THE CKB 직원이 {day}영업일 후에 연락 드릴 겁니다! 작업 페이지-브랜드 관리 페이지에서 진도를 확인 가능합니다!',
  '授权已保存，可在工作台-品牌管理查看授权进度': '저장 완료되었습니다! 마이페이지-브랜드 승인에서 확인 가능합니다!',
  前往查看: '더 보기',
  '前往查看>': '더 보기>',
  下载授权书: '승인서 다운로드',
  优质供应商: '우수 공급자',
  目录: '목록',
  供应商优势: '공급자 장점',
  基础信息: '기본 정보',
  热卖产品: '인기 상품',
  品牌授权书: '브랜드 승인서',
  品牌授权: '브랜드 승인',
  申请类型: '유형',
  申请日期: '시작 날짜',
  开始日期: '시작 날짜',
  结束日期1: '종료 날짜',
  新增品牌授权: '브랜드 승인 추가',
  待提交: '미제출',
  审核中: '심사중',
  已授权3: '승인 완료',
  已拒绝3: '승인 거부',
  申请信息: '신청 정보',
  审核信息: '심사 정보',
  授权状态1: '신청 상태',
  授权有效期: '유효 기간',
  重新申请: '재 신청',
  审核详情: '심사 상세',
  通过: '통과',
  时间1: '일시',
  '是否确认提交？': '제출하시겠습니까',
  '是否确认取消？': '취소하시겠습니까',
  进入品牌: '브랜드 들어가기',
  联名品牌: '콜라보레이션 브랜드',
  联名: '콜라보레이션을 합니다',
  不联名: '콜라보레이션을 하지 않습니다',
  操作后状态: '조작 후 상태',
  我收藏的品牌: '내가 찜한 브랜드',
  品牌已下架: '브랜드 이미 퇴출',
  前往品牌列表: '브랜드 리스트에 가기',
  '前往品牌列表>': '브랜드 리스트에 가기>',
  查看全部: '더 보기',
  '存在部分商品未授权，请查看详情并申请授权': '일부 상품 미승인 상태라 상세보기 및 승인 신청하시기 바랍니다.',
  '前往授权>': '승인 신청하러 가기>',
  前往授权: '승인 신청하러 가기',
  店铺余额: '점포 잔액',
  普通授权字段说明: '일반 수권: 한국에서 판매 가능해지는 것을 말합니다.',
  独家授权字段说明: '독점 수권: 유일한 독점 판매자가 되는 것을 말합니다',
  '品牌集的优势介绍 给用户带来什么': '독창성이 높은 상품 개발을 할 수 있게!',
  销售平台不能为空: '판매 플랫폼을 입력하세요. ',
  联名品牌不能为空: '콜라보레이션 브랜드를 입력하세요.',
  '品牌集的优势 用户可以获得哪些权益，在品牌集购买商品有什么优惠等等': `
      브랜드 컬렉션이란<br/>
      중국 브랜드를 구입, 판매할 때 브랜드 권한을 허가해야 합니다.<br/>
      THE CKB에서는 현시점에서 수많은 중국 브랜드의 독립적인 판매권을 취득해, 그런 브랜드를 모은 컬렉션이 여기에서!<br/>
      THE CKB를 통해 이 브랜드의 판매권을 신청할 수 있고 일정한 구매량을 달성한 경우 독점 판매권을 신청할 수 있게!<br/>
      브랜드 수권의 매력이라고 하면, ①비용 경쟁력 ②재고 안정성 ③오리지널성이 포인트로서 들수 있습니다. 게다가 브랜드의 독점 판매권을 얻는 것으로, 시장 경쟁의 배제, 가격의 자유 설정, 매상의 안정화등을 할 수 있습니다.<br/>
      중국 수입 판매를 계속하여 가격 경쟁에 휘말리지 않도록 꼭 이 기능을 활용해 주세요!
    `,
  寻找: '탐색하다',
  '验证码正在发送到您的邮箱，请注意查收': '인증 코드를 발송했습니다. 귀하의 이메일을 확인해 주세요.',
  仅限输入韩文: '한글로만 입력해주세요',
  待完善: '편집 대기',
  '密码的新建/变更': '비밀번호 작성/변경',
  请填写邮箱: '이메일 주소를 입력해 주세요',
  '正在发送请求，请稍侯': '요청을 보내는 중입니다. 잠시 기다려 주십시오.',
  次品重买1: '불량품 재매입',
  资金明细3: '계좌 내역 보기',
  商品附加项1: '상품옵션비',
  商品附加项2: '상품 옵션비용',
  押金1: '보증금',
  全检1: '전체 검사',
  手机重置密码: '핸드폰 비밀번호 재설정',
  件2: '개',
  公司英文名: '해당 회사 영어명',
  请输入英文: '영어',
  服装类目: '의복류',
  杂货类目: '잡화류',
  圣诞节HOT商品: '크리스마스 HOT 상품',
  展开更多2: '더 보기',
  没有搜索结果: '검색 결과가 없습니다.',
  默认1: '기본 주소',
  找相似1: '유사 상품 찾기',
  英文名1: '영문',
  请选择附加项3: '옵션 선택',
  选择物流公司1: '운송방식',
  起订量1: '최소 주문수량',
  价格1: '가격',
  注意3: '안내',
  使用邮箱注册: '이메일 주소로 가입하기 ',
  使用手机号注册: '핸드폰 번호로 가입하기',
  已取消1: '취소',
  收起筛选条件: '필터 조건 치우기',
  展开筛选条件: '필터 조건 확장하기',
  筛选条件1: '필터조건',
  批量修改物流: '대량 수정(물류)',
  '默认物流不可发该国家，请重新选择': '해당국가 물류지원하지 않음. 　재선택 요망',
  '第{day}期': '제{day}기',
  本期支付: '본기 지급 ',
  确定支付: '지불하기',
  '商品的供应商次品多，无法购买': '※해당공장의 제품불량률이 높아 매입이 불가합니다.',
  '※商品的供应商次品多，无法购买': '※해당공장의 제품불량률이 높아 매입이 불가합니다.',
  '商品侵权，无法购买': '※지적재산권 침해의 우려가 있으므로 구입할 수 없습니다.',
  '※商品侵权，无法购买': '※지적재산권 침해의 우려가 있으므로 구입할 수 없습니다.',
  '商品次品过多，无法购买': '※해당 제품의 불량률이 높아 매입이 불가합니다.',
  '※商品次品过多，无法购买': '※해당 제품의 불량률이 높아 매입이 불가합니다.',
  '商品缺货，无法购买': '※해당 제품은 단종이므로 매입이 불가합니다.',
  '※商品缺货，无法购买': '※해당 제품은 단종이므로 매입이 불가합니다.',
  '商品为易燃易爆产品，无法购买': '※인화성 및 기타 위험품에 해당하므로 구입할 수 없습니다.',
  '※商品为易燃易爆产品，无法购买': '※인화성 및 기타 위험품에 해당하므로 구입할 수 없습니다.',
  '商品为液体，无法购买': '※액체물에 해당하므로 구입할 수 없습니다.',
  '※商品为液体，无法购买': '※액체물에 해당하므로 구입할 수 없습니다.',
  '商品为仿牌，无法购买': '※모방품 또는 해적판에 해당하므로 구입할 수 없습니다.',
  '※商品为仿牌，无法购买': '※모방품 또는 해적판에 해당하므로 구입할 수 없습니다.',
  '商品为粉末，无法购买': '※분말물의 물품에 해당하므로 구입할 수 없습니다.',
  '※商品为粉末，无法购买': '※분말물의 물품에 해당하므로 구입할 수 없습니다.',
  '商品为未防腐处理木制品，无法购买': '※브롬화메틸 미처리 목제품에 해당하므로 구입할 수 없습니다.',
  '※商品为未防腐处理木制品，无法购买': '※브롬화메틸 미처리 목제품에 해당하므로 구입할 수 없습니다.',
  '商品为管制刀具，无法购买': '※도검류에 해당하므로 구입하실 수 없습니다.',
  '※商品为管制刀具，无法购买': '※도검류에 해당하므로 구입하실 수 없습니다.',
  '商品为动植物，无法购买': '※검역유해동식물에 해당한다고 의심되어 구입할 수 없습니다.',
  '※商品为动植物，无法购买': '※검역유해동식물에 해당한다고 의심되어 구입할 수 없습니다.',
  黑名单商品不支持下单: '블랙리스트에 있는 상품은 주문이 불가합니다. ',
  '该供应商次品多，无法购买': '해당 공장은 제품 불량률이 높아 매입이 불가합니다.',
  '该供应商因次品过多，无法购买其产品': '해당 공장은 제품 불량률이 높아 매입이 불가합니다.',
  一键设置追跡番号自動反映: '한 번의 클릭으로 트레이스 인덱스를 설정하면 자동으로 반영됩니다',
  设置当前页追迹番号反映: '현재 페이지 추적번호 반영 설정',
  开启: '켜짐',
  一件购买: '1개 구매',
  批发: '도매',
  '建议订购数：{num}': '권장 구매 수량: <span style="color:#E83D51;">{num}</span>',
  可享批发优惠价: '<span style="color:#E83D51;">도매 가격 </span>가능',
  API自动下单设定: 'API 자동주문설정',
  '当自动下单的商品不满足最小起订量，且有“一件购买”价时': '자동주문 상품이 최소구매수량 미충족, 하지만 1개 구매가 가능할때 가격 ',
  '不询问，自动下单成功（以“一件购买”价）': '알림 없음, 자동주문설정(1개 구매 가격으로 주문)',
  每次询问: '매번 알림',
  '有最小起订量限制，价格更优惠': '구매수량제한 O, 도매가 혜택',
  '无最小起订量限制，可一件购买': '구매수량제한 X, 1개 구매 가능',
  支持一件代发: '1개 구매 지원',
  '当前订单内商品不满足最小起订量，继续下单将以“一件代发”价格下单': '주문 내 상품이 최소구매수량 미충족 , 진행시 1개 구매 가격으로 청구',
  '设置为自动下单，不再询问': '자동주문설정, 다시묻지않기',
  为不超过次品退货期限次品默认退货: '【※주의】: 불량품은 전부 반품처리。',
  '约合{dollar}美元': '총{dollar}달러',
  专属折扣价: '전용 할인가',
  '月费{price}': '{price}원/월',
  'D2C订单的情况下，购买手续费为{fee1}/个，入库手续费为{fee2}/个，出库手续费为{fee3}/个，总计为{fee4}/个。': 'D2C 주문의 경우 구매 수수료 {fee1}/개, 입고 수수료 {fee2}/개, 출고 수수료 {fee3}/개, 총 {fee4}/개가 발생합니다.',
  '请注意，如果发生这些手续费，可能无法退款。': '이러한 수수료가 발생하는 경우 금액 환불이 불가능할 가능성이 높으니 유의하시기 바랍니다.',
  元_1: '위안',
  $通电不良$: '불량 원인：통전 불량<br/> 검품 기준에 의한 불량 판정',
  $通电不良$2: '통전 불량<br/> 교환시 불량 개선 가능성 없음(로트생산으로 인해)<br/> ※문제 상품 수가 많아 납기지연 가능성 대',
  $其他不良$: '불량 원인：기타불량<br/> 검품 기준에 의한 불량 판정',
  $其他不良$2: '기타불량<br/> 교환시 불량 개선 가능성 없음(로트생산으로 인해)<br/> ※문제 상품 수가 많아 납기지연 가능성 대',
  '$污渍/斑点/水印$': '불량 원인：얼룩/얼룩/비침<br/> 검품 기준에 의한 불량 판정',
  '$污渍/斑点/水印$2': '얼룩/얼룩/비침<br/> 교환시 불량 개선 가능성 없음(로트생산으로 인해)<br/> ※문제 상품 수가 많아 납기지연 가능성 대',
  $破损$: '불량 원인：파손<br/> 검품 기준에 의한 불량 판정',
  $破损$2: '파손<br/> 교환시 불량 개선 가능성 없음(로트생산으로 인해)<br/> ※문제 상품 수가 많아 납기지연 가능성 대',
  $线头$: '불량 원인：실밥<br/> 검품 기준에 의한 불량 판정',
  $线头$2: '실밥<br/> 교환시 불량 개선 가능성 없음(로트생산으로 인해)<br/> ※문제 상품 수가 많아 납기지연 가능성 대',
  $接缝不良$: '불량 원인：절개불량<br/> 검품 기준에 의한 불량 판정',
  $接缝不良$2: '절개불량<br/> 교환시 불량 개선 가능성 없음(로트생산으로 인해)<br/> ※문제 상품 수가 많아 납기지연 가능성 대',
  $抽丝$: '불량 원인：실밥<br/> 검품 기준에 의한 불량 판정',
  $抽丝$2: '실밥<br/> 교환시 불량 개선 가능성 없음(로트생산으로 인해)<br/> ※문제 상품 수가 많아 납기지연 가능성 대',
  $针眼$: '불량 원인：다래끼<br/> 검품 기준에 의한 불량 판정',
  $针眼$2: '다래끼<br/> 교환시 불량 개선 가능성 없음(로트생산으로 인해)<br/> ※문제 상품 수가 많아 납기지연 가능성 대',
  $霉菌$: '불량 원인：곰팡이<br/> 검품 기준에 의한 불량 판정',
  $霉菌$2: '곰팡이<br/> 교환시 불량 개선 가능성 없음(로트생산으로 인해)<br/> ※문제 상품 수가 많아 납기지연 가능성 대',
  $生锈$: '불량 원인：녹슨<br/> 검품 기준에 의한 불량 판정',
  $生锈$2: '녹슨<br/> 교환시 불량 개선 가능성 없음(로트생산으로 인해)<br/> ※문제 상품 수가 많아 납기지연 가능성 대',
  $商品有中文$: '불량 원인：상품위에 중국어 있음<br/> 검품 기준에 의한 불량 판정',
  $商品有中文$2: '상품위에 중국어 있음<br/> 교환시 불량 개선 가능성 없음(로트생산으로 인해)<br/> ※문제 상품 수가 많아 납기지연 가능성 대',
  $纽扣破损$: '불량 원인：버튼 파손<br/> 검품 기준에 의한 불량 판정',
  $纽扣破损$2: '버튼 파손<br/> 교환시 불량 개선 가능성 없음(로트생산으로 인해)<br/> ※문제 상품 수가 많아 납기지연 가능성 대',
  $拉链破损$: '불량 원인：지퍼 파손<br/> 검품 기준에 의한 불량 판정',
  $拉链破损$2: '지퍼 파손<br/> 교환시 불량 개선 가능성 없음(로트생산으로 인해)<br/> ※문제 상품 수가 많아 납기지연 가능성 대',
  $附属品缺陷$: '불량 원인：부속품 결함<br/> 검품 기준에 의한 불량 판정',
  $附属品缺陷$2: '부속품 결함<br/> 교환시 불량 개선 가능성 없음(로트생산으로 인해)<br/> ※문제 상품 수가 많아 납기지연 가능성 대',
  $有气味$: '불량 원인：유취<br/> 검품 기준에 의한 불량 판정',
  $有气味$2: '유취<br/> 교환시 불량 개선 가능성 없음(로트생산으로 인해)<br/> ※문제 상품 수가 많아 납기지연 가능성 대',
  $色差$: '불량 원인：색차<br/> 검품 기준에 의한 불량 판정',
  $色差$2: '색차<br/>교환시 불량 개선 가능성 없음(로트생산으로 인해)<br/>※문제 상품 수가 많아 납기지연 가능성 대',
  价格从低到高: '단가 낮은 순서로',
  价格从高到低: '단가 높은 순서로',
  默认顺序: '기본 정렬',
  复购率: '높은 재구매율',
  次品默认退货退款: '※불량품은 자동 반품됩니다',
  '请决定发生次品时，您的重拍设置': '불량 발생 시 재촬영 설정을 결정해 주십시오',
  留在购物车: '장바구니로 돌아가기',
  '商品SKU作用旨在区分相同商品的不同规格、尺寸、颜色等。': '동일 상품의 사양, 사이즈, 색상 등을 구분하기 위해 고객이 독자적으로 설정한 상품 식별 코드를 말합니다.',
  '您可以直接填写自家店铺现有的的商品SKU，也可以额外设置新的SKU。': '저희 매장 상품인 SKU를 그대로 이용하실 수도 있고, 추가로 독특한 SKU를 설정하실 수도 있습니다.',
  '用于识别不同订单。': '주문 식별에 사용됩니다.',
  '您可以直接引用自家店铺的客户订单号，': '고객의 매장 주문 번호를 직접 인용할 수 있습니다.',
  '也可以另外输入文字区分您的订单。': '주문 제목 입력도 가능합니다.',
  '例）': '예) ',
  '＜店铺订单号＞ 503-0575395-6075865': '<점포주문번호> 503-0575395-6075865',
  '＜订单标题＞ 2024年1月24日李先生的订单已读': '<주문 제목> 2020년 1월 24일 야마다님',
  '该价格仅供参考，请登录后获取实际价格信息': '이 가격은 참고용이며, 실제 가격 정보는 로그인 후 확인하실 수 있습니다.',
  '按手起批 1手={num}双': '세트부터, 1세트={num}쌍',
  商品数量选择不正确: '상품배수선택 오류',
  '在国际发货时，如果包含易碎或尖锐的物品，建议选择气泡膜或者缓冲垫。': '국제 운송을 신청하실 때 깨지기 쉬우거나 날카로운 물건이 포함되어 있다면 뽁뽁이를 선택하는 것 추천 드립니다.',
  '气泡膜体积较小，但是保护作用会比缓冲垫差一点。': '국제 운송의 뽁뽁이 서비스는 박스에 넣은 서비스인데 상품마다 뽁뽁이를 포장 원하시면 상품 구매하실 때 뽁뽁이 서비스를 선택하세요! ',
  '缓冲垫体积较大，但是保护作用较强。': '',
  '您也可以选择同时使用两种缓冲材。不管是哪种方式都无法确保100%不破损。': '혹은 CS 창구한테 연락하시길 바랍니다! 어떤 식으로든 100% 파손되지 않도록 할 수 없는 점 양해 부탁 드립니다!',
  注册或登录以查看更多信息: '더 많은 정보를 보기 위해 가입 또는 로그인하기',
  '加入CKB 会员计划以查看更多信息': '더 많은 정보를 보려면 CKB 멤버십 프로그램에 가입하세요',
  库存保管费: '재고 보관료 ',
  包裹滞留费: '소포 체류비',
  '免费滞留天数（自然日）': '무료 체류일수(자연일)',
  结算周期: '청산 주기',
  发货单编号: '출고 번호',
  滞留日期: '체류 날짜',
  发货完成日期: '출고 완료 일자',
  免费滞留天数: '무료 체류 일수',
  计费类型: '계비 유형',
  '数量(体积)': '수량( 부피)',
  体积: '부피',
  体积类型: '사이즈 규격',
  '元/个/天': '위안/개/일',
  个: '개',
  '元/m³/天': '위안/m³/일',
  明细下载: '내역 다운로드하기',
  关于超过免费保管期限的保养费: '무료 보관기간 경과에 따른 유지비에 대하여',
  超小: 'XS',
  小: 'S',
  中: 'M',
  大: 'L',
  超大: 'XL',
  '注: 体积为3边合计，小于1cm则按1cm计算': '비고: 부피는 3변의 합으로 1cm 미만일 경우 1cm로 계산하기',
  关于超过免费滞留期的滞留费: '무료체류기간이 경과한 체류비에 대하여',
  按包裹计费: '소포별 요금 계산',
  按箱子计费: '박스별 요금 계산',
  '注: 箱子体积小于1㎡则按1平方米计算': '비고: 상자의 부피가 1㎡ 미만인 경우 1㎡로 계산하기',
  '您本月库存保管费和包裹滞留费账单已生成，合计XX元。请前往"资金管理"进行查看': '이번 달 재고 보관비와 소포 체재비 청구서가 생성되어 총 XX위안입니다. "자금관리"에서 확인하세요.',
  '您本月的库存保管费和包裹滞留费账单已生成（合计XX人民币），请前往“资金管理”进行查看': '이번 달 재고 보관비와 소포 체재비 청구서가 생성되어 총 XX위안입니다. "자금관리"에서 확인하세요.',
  及以上: '~',
  包裹: '소포',
  $箱子$2: '박스',
  库龄: '재고 보관 기간',
  '3边合计': '3변 합계 사이즈',
  以上: '이상',
  '180日以上': '180일 이상',
  '365日以上': '365일 이상',
  '在庫の保管日数では、在庫あり商品の保管日数を示します': '재고 보관 일수란 재고가 있는 상품의 보관 일수입니다.',
  '在庫の保管日数に含まれる商品 = 良品 + 返品不可不良品': '재고 보관 일수에 포함되는 상품 = 양품 + 반품불가 불량품',
  '※在庫保管日数は日単位で計算され、1日未満の場合は1日となります': '※ 재고 보관 일수는 일 단위로 계산되며, 1일 미만의 경우는 1일로 계산합니다.',
  总计天数: '총 일수',
  需计费天数: '계비 일수',
  操作成功: '연계 성공',
  更新成功: '갱신 완료',
  更新中: '업무부서 처리중',
  SKU规格: '규격',
  お届け先住所の形式が正しくありません: '',
  再度確認してから提出してください: '재확인해 주십시오',

  是否使用在途库存: " '운송 중 재고' 사용 여부",
  使用1: '사용',
  '(如果您选择了「使用」，如您有处理中的库存，将会使用处理中库存进行下单(无需支付商品费用，处理中库存成品上架后即可发货))': "('사용'을 선택하면 진행중인 재고가있는 경우 진행중인 재고를 사용하여 주문합니다 (상품 대금을 지불 할 필요가 없으며 진행중인 재고의 완제품이 도착하면 배송 할 수 있음)",
  不使用1: '사용 안함',
  '(如果您选择了「不使用」，则会为您采购成品库存不足的商品)': "('사용 안 함'을 선택하면 재고가 부족한 완제품을 구매해 드립니다)",
  使用在途库存: '운송 중 재고 사용',
  不使用在途库存: '운송 중 재고 미사용',
  处理中库存提醒: '처리 중인 재고 알림',
  '以下商品有正在处理中的库存，请选择处理方式：': '이하 상품에 처리 중인 재고가 있으니 처리 방법을 선택해 주세요:',
  '不使用在途库存，直接下单重新采购': '운송 중 재고를 사용하지 않고 직접 재구매 주문하기',
  '使用处理中库存进行下单（无需支付商品费用，处理中库存成品上架后即可发货）': '처리중인 재고를 사용하여 주문하십시오 (상품 비용을 지불 할 필요가 없으며, 처리중인 재고의 완제품은 도착하면 배송 될 수 있습니다)',
  '请选择是否使用在途库存进行下单处理方式：': '주문 처리 방법으로 배송 중 재고를 사용할지 여부를 선택합니다:',
  批量优先发货: '일괄 우선 발송',
  请将优先发货筛选项改为是后操作: '우선 배송 필터를 ‘예’로 변경한 후 작동하세요.',
  请将优先发货筛选项改为是后操作1: '우선 배송 필터를 ‘예’로 변경한 후 작동하세요.',
  '批量优先发货中，请稍等1-3分钟，期间请勿重复操作': '일괄 우선 발송 중, 1~3분 정도 기다리시고, 이 기간 동안에는 작업을 반복하지 마세요.',
  在途: '운송 중',
  在途抵用: '운송 중 상품 (공제)',
  等待采购: '구매 대기 중',
  采购处理中: '구매 처리 중',
  采购完成: '구매 완료',
  国内运输中1: '중국 내 운송 중',
  已入库1: '창고 입고 완료',
  质检中1: '검품  중',
  异常处理中: '이상 처리 중',
  同意1: '동의',
  '※処理中＝ 国内運送中＋入庫済み＋検品中': '준비중＝ 국내운송중＋입고완료＋검품중',
  已经存在提前发货任务: '조기 발송 작업이 이미 존재합니다',
  购买数: '주문 소요 수량',
  处理中库存使用数: '처리 중 수량',
  是否确认批量优先发货: '대량 우선 출고 확인 여부',
  '此商品附加项只对该订单中需采购的商品生效，对库存商品不生效': '이 상품 추가 사항은 주문 시 구매하는 상품에만 적용되며, 재고 상품에는 적용되지 않습니다. ',
  选择订单数: '주문 수량',
  确认分纳发送吗: '대량 우선 발송하시겠습니까?',
  发送确认: '발송 확인',
  // sku一对多翻译
  '关联商品可以支持(1对多)的绑定啦！': '관련 상품은 일대 다수 바인딩이 가능합니다. — 관련 상품은 일대 다수의 연결이 가능합니다.  ',
  供货商品数: '공급 상품 수',
  api商品: '상품',
  选择已同步商品: '동기화 된 상품 선택',
  创建关联商品: '관련 상품 만들기 ',
  选择外部销售商品: '외부 판매 상품 선택',
  选择供货商品: '납품 상품 선택',
  选择关联的规格: '관련 규격 선택',
  保存即关联成功: '저장 후 연동 성공',
  销售商品: '판매 상품',
  请输入商品名2: '상품명을 입력하세요.',
  '当前店铺未绑定API，授权后可绑定商品，享受自动下单功能': '현재 매장에는 API가 연동되어 있어, 인증 후 상품을 연동하여 자동주문 기능을 이용하실 수 있습니다.',
  去授权: '권한 받기',
  请先去授权: '우선 권한을 받으십시오.',
  '当前店铺已绑定API，去选择要绑定的商品': '현재 점포는 API 연동이 되어 있으며, 연동 희망하는 상품을 고르세요.',
  选择销售商品: '판매 상품 선택',
  重置2: '초기화',
  选择2: '선택',
  绑定中: '연동 중',
  已关联: '기 연동',
  未关联: '미 연동',
  供货商品: '상품 공급',
  '选择OEM、组合商品': 'OEM 선택, 상품 조합',
  '绑定成功后，多个供货商品之间的库存可共用！下单时会按照顺位进行依次扣除': '연동 성공 후, 다수 공급 상품 사이의 재고 사용 가능! 주문시 순위에 따라 상품 공제',
  '请输入URL、商品名、THE CKB SKU': 'URL을 입력해주세요, 상품명, THE CKB SKU',
  主2: '주',
  商品: '상품',
  '所有供货商品库存不足时，将会采购主商品': '모든 공급 상품 재고 부족 시，주요 상품 구매 예정',
  次: '부',
  '第{num}顺位商品': '{num}순위 상품',
  设为主商品: '주요 상품 설정 ',
  规格2: '규격',
  去选择要绑定的供货商品: '연동한 공급 상품을 선택하세요',
  '可支持绑定多个商品，建议前往绑定库存商品': '다수 상품 연동 가능, 재고 상품을 연동하길 추천',
  库存商品: '재고 상품',
  是否确认删除2: '삭제 하시겠습니까',
  删除后将自动解绑该商品下已绑定的SKU: '삭제 후 자동으로 현재 상품과 연동된 SKU를 해제합니다',
  绑定成功2: '연결 성공',
  '抱歉，绑定失败': '오류, 연동 실패',
  '原因：该商品已被其他销售商品绑定，需要先解绑后才能绑定该商品。': ' 원인: 현재 상품이 이미 기타 판매상품과 연동이 되어, 먼저 연동 해제 후 현재 상품 연동 가능',
  当前被该商品绑定: '현재 이 상품에 연동되어 있음',
  解绑并绑定到当前商品上: '해제 후 현재 상품에 연동',
  最多只能绑定3个商品: '최대 3개 상품 등록 가능',
  最多只能绑定30个商品: '최대 30개 상품 등록 가능',
  供货商品库存: '공급 상품 재고',
  销售商品库存: '판매 상품 재고 ',
  '当前售卖商品库存为关联的所有供货商品的库存总和，以便您进行销售库存的预估和管理': '현재 판매 상품의 재고는 관련된 모든 공급 상품의 재고 총합으로, 판매 재고의 예측 및 관리가 용이합니다.',
  销售sku: '판매 sku',
  销售SKU: '판매 sku',
  去绑定: '연동 하기',
  修改绑定: '연동 수정',
  当前商品绑定关系: '현재 상품 연동 현황',
  '当前商品未绑定Amazon sku，请在下方搜索进行绑定': '현재 상품 Amazon sku 미 연동, 이하 검색을 진행하여 연동하십시오.',
  平台2: '플랫폼',
  '请输入要绑定的Amazon sku': '연동하려는 Amazon sku를 입력해주세요.',
  '已绑定Amazon sku': 'Amazon sku 연동 완료',
  查看商品绑定关系: '상품 인증 관계 확인',
  我知道了3: '주의사항 확인 완료',
  '当所有供货商品库存不足，将会采购主商品': '모든 공급 상품의 재고가 부족할 때, 주요 상품을 구매할 것입니다.',
  是否设为主商品: '주요 상품으로 설정 여부',
  是否解绑: '묶음 해제 여부',
  编号: 'sku',
  '暂无商品，请先去搜索商品': '현재 상품이 없습니다, 먼저 상품을 검색해 주세요.',
  '当前店铺未授权同步数据功能，授权后可绑定商品，享受自动下单功能': '현재 매장에서는 데이터 동기화 기능이 허가되어 있지 않으며, 허가 후 상품을 연동하여 자동주문 기능을 이용하실 수 있습니다.',
  '当前店铺已授权同步数据功能，去选择要绑定的商品': '현재 매장에서는 연동할 상품을 선택하실 수 있는 데이터 동기화 기능을 부여하였습니다.',
  去选择: '선택하기',
  去选择2: '선택하기',
  去选择3: '선택하기',
  '请点击“同步商品”': "동기화 상품'을 클릭해주세요",
  '可支持绑定多个商品，前往去绑定库存商品': '여러 개의 상품을 묶어서 재고 상품을 묶을 수 있도록 지원 — 여러 개의 상품을 연결해서 재고 상품을 연결할 수 있도록 지원',
  '当前商品未绑定Amazon sku,请在下方搜索Amazon sku进行绑定': '현재 상품은 Amazon sku가 연동되어 있지 않습니다. 아래에 Amazon sku를 검색하여 연동해 주세요',
  当前sku已绑定: '현재 sku 바인딩됨',
  是否解除绑定: '바인딩 해제 여부',
  三方商品关联不允许多对多: '3자 상품 관련은 다대다를 허용하지 않습니다.',
  黑名单商品不允许关联商品: '블랙리스트 상품은 연관 상품이 허용되지 않습니다',
  '该商品不在该店铺内，请重新操作': '제품이 매장에 없습니다, 다시 시도해보세요.',
  // sku一对多翻译
  '密码修改成功，请重新登录': '비밀번호 변경 성공, 다시 로그인 해주세요.',
  采购均价: '구매 평균 가격',
  欢迎使用CKB应用: 'CKB Cafe24 애플리케이션 플러그인에 오신 것을 환영합니다.',
  '请注册/登录后进行授权': '가입/로그인하여 승인하세요.',
  登录并授权: '로그인 및 승인',
  '没有账号，点击创建': '계정이 없는 경우 생성을 클릭해주세요.',
  请选择或创建一个CKB店铺进行授权: '인증할 CKB 스토어를 선택하거나 생성하세요.',
  请输入店铺名称: '스토어 이름을 입력해주세요.',
  '将会为您创建CKB店铺并与{app}进行绑定': 'CKB 스토어가 생성되어 {app} 에 바인딩됩니다.',
  '恭喜您授权成功，请开始使用CKB吧': '축하합니다, 인증이 성공했습니다. CKB 사용을 시작하십시오.',
  请勿重复授权: '두 번 승인하지 마십시오.',
  '请先选择三方商品后，再添加此商品来绑定吧！': '세 번째 플랫폼 제품을 먼저 선택하신 후 추가하여 바인딩해주세요!',
  一键添加: '일괄 추가하기',
  '※商品不良包含：次品、到错货、多件/少件情况。': '불량품에는 불량품, 잘못된 상품, 더 많은/더 적은 조각이 포함됩니다.',
  '该商品近30天不良率超过X%，请谨慎选择。': '최근 30일간 제품 불량률 > X%로 기재 부탁드립니다.',
  去找同款: '동일한 제품 찾기',
  '※回货时长超过15天。': '※반품시간> 15일.',
  '该商品近30天回货速度慢，请谨慎选择。': '이 제품은 지난 30일 동안 천천히 상품을 반품하고 있으니 참고하시기 바랍니다.',
  失效商品不允许关联商品: '유효기간이 지난 품목에 대해서는 관련 품목이 허용되지 않습니다',
  易燃易爆物品: '가연성 및 폭발성 품목',
  粉末: '분말',
  液体: '액체',
  $最后一行谢谢$: '',
  保管费计费尺寸: '상품 크기',
  // 库存保管费: '재고보관료',
  尺寸规格: '치수 규격',
  '3边总尺寸': '3단총사이즈',
  库存保管天数: '재고보관일수',
  // 单价: '단가',
  '0-180日': '0-180일',
  '181日以上': '180일 이상',
  '141cm以上': '141cm 이상',
  '{price}元/点/日': '{price}위안/개/일 ',
  // 成本计算器
  总预估成本价: '총 예상 원가',
  请先在下方选择SKU: '밑에 sku 먼저 선택해주세요',
  成本计算: '원가 계산',
  应用工具: '응용 도구',
  成本计算器: '원가 계산기',
  运输公司: '운송 회사',
  预估运输费用: '예상 운송비용',
  运输时效: '운송 시효',
  费用暂时无法预估: '비용은 잠시 예측할 수 없습니다.',
  运费估算: '운송비 예측',
  展开1: '펴기',
  更多: '더 보기',
  支持表格字段自定义展示: '테이블 필드 사용자 정의 프레젠테이션 지원',
  表格筛选: '양식 스크리닝',
  标题1: '제목',
  明细1: '내역',
  表格恢复为初始状态: '테이블을 원래 상태로 복원합니다',
  表格已恢复为初始状态: '테이블을 원래 상태로 복원 완료 되었습니다',
  约: '약',
  寄往国家: '배송지 국가',
  运送会社: '운송 회사',
  '补充手机号，获得担当优先服务!': '휴대폰 번호 추가해서 담당 서비스 우선획득!',
  立即填写: '작성하기',
  主账号余额: '본계정 잔액',
  主账号余额1: '본계정 잔액',
  立即处理: '처리하기',
  API自动下单异常: 'API 주문 이상',
  待支付账单: '미 지불 거래',
  OEM待确认报价: 'OEM 견적서 확인 대기',
  常用功能: '자주 사용 기능',
  全部功能: '전부 기능',
  '有包裹因欠费而无法发货，请尽快转账': '요금 미납으로 발송할 수 없는 국제의뢰가 있으니, 최대한 처리하십시오',
  自定义常用功能: '자주 사용하는 기능 사용자 정의',
  待处理异常订单: '미처리 이상 주문',
  组合商品落单: '조합 상품 낙하',
  重要公告: '중요 공고',
  热门活动: '인기 이벤트',
  功能更新: '기능 업데이트',
  暂无公告: '정보 잠시 없습니다',
  会员自动续费: '회원 자동 갱신',
  '条(未读)': '개 (읽지 않음)',
  'X个包裹因欠费而无法发货，请尽快充值': 'X个包裹因欠费而无法发货，请尽快充值',
  请添加常用功能: '자주 사용하는 기능을 추가하세요',
  最多添加5个常用功能: '자주 사용하는 기능 최대 5개 추가할수 있습니다',
  在库商品: '재고 상품',
  导出SKU费用明细: 'SKU 비용 내역 내보내기',
  sku费用明细: 'SKU 비용 내역',
  原因: '원인',
  当前店铺: '해당 점포',
  '标准舱客户可以提供OEM资材服务。商务舱及以上客户可以提供服装，杂货OEM服务': 'OEM(부자재) 서비스는 비즈니스 및 퍼스트 플랜만 이용할 수 있습니다.이용을 원하는 고객님들은 회원등급을 변경하시길 바랍니다.\n주의: 비즈니스 플랜은 부자재(예: 전용 OPP 봉투/ 개인 브랜드 라벨)만 제작할수 있고 퍼스트는 모든 OEM(예: 샘플이나 링크에 따라 전부 제작과 부자재 제작) 제작할수 있습니다!',
  // 清野
  水洗标名称: '워싱 라벨명',
  '在下单时，如未主动选择水洗标，将全部设为默认水洗标': '주문 시 워싱라벨을 능동적으로 선택하지 않으면 모두 기본 워싱라벨으로 설정',
  设为默认水洗标: '기본 워싱 라벨으로 설정',
  请输入水洗标名称: '워싱 라벨명을 입력해주세요',
  填写的客户商品规格将打印在水洗标上: '기입하신 고객님의 상품 규격은 워싱 라벨에 인쇄됩니다',
  '示例：L码，红色等': ' 예: L사이즈, 레드 등',
  '请输入客户商品规格  示例：L码，红色等': '고객 상품 규격을 입력하십시오.  예: L사이즈, 레드 등',
  '日本工业标准法要求产品上需要标注商品规格信息，若无规格信息，您的商品售卖可能受到影响': '상품에는 상품 규격 정보를 표시해야 하므로, 규격 정보가 없으면 상품 판매에 영향을 미칠 수 있습니다.',
  水洗标图片: '워싱 라벨명',
  '您填写的规格信息将打印在该商品的水洗标上，请您再次确认规格信息是否正确,确认后规格信息将作用在该SKU所有订单上': '작성하신 규격 정보는 이 상품의 워싱 라벨에 출력될 예정이오니, 규격 정보가 정확한지 다시 한 번 확인하시고, 확인 후 규격 정보는 이 SKU의 모든 주문에 적용됩니다.',
  '打印水洗标，需确认客户商品规格信息': '워싱 라벨 출력 시 고객의 규격 정보 확인이 필요합니다.',
  批量导入规格: '테이블에서 수정사항 도입하기',
  客户商品规格只用于在水洗标上打印: '고객 상품 규격은 워싱 라벨에 인쇄하는 데만 사용됩니다.',
  在库管理编辑: '재고 관리 편집',
  订单编辑: '주문서 편집',
  组合商品编辑: '----',
  购物车下单: '장바구니 주문',
  场景: '장면',
  '客户商品规格/客户SKU': '고객  상품의 규격/고객SKU',
  修改客户商品规格为: '고객  상품의 규격을 다음과 같이 수정합니다.',
  修改客户SKU为: '고객 SKU를 다음과 같이 수정합니다.',
  '3.导入成功后将更改客户商品SKU及客户商品规格信息': '3.에 성공하면 고객 상품 SKU 및 고객 상품 사양 정보가 변경됩니다.',
  '4.THE CKB SKU为必填项，客户商品SKU及客户商品规格不填写默认不修改': '4. 필수항목인데 고객상품 SKU 및 고객상품 규격 미작성 시 표시되지 않습니다.',
  '存在多个一样ckb sku: {sku}': '같은 ckb의 sku가 여러 개 존재합니다. {sku}',
  '{sku} 该ckb sku不存在': '{sku} 이 ckb의 sku가 존재하지 않습니다',
  客户sku过长: '고객님의 sku가 너무 깁니다(상한 100자)',
  商品规格过长: '상품규격이 너무 깁니다(상한 20자)',
  选择水洗标: '워싱라벨 선택',
  水洗标: '워싱라벨',
  请选择水洗标: '워싱라벨 선택',
  默认水洗标: '기본 워싱라벨',
  请填写水洗标名称: '워싱 라벨명을 기입해 주십시오',
  商品未填写客户商品规格: '상품 규격 미 작성',
  水洗标信息: '워싱라벨 정보',
  '读取文件中，即将更新数据': '파일을 읽는 중, 곧 데이터를 업데이트할 것입니다.',
  '商品规格/客户SKU': '상품 설명/고객 SKU',
  '根据商品上款量、收藏量、销量等数据计算': '재고 건수, 판매 수량, 매출에 근거한 가장 인기 있는 상품',
  '网商园商品涵盖男装全品类，款式多更新快，为商家和买家提供了极大的便利。': '중국 항저우시에 있는 인터넷 쇼핑몰 사업자를 위한 도매 플랫폼.타오바오의 공식 제휴처로서 다양한 제품을 제공할 수 있습니다.',
  找商品: '상품을 찾기',
  找档口: '점포를 찾기',
  热卖商品: 'HOT 상품',
  筛选: '필터링',
  发货快: '빠른 배송',
  商品丰富: '다양 상품',
  档口排序: '정렬순',
  默认排序: '디폴트순',
  今日新品: '신상품',
  每周爆款: '매주 HOT!',
  七日爆款: '주간 HOT',
  热销榜单: '종합 HOT',
  行业精品: 'WSY 엄선',
  平台销售额: '매출액순',
  实力档口: '우량점포',
  '根据档口的缺货率、次品率、发货到仓及时率得出的评分较高的档口': '재고소진률, 불량품률, 출하지연률 등이 낮아 종합적인 평가가 양호한 점포를 나타냅니다.',
  一级分类: '메인 카테고리',
  二级分类: '서브 카테고리',
  排序方式: '정렬 순',
  价格排序: '가격 저렴한 순',
  现货专区: '재고 보증 상품',
  '搜款网聚焦女装潮流，针对年轻都市丽人，提供性价比高、款式前沿的优质服装配饰。': '의류 전문 도매가 특징이며 600만개 이상의 점포와 온라인 상점의 판매자를 위한 상품을 제공하고 있습니다.',
  每日新品: '매일 신상품',
  七日热卖: '주간 인기품',
  商品榜: '전부',
  '这就是市场购！': '시장 구매!!',
  '用户下单即采，采购人员当天直接前往源头采购并检品，最快当天发货，避免国内运输耗时和中间商层层加价，有效控制成本，为客户提供优质货品。': '「시장 구매」, 고객 발주 당일에 매입 부문이 도매 시장으로부터 직접 상품을 조달하는 방법입니다.중국 국내 배송시간을 단축시킬 수 있으며, 최단 시일 당일 발송이 가능합니다.또한 도매업자 등의 중간업자를 거치지 않고 직접 매입하기 때문에 비용을 절감할 수 있습니다.',
  视频了解: '동영상 보기',
  代采平台: '구매대행 사이트',
  '以下平台支持直接采购，快挑选您心仪的商品吧！': '아래 사이트에서 상품 직접 구입 가능!',
  中国杭州第一家获淘宝官方正式授权的批发平台: '중국 항저우 최초의 타오바오 공식 허가를 받은 도매 플랫폼입니다.',
  精品男装: '항저우시에 입지!',
  源头直采: '구색이 풍부!',
  快速发货: '남성복을 중심으로!',
  采购商品2: '상품 구매하기',
  了解网站: '더 보기',
  '中国广州市最大的服装批发平台。': '중국 광저우시 최대 도매 플랫폼.의류 전문 도매가 특징이며 600만개 이상의 점포와 온라인 상점의 판매자를 위한 상품을 제공하고 있습니다.',
  精品女装: '광주시에 입지',
  一手货源: '의류 전문 도매',
  真实档口: '여성복 중심으로',
  采购流程: '구매 절차',
  平台采购将通过以下流程高效且便捷地完成: '상품을 찾고 도착까지 3단계!',
  代采优势: 'THE CKB 강점',
  '直行便提供信息透明、交易高效、服务完善的采购环境，买家可以更方便、快捷地完成采购': '더 쉽게, 더 투명하게',
  丰富的款式: '풍성한 디자인',
  '直接从中国各地主要批发市场采购，实时更新商品，紧跟最新潮流趋势。': '중국 전역의 주요 도매 시장에서 직접 구매하여 실시간으로 상품을 업데이트하고 최신 트렌드를 따릅니다.',
  极高的性价比: '효율적인 물류 시스템',
  '提供比阿里巴巴价格低一半以下的商品。通过直接采购，大幅降低中间成本。': '알리바바보다 가격이 절반 이하인 상품을 제공합니다. 직접 구매를 통해 중간 비용을 크게 줄입니다.',
  独特的商品: '유니크한 상품',
  '大量未在网上销售的独家商品，提供与众不同的独特商品选择。': '온라인에서 판매되지 않는 독점 상품을 대량으로 판매하여 차별화된 상품 선택권을 제공합니다.',
  常见问题: '자주 묻는 질문',
  '以下是一些常见问题，看能不能帮您解决问题': '자주 묻는 질문을 받았습니다. 참고하시길 바랍니다.',
  了解详情: '자세히 보기',
  '您的浏览器未安装商品导入插件，安装插件后，您才可以把找到的商品一键导入到CKB。': 'THE CKB 확장 기능:「구매 플로그인」을 설정 되어 있지 않습니다. 설정 후 마음에 드는 상품을 일괄 등록할 수 있습니다.',
  搜款网小技巧: 'VVIC 사용 가이드',
  用户当天下午2点前下单: '당일 15시전 구매',
  当天线下采购并检品出库: '매입부문이 도매시장에서 직접 상품을 매입하여 최단 2~3일내에 출고',
  商品送达: '상품 도착',
  爆款分类: '인기 종류',
  导入: '업로드하기',
  '材质为自动读取，不可编辑': '재질은 자동 읽기이므로 편집 불가',
  '商品的规格，请从选项设定画面进行编辑。未输入的情况下不显示': '규격은 상품부가 항목 추가(즉, 장바구니)화면에서 커스텀 편집하여 주시고, 입력하지 않으시면 표시되지 않습니다.',
  部分商品未关联采购链接: '일부상품은 연관 구매링크 없음.',
  待处理异常: '이상 주문',
  有1: '네',
  无1: '아니오',
  是1: '네',
  否1: '아니오',
  到货延迟: '공장측 출하 지연',
  预计发货时间: '공장측 출하 예정일',
  X件: 'X개',
  预计到货时间: 'THE CKB입고예정일',
  跟单进度: '주문거래 대응 상황',
  跟单反馈时间: '주문거래 대응 확인 시간',
  '预计发货时间：<br/>无': '공장측 출하 예정일:<br/>미정',
  无2: '미정',
  中国国内运输物流编号: '중국국내 운송 택배 번호',
  点击查看物流状态: '물류 상황을 보기',
  '已到货，入库中': '물건 도착, 입고중',
  关税报销: '',

  '商品为预售商品，商家回复预计X发货': '【예약판매상품】X 제조사 배송 예정',
  '商家还在生产中，商家回复预计X发货': '【상품 제조 중】X 제조업체 출하 예정',
  '遇到节假日（工厂放假），商家延迟到X发货': '【제조사 휴가로 인한 출하 지연】X 예상',
  '商家预计X发货，有可能会分批次发货': '【분할 발송 가능성 있음】X 제조사 출하 예정',
  '该商品正在生产中，不确认出货时间': '【제품 제조 중】출하 예정일 미정',
  '已跟商家确认最新发货时间，商家未回复': '【구입처 미회신】진척 상황을 계속 팔로우',
  '无预计发货时间，正在与您确认商品详细中': '※ 상품 종류(색상, 사이즈 등) 확인 필요',
  '商品为预售商品，商家回复预计延迟到X发货': '【예약판매 상품의 출하 지연】X 예상',
  '商家还在生产中，商家回复预计延迟到X发货': '【생산 지연으로 인한 출하 지연】X 예상',
  '遇到节假日（工厂放假），商家回复预计延迟到X发货': '【제조사 휴가로 인한 출하 지연】X 예상',
  '商家预计延迟到X发货，有可能会分批次发货': '【출하지연】X 전망.분할발송 가능성이 있음.',
  '出货时间变更，询问商家未回复出货时间，会持续跟进': '【구입처 미회신】출하 예정일 미정아라 진척 상황을 계속 대응하겠습니다.',
  '询问商家未回复出货时间，会持续跟进': '출하 예정일 미정아라 진척 상황을 계속 대응하겠습니다.',
  '出货时间变更，正在与您确认商品详细中': '※ 상품 종류(색상, 사이즈 등) 확인 필요',
  '经再次跟卖家确认发货时间，因为产品还在生产中，发货时间延迟至X': '【생산 지연으로 인한 출하 지연】X 예상',
  '已经再次跟卖家确认发货时间，发货时间提前至X': '【출하 예정일보다 빨리 납품 가능】X 예상',
  '已和商家核实是否按原计划发出，发货时间未变': '【출하 일정대로】X 예상',
  '已和商家核实是否按原计划发出，卖家暂未回复，明日会继续跟进': '【구입처 미회신】진척 상황을 계속 대응',
  '跟卖家确认，卖家扔未回复，卖家除预计发货时间X之外，未给到新的发货信息，若预计发货时间未发货，我司会继续确认': '【구입처 미회신】진척 상황을 계속 대응',
  '遇到节假日（工厂放假），商家延迟到X': '【제조사 휴가로 인한 출하 지연】X 예상',
  '商家回复产品还在生产中，预计X发货': '【생산 지연으로 인한 출하 지연】X 예상',
  '已跟商家确认最新发货时间，商家暂无法提供准确的发货时间': '【출하 예정일 미정】진척 상황을 계속 대응',
  '商家会分批发货，首次发货时间为X': '공장은 분할하여 상품을 발송할 것이며, 첫 발송 시간은 X입니다',
  正在与您确认商品详细中: '※ 상품 종류(색상, 사이즈 등) 확인 필요',
  '确认到最新状态为未发货，原因是之前商家虚假发货，预计最新发货时间为X': '【상품 미출하】원인은 이전 업체에서 허위발송을 하였기 때문이며, 예상최신발송시기는 X',
  '确认到最新状态为分批次发货，预计剩余商品最新发货时间为X': '확인해보니 최신상태는 분할출고이며, 잔여상품의 최신출고 예상시기는 X입니다',
  '确认到最新状态为未发货，原因包裹丢失，预计最新发货时间为X': '상품 미출하】원인은 원인 소포 분실, 예상 최신 발송 시간은 X',
  '确认到最新状态为未发货，商家出货时间变更': '【상품 미출하】원인은 판매자 출고시간 변경',
  '确认到最新状态为未发货，原因是之前商家虚假发货，目前暂无预计发货时间，会持续跟进': '【상품 미출하】원인은 이전 업체에서 허위발송을 하였기 때문이며, 예정 출하 날짜 없어서 계속 대응하겠습니다',
  '确认到最新状态为未发货，原因包裹丢失，目前暂无预计发货时间，会持续跟进': '【상품 미출하】원인은 원인 소포 분실하였기 때문이며, 예정 출하 날짜 없어서 계속 대응하겠습니다.',
  '确认到最新状态为未发货，商家出货时间变更-商家回复产品还在生产中，目前暂无预计发货时间，会持续跟进': '【상품 미출하】원인은 판매자 출고시간 변경 - 판매자 답변 제품은 아직 생산중이기 때문이며, 예정 출하 날짜 없어서 계속 대응하겠습니다.',
  '确认到最新状态为未发货，商家出货时间变更-商家回复产品还在生产中，预计X发货': '【상품 미출하】원인은 판매자 출고시간 변경 - 판매자 답변 제품은 아직 생산중이며 X 발송예정',
  '确认到最新状态为未发货，商家未回复，目前暂无预计发货时间，会持续跟进': '【상품 미출하】공장측  미회신 상태이라 출하 예정일 미정, 진척 상황을 계속 대응하겠습니다.',
  '已为您中途确认，商家生产计划有调整，预计X发货': '【상품 미출하】공장측 생산 계획 변경,X 출하예정',
  '已和商家核实是否按原计划发出，发货时间未变，X': '【출하 일정대로】X 예상',
  '已经连续Y次（读取采购确认最近连续次数“需持续确认预计发货时间”）跟卖家确认，卖家扔未回复，卖家除预计发货时间X之外，未给到新的发货信息 若预计发货时间未发货，我司会继续确认': '【상품 미출하】 공장측 연속 X회 소식을 읽지 않고 무시하는 상태중이라 출하 예정일 미정, 진척 상황을 계속 대응하겠습니다',
  '确认到最新状态为入库少件，剩余商品预计X到仓（预计到仓时间规则=预计发货时间+3天同现在）': '【상품 수량 차이】 부족품의 재발송을 구입처에 연락 완료,X THE CKB창고로 입고예정 (※출하예정일로부터 3일째 예상합니다.어디까지나 참고 정보로서 이해해 주십시오)',
  '确认到最新状态为入库少件，剩余商品，商家未回复，目前暂无预计发货时间，会持续跟进': '【상품 수량 차이】부족품의 재발송 시간 미정,공장측 미회신 상태이라 진척 상황을 계속 대응하겠습니다.',
  '确认到最新状态为入库少件，剩余商品，商家回复暂无预计发货时间，会持续跟进': '【상품 수량 차이】부족품의 재발송 시간 미정,진척 상황을 계속 대응하겠습니다.',
  '尚处在中国国内运输中，之前商家提供的物流单号有误，现已更正，预计X到仓': '【중국 국내 배송 중】이전 업체에서 제공한 송장번호가 잘못되어 정정되었으며 X 입고예정',
  '尚处在中国国内运输中，因运输途中包裹丢失，商家已补发，预计X到仓': '【중국 국내 배송 중】운송도중 소포분실로 인해 업체에서 재발급하여 X 입고예정',
  '尚处在中国国内运输中，确认因物流公司运力不足，物流缓慢，预计X到仓': '【중국 국내 배송 중】물류회사 수송력 부족으로 물류가 더딘 것으로 확인되어 X 도착예정',
  '尚处在中国国内运输中，确认因天气因素，物流缓慢，预计X到仓': '【중국 국내 배송 중】기상요인으로 인해 물류가 더딘 것으로 확인되며 X 도착예정',
  '尚处在中国国内运输中，确认因中国节日因素，物流缓慢，预计X到仓': '【중국 국내 배송 중】중국 명절 사정으로 물류가 더딘 것으로 확인되어 X 도착예정',
  '包裹已签收，正在紧急入库中': '【수취완료】THE CKB창고 입고 작업 중',
  '确认到最新状态为中国国内运输中，商家分批次发，分包物流已新增，预计X到仓': '【중국 국내 운송 중】분할 발송에 따른 여러 배송 전표 발행물류번호 갱신 완료: X 도착 예정',
  '确认到最新状态为入库少件，剩余商品预计X到仓': '【상품 수량 차이】부족분의 재발송을 구입처에 연락 완료, X THE CKB창고 입고 예정',
  '确认到最新状态为中国国内运输中，预计X到仓': '【중국 국내 배송 중】X THE CKB창고 입고 예정',
  轻度: '약간 정도',
  中度: '중간 정도',
  重度: '심각 정도',
  '10cm以上': '10cm 이상',
  自动处理剩余时间: '자동 반품 남은 시간',
  最新问题时间: '연락일',
  自动处理时间: '자동 반품 시간',
  异常情形: '불량 상황',
  异常图片: '불량 사진',
  异常数量: '수량',
  '遇到需要选择良品入库或次品退货异常需要您确认时，请在72小时内确认，超过72小时系统将自动选择次品退货': '※불량품에 관한 대응 기한은 72시간입니다.72시간 이내에 처리되지 않을 경우 자동 반품이 되며, 제조사에 반품 절차를 진행해 드립니다.',
  $通电不良$9: '통전 불량',
  '$材质、面料差异$9': '원단이 달라',
  $设计差异$9: '디자인이 달라',
  $尺码差异$9: '사이즈가 달라',
  $logo差异$9: 'Logo가 달라',
  $配件差异$9: '부속품이 달라',
  $商品上有中文$9: '중국어 표기',
  $颜色差异$9: '상품 색상 차이 있음',
  'Paypal入金后，如果返金情况，手续费扣除不能返还': 'PAYPAL로 입금 후 입금된 경우 수수료 차감은 환불 불가',
  修改手机号: '핸드폰 번호 수정 ',
  '※多次更换变成了同样的不良品。即使重新更换也没有改善不良品的可能性(因为是批量生产)。不良在容许范围内的情况下，建议允许入库': '교환시 불량 개선 가능성 없음(로트생산으로 인해)',
  '※问题商品数量多，交货期延迟的可能性大。不良在容许范围内的情况下，建议允许入库': '※문제 상품 수가 많아 납기지연 가능성 대',
  自动退货: '자동 반품',
  注意4: '*주의하십시오',
  重新上传: '다시 업로드하기',
  继续上传: '계속 업로드하기',
  重复信息: '重複内容',
  行目: '목차',
  '请确认重复信息，若确认请点击继续上传，否则请重新上传修改后的文件。': '중복정보를 확인하시고 확인되시면 계속 올리기를 누르시고, 그렇지 않으시면 수정된 파일을 다시 올려주시기 바랍니다.',
  存在重复的乐天SKU: '存在重复的乐天SKU',
  存在重复JANcode: '存在重复JANcode',
  存在重复商品SKU: '이미 존재하고 있는 상품 관리 코드',
  去原网站选品2: '원 사이트에 가서 상품 고르기',
  去原网站选品: '원 사이트에 가서 상품 고르기',
  'THECKB系统默认入金领收书和领收书上的抬头为您的账户名称，前述文件仅证明与该账户相关的入金和订单情况。如您有正当理由需要将抬头修改为个人名称或法人名称，请您自行修改。修改之前，请您仔细阅读并确认以下内容：': 'THE CKB系统默认入金领收书和领收书上的抬头为您的账户名称，前述文件仅证明与该账户相关的入金和订单情况。如您有正当理由需要将抬头修改为个人名称或法人名称，请您自行修改。修改之前，请您仔细阅读并确认以下内容：',
  '本公司和THE CKB因信息保护原因无权对您提供的个人名称或法人名称进行审查。': '本公司和THE CKB因信息保护原因无权对您提供的个人名称或法人名称进行审查。',
  '您承诺您提供的抬头内容（个人名称或法人名称）准确无误，并符合相关法律法规的规定。': '您承诺您提供的抬头内容（个人名称或法人名称）准确无误，并符合相关法律法规的规定。',
  '您承诺更改抬头后的领收书和入金领收书不会用于任何虚假计账、逃税或其他违法行为。': '您承诺更改抬头后的领收书和入金领收书不会用于任何虚假计账、逃税或其他违法行为。',
  '因由您自行更改抬头的入金领收书和领收书导致的任何法律、税务或其他相关问题，均由您自行承担全部贵任。本公司对由您自行更改抬头的入金领收书和领收书引发的任何直接或间接损失概不负责。': '因由您自行更改抬头的入金领收书和领收书导致的任何法律、税务或其他相关问题，均由您自行承担全部贵任。本公司对由您自行更改抬头的入金领收书和领收书引发的任何直接或间接损失概不负责。',
  '因由您自行更改抬头的入金领收书和领收书导致本公司受到任何形式的税务检查、法律追诉、罚款或其他损失，您将承担所有赔偿责任（包括直接损失和预期利益损失）。': '因由您自行更改抬头的入金领收书和领收书导致本公司受到任何形式的税务检查、法律追诉、罚款或其他损失，您将承担所有赔偿责任（包括直接损失和预期利益损失）。',
  '请在继续操作前，勾选以下选项以确认您已阅读并同意上述免责声明': '请在继续操作前，勾选以下选项以确认您已阅读并同意上述免责声明',
  '我已阅读并同意上述免责声明的内容，并确认由我自行承担更改领收书抬头所引发的所有法律和财务责任。': '我已阅读并同意上述免责声明的内容，并确认由我自行承担更改领收书抬头所引发的所有法律和财务责任。',
  '设置完后，每次下载都使用该抬头，不再询问': '设置完后，每次下载都使用该抬头，不再询问',
  领受书抬头设定: '领受书抬头设定',
  同意免责声明并保存: '同意免责声明并保存',
  免责声明: '免责声明',
  保存前请先阅读免责声明: '保存前请先阅读免责声明',
  不询问: '不询问',
  请输入内容: '请输入内容',
  领授书抬头: '领授书抬头',
  请输入领授书抬头: '请输入领授书抬头',
  同意免责声明: '同意免责声明',
  免责声明标题: '免责声明标题',
  '口每次下载都使用该抬头，下次不再询问。': '口每次下载都使用该抬头，下次不再询问。',
  费用说明: '비용 명세',
  //   韩国仓
  品牌所在地: '브랜드 소재지',
  您获得X笔返金: '요금 반환 처리되었습니다.',
  金额1: '금액',
  立即查看: '확인하기',
  '超过60天用户未处理，系统已自动处理': '60일 이상 사용자가 처리하지 않으면 시스템이 자동으로 처리 되었습니다.',
  '采购中发起异常，请在60个自然日处理，超时系统将自动处理为取消。': '구매중 이상발생시 60일 자연일 처리하시길 바랍니다.  시간 초과되면 시스템은 자동취소 처리 됩니다.',
  发货地: '발송지',
  韩国: '한국',
  中国: '중국',
  系统异常: '에러있음, 고객 서비스센터로 연락주십시오',
  重新加购: '장바구니에 추가',
  原商品尺码: '원본 상품 사이즈',
  购买链接: '상품 URL',
  详细地址不能超过40个字符: '상세 주소는 40개 글자 초과 불가',
  结算金额: '결제 금액',
  '待支付的订单才能重新支付，请确认后重新选择': '아직 결제되지 않은 주문에 대해서는 환불이 가능합니다.',
  商品材质: '상품 소재',
  春节前纳品oem商品截单日: '< 설날 전 납품oem 상품 마감일 >',
  服装杂货: '의류잡화',
  '★12/25（水）': '★12/25',
  '辅料（纸盒，特殊纸袋，opp袋）': '부재료(종이박스,특수종이봉투,opp봉투)',
  '★1/5（日）': '★1/5',
  '★1/15（水）': '★1/15',
  '辅料（布标，纸标，说明书）': '부재료(포표, 종이표, 설명서)',
  'oem订单请尽快下单！': 'oem 주문은 최대한 빨리 넣어주세요!',
  '※oem工厂春节休息时间：约1月初~2月中旬': '※oem공장 설날휴무기간 : 약 1월초~2월중순',
  '※截单日之后也可以下单，但是工厂发货基本会延迟到2月下旬及以后~2月中旬': '※오더 마감일 이후에도 주문이 가능하나, 공장 출하는 기본적으로 2월 하순 이후까지 지연될 수 있습니다.',
  '※每个工厂的情况不同，截单日之前的订单也会有春节后发货的可能性': '※공장마다 사정은 다르며, 마감일 이전 주문건도 설날 이후에 발송될 가능성이 있습니다.',
  成品采购春节停止下单时间: '< 기성품 구매 설날 주문중지 시간 >',
  '１月２２日（水）~２月４日（火）': '1월 22일 ~ 2월 4일',
  建议春节前尽快囤货: '설날 전에 가능한 한 빨리 재고를 비축할 것을 건의합니다.',
  '※由于部分店铺已经开始休业，1月22日之前下单的商品也有节前发不出货的可能，商品状态会停滞在：***，请谅解！有需要取消的可以联系客服确认': '※일부 매장 휴무로 인해 1월 22일까지 주문하신 상품은 명절 전 출고가 되지 않을 수 있으며, 상품 상태가 정체될 수 있으니 양해 부탁드립니다! ',
  '※１月２２日（水）~２月４日（火）的订单我们也受理，统一在2月4日之后采购': '※1월 22일(물)~2월 4일(화) 주문은 저희도 접수하고 일괄적으로 2월 4일 이후 구매합니다.',
  春节前希望发货的发货委托制作的推荐期间: '<설날 - 국제 운송에 대해> ',
  船运节前出货发货依赖截单时间: '설날전 국제출하 차단기간 ',
  空运节前出货发货依赖截单时间: '',
  '1月20日（月）18时': '1월 20일  18시',
  '1月24日（金）12时': '',
  请提前安排发货: '미리 발송해 주시길 바랍니다!!',
  市场购春节停止拿货时间: '< 시장 구매 설날 상품 수령 중단 기간 >',
  '1月18日（土）~2月4日（火）': '1월 18일~2월 4일 ',
  市场购商品请在1月27日之前囤货: '시장에서 상품을 구매하려면 1월 27일까지 사재기를 하십시오.',
  '※由于部分市场已经开始休业，1月18日之前下单的市场购商品也有拿不到货的可能，商品状态会停滞在：***，请谅解！有需要取消的可以联系客服确认': '※일부 시장은 이미 휴업에 들어갔기 때문에 1월 18일까지 주문하신 마켓에서 상품을 받지 못할 수도 있으며, 상품 상태는 정체될 수 있는점 양해 부탁드립니다! ',
  '※1月18日（金）~2月4日（火）休的市场购订单，统一在2月4日之后拿货': '※1월18일(금)~2월4일(화)휴가 마켓오더, 2월4일 이후 일괄수령 가능!',
  '（注文，寻源）工厂停止生产': '< 공장 휴무(주문,oem 신청) 공장 생산중단 >',
  '1月16日（水）~2月4日（火）休': '1월 16일~2월 4일 ',
  '由于OEM商家基本已经开始休业，1月16日（水）~2月4日（火）休的oem寻源和订单，基本会在2月4日之后出货': 'OEM 업체들은 기본적으로 휴업에 들어갔기 때문에 1월 16일~2월 4일에 OEM 공급처 및 주문은 기본적으로 2월 4일 이후에 출고됩니다.',
  '承接订单，提前咨询，提前沟通，锁定库存，准备材料': '',
  '商家提前排期，先下单先出货': '',
  '成品订单 停止采购！': '< 기성품 주문, 구매 중지 >',
  '※由于商家已经开始休业，１月２２日（水）~２月４日（火）的订单，统一在2月4日之后采购。': '※공장 휴무로 인해 1월 22일~2월 4일 주문은 2월 4일 이후에 일괄 구매합니다.',
  '※由于商家恢复营业的时间不同，2月4日营业再开后，部分商品也有可能在2月中旬才能发货，请谅解': '※공장 영업 재개 시점이 다르기 때문에 2월 4일 영업 재개 후 일부 상품은 2월 중순에나 출하가 가능할 수 있으니 양해 부탁드립니다.',
  '不能采购，但是承接订单，提前咨询，提前沟通，锁定库存': '구매는 불가하나 주문접수, 사전문의, 사전소통, 재고잠금!',
  直行便仓库休息时间: '< THE CKB 창고휴뮤시간 >',
  'D2C（仓库发货停止）': 'D2C',
  '1月28日（火）~2月2日（日）': '1월 28일 ~ 2월 2일 ',
  'B2B（仓库发货停止）': 'B2B',
  '1月27日（水）~2月4日（火）': '1월 27일~2월 4일',
  '发货依赖正常受理，节后顺次发货': '배송은 정상접수에 의존하며, 명절 이후 순차배송',
  '订单正常受理，采购和发货在2月中旬顺时恢复': '주문은 정상적으로 접수되며, 구매 및 발송은 2월 중순에 재개됩니다.',
  总发货数量: '총 출고 수량',
  公告: '알림',
  /** 新会员 */
  免费会员: '비회원',
  '参考购买金额：每月不超过2万日元': '',
  免费: '무료',
  'EC 网站商品采购': 'EC홈페이지 상품구매',
  '2次/月': '2회/월',
  类似图片搜索: '유사 이미지 검색',
  类似图片搜索2: '유사 이미지 검색',
  '3次/天': '3회/일',
  日本标准质检: '',
  品牌代理销售权: '도매상품 및 브랜드 대행',
  '与日本 EC 网站系统联动和代发货服务': '',
  自定义选项和材料使用: '옵션 서비스 사용',
  '简单 OEM 支持': '',
  系统聊天支持: '시스템 채팅 지원',
  '如果需要体验更多特典，可以在这里升舱为': 'さらに多くの特典を体験するには',
  推荐: '추천',
  '参考购买金额：30万～100万日元/月': '',
  商业和企业客户的费率计划: '상업 및 기업고객의 요율계획',
  '商业计划和付费的第一计划提供的服务没有太大区别，但根据购买金额的不同，费用差异很大。 查看这两个计划的基本费用和成本，以找到更有效地支持您的业务的最佳计划。': '비즈니스 플랜과 퍼스트 플랜이 제공하는 서비스는 크게 다르지 않지만 구매 금액에 따라 비용 차이가 큽니다. 두 가지 프로그램의 기본 비용과 비용을 확인하여 비즈니스를 보다 효과적으로 지원할 수 있는 최적의 회원을 찾으십시오.',
  '参考购买金额：每月100万~300万日元': '',
  '参考购买金额：每月300万日元以上': '',
  稍后处理: '닫기',
  包含标准计划的所有服务: '이코 노미 플랜을 포함한 모든 서비스',
  '完全支持OEM/ODM': '잡화 및 의류 OEM 지원',
  '完全支持OEM/ODM1': '부자재 OEM 신청 가능',
  免费样品提供: '',
  '1对1特别商品提案': '',
  系统聊天及专属Chatwork群组: '시스템 채팅 및 전용 카카오톡 매니저',
  品牌独占销售权及优惠价格采购: '브랜드 독점 판매권 및 우대 가격 구매',
  首月0元: '첫달 0원',
  '原价9800元/月': '원가9900원/월',
  '系统聊天和 LINE 专属支持': '시스템 채팅 및 카카오톡 전용 지원',
  试用1个月免费: '첫달 10원으로',
  '已为您自动创建店铺，如有需要，您可自行修改店铺信息': '점포가 자동으로 생성되었습니다. 필요에 따라 점포 정보를 변경할 수 있습니다.',
  下单成功2: '주문완료',
  '请及时留意订单发货情况。商品到达仓库后，您可创建国际发货单，将商品发送至您的地址。': '주문해 주셔서 감사합니다. 상품이 당사 창고에 도착한 후, 국제 배송 의뢰를 작성하여 지정된 주소로 발송할 수 있습니다.',
  CKB执行: 'THE CKB',
  采购: '구입',
  CKB仓库: 'THE CKB창고/입하',
  检品上架: '검품/국제배송의뢰',
  用户执行: '고객님',
  创建国际发货单: '작성',
  运输: '운송',
  收货: '배송지',
  查看订单: '주문 확인하기',
  '如何创建国际发货单？': '국제운송 의뢰를 어떻게 신청합니까?',
  '很抱歉，本月采购次数已用完': '죄송합니다, 이번 달의 구입 횟수를 다 사용했습니다.',
  '非会员每月仅限2次采购机会，升级会员后不限次数。': '비회원은 월 2회까지 구매가 가능합니다. 회원 업그레이드 후에는 무제한으로 이용하실 수 있습니다.',
  '非会员首次开通9800标准仓会员，首月仅需0元。': '※ 첫달 10원으로 이코노미 회원(원가 9,900원/월)에 입회할 수 있는 캠페인 실시 중! 꼭 검토해 주세요!',
  业务模式选择: '업무 모드 선택',
  店铺设置: '점포 설정/매입',
  '请选择您首先要尝试的业务模式，后续可切换': '시도해보고 싶은 업무모드를 선택해주세요. 나중에 변경 가능합니다.',
  'b2b 我们支持持有库存并将其运送到您的家庭、内部仓库或国内电子商务仓库的操作。': 'B2B: 상품을 CKB 사내창고, 자택 또는 다른 한국 국내 주소에 배송 가능합니다.',
  'd2c 支持从一点到直接交付给最终用户的操作': 'D2C: 1건에서 직접 최종 사용자에게 전달할 수 있습니다.',
  'THE CKB（直行便）标准会员计划.随心采购': '표준한 회원 프로그램, 마음 대로 구매할 수 있게!',
  '为个人到法人寻找符合需求的采购服务的最佳选择。从免费计划到免手续费的标准会员计划，提供丰富的福利以支持业务发展。': '개인이 법인에 가서 요구에 맞는 구매 서비스를 찾는 최선의 선택입니다. 무료 프로그램부터 수수료가 없는 표준 회원 프로그램까지 다양한 혜택을 제공하여 비즈니스를 지원합니다.',
  当前等级: '현재 등급',
  免费寻源: '무료 견적 의뢰',
  个人客户: '개인 고객',
  企业客户: '사업 고객',
  '个人客户（主要是个体工商户）的费率计划': '',
  '免费计划和付费标准计划中提供的服务和福利的详细比较，': '',
  '找到支持您业务增长的最佳计划。': '',
  基本功能: '기본 기능',
  去升舱: '업그레이드 하기',
  首月免费: '첫달 10원',
  基本手续费: '',
  '采购手续费（市場购商品）': '',
  '次品自动再次购买（市場购商品）': '',
  OEM采样费用: '',
  検品附加项: '',
  '去布标・去水洗标・去吊牌': '',
  制作并缝制水洗标: '',
  普通发货袋: '',
  成为标准会员的三大优势: '유료회원이 되는 것의 장점 3가지',
  '作为标准会员，您将享受加速业务发展的三大主要优势：节省成本、差异化竞争和独特的产品开发。': '',
  免手续费和采购次数无限制: '수수료 면제 및 구매 횟수 제한 없음',
  '可无限次采购 EC 网站商品，免手续费，降低采购成本，最大化利润率。': 'EC 웹사이트의 상품을 무제한으로 구매할 수 있으며 수수료가 면제되고 구매 비용이 절감되며 이윤을 극대화할 수 있습니다.',
  独特产品开发和竞争差异化: '독특한 제품 개발과 경쟁의 차별화',
  '批发商专属商品和品牌代理销售，加上简单 OEM 支持，帮助您与竞争对手区别开来，强化自有品牌。': '도매상 전용 상품 및 브랜드 대리 판매와 간단한 OEM 지원으로 경쟁사와 차별화하고 자체 브랜드를 강화할 수 있도록 도와드립니다.',
  过代发货实现业务自动化: '대체배송으로 업무 자동화 실현',
  '与日本电商网站（如 Amazon、BASE、Shopify 等）系统联动，无需库存管理，实现业务自动化。通过自动同步商品信息和自动订单处理，大大节省时间和精力。': '',
  企业会员计划的四大优势: '기업 멤버십 프로그램의 3가지 장점',
  '商务会员和头等会员提供个人计划无法享受的特别支持和丰富特权，为业务扩展和增长提供助力。以下是三个主要优势，请根据需求选择适合您的计划。': '비즈니스 회원 및 퍼스트 회원은 개인 프로그램이 누릴 수 없는 특별한 지원과 풍부한 특권을 제공하여 비즈니스 확장 및 성장에 도움을 줍니다. 다음은 몇 가지 주요 장점이며 필요에 따라 적합한 계획을 선택하십시오.',
  '高效管理，减轻工作负担': '효율적인 관리로 업무 부담 경감',
  '商务会员最多支持10家店铺，头等会员则可不限店铺数量使用！通过优化采购到销售的业务流程，帮助您以更少的精力扩大业务。': '비즈니스 회원은 최대 10개의 점포를 지원하며, 퍼스트 회원은 점포 수에 제한 없이 이용 가능합니다! 구매에서 판매에 이르는 비즈니스 프로세스를 최적화하여 적은 에너지로 비즈니스를 확장할 수 있도록 도와줍니다.',
  专业支持体系: '전문 지원 시스템',
  '提供在线聊天支持，以及由专业负责人提供的Chatwork支持，确保高效、快速的业务运营。': '효율적이고 신속한 비즈니스 운영을 위해 온라인 채팅 지원 및 전문 담당자의 지원을 제공합니다.',
  全面支持品牌成长: '브랜드 성장 전폭 지원',
  '通过OEM/ODM的全面支持，轻松开发定制商品或自主品牌。品牌独占销售权和优惠价格商品助力差异化竞争，提升品牌价值。': 'OEM/ODM의 전폭적인 지원을 통해 맞춤형 상품이나 자체 브랜드를 쉽게 개발할 수 있습니다. 브랜드의 독점 판매권과 우대 가격 상품은 차별화된 경쟁을 촉진하고 브랜드 가치를 높입니다.',
  '根据您的品牌和需求，专属采购员1对1推荐特殊商品。此外，每月可免费获得⚪︎万日元以内的样品，帮助您在低风险下把握市场机会。': '',
  面向法人的收费计划: '법인형 요금제',
  '我们不仅提供个体经营者，也为法人提供收费计划。提供 OEM 和 ODM 支持及周末客户服务，选择适合您业务规模和需求的最佳计划': '저희는 개인사업자뿐만 아니라 법인도 요금제를 제공하고 있습니다. OEM 및 ODM 지원 및 주말 고객 서비스 제공, 비즈니스 규모와 니즈에 맞는 최적의 계획 선택',
  '法人和企业客户请点此 >': '법인 및 기업 고객은 여기를 클릭하십시오 >',
  个人及个体户的收费计划: '개인 사용자는 여기를 클릭하십시오.',
  '我们还为个体户和个人用户提供会员计划。适合业务起步阶段的新人或希望尝试新挑战的人群，助力他们迈向更高的业务台阶。': '또한 자영업자와 개인 사용자를 위한 멤버십 프로그램을 제공합니다. 비즈니스 시작 단계의 신입사원이나 새로운 도전을 원하는 사람들에게 적합하며 더 높은 비즈니스 단계로 나아갈 수 있도록 지원합니다.',
  '个人用户请点击此处 >': '개인 사용자는 여기를 클릭하십시오 >',
  常见的问题: '',
  免费咨询2: '무료상담',
  '若对选择合适的计划有疑问，请随时联系我们。THECKB（直行便）的专业人员将根据您的业务需求为您提供免费咨询。': '어떤 방안을 선택하시는지 궁금하신 점이 있으시면 언제든지 연락주세요. 저희 전문 팀은 고객의 비즈니스 요구에 따라 가장 적합한 방안을 무료로 추천해 줄 것입니다.',
  免费咨询: '무료상담',
  上一步: 'prev',
  仅限在线聊天: '온라인 채팅만 제공',
  '很抱歉，您无法申请该品牌': '죄송합니다, 이 브랜드를 신청할 수 없습니다',
  '申请前，请先升级至商务舱会员及以上。': '신청 전에 먼저 퍼스트 회원으로 업그레이드하십시오.',
  '申请前，请先升级至标准会员及以上。': '신청 전에 먼저 비즈니스 회원으로 업그레이드하십시오.',
  '下单次数超出限制，请升级会员': '주문횟수가 제한을 초과하였습니다, 회원가입 후 업그레이드 바랍니다.',
  无限制: '',
  '剩余可新增子店铺数量：X个': '작성 가능한 매장 수 : 나머지 X 개',
  '您的会员仓位可创建的店铺个数上限为{x}个': '현재 회원 플랜에서는 작성 가능한 매장 수는 {x}개까지입니다.',
  '您的会员仓位可创建的店铺个数上限为{x}个(2b+2c)': '현재 회원 플랜에서는 작성 가능한 매장 수는 {x}개까지입니다.',
  '您的会员仓位可创建的店铺个数上限为{x}个，如需新增，请升级会员等级。': '현재 회원 플랜에서는 작성 가능한 매장 수는 {x}개까지입니다. 신규 매장을 추가하려면 회원 플랜 업그레이드가 필요합니다.',
  '订单已生成，部分订单支付失败，': '주문 생성, 일부 주문 지불 실패,',
  '非会员只能下单普通商品,请升级会员': '비회원은 일반 상품만 주문가능, 회원을 업그레이드하세요',
  包含商务计划的所有服务: '비즈니스 플랜을 포함한 모든 서비스',
  会员功能限定去升级: '회원 기능 한정, 회원 업그레이드하세요.',
  店舗商品名: '매장 상품명',
  清空失效商品: '만료 상품 삭제하기',
  失效商品: '만료 상품',
  是否清空失效商品: '만료된 상품을 삭제합니까?',
  '无法批量操作，请去单个商品上维护': '대량 조작이 불가하오니 개별상품을  조작하십시오.',
  '注意：批量水洗标模版功能，只对未下过单的商品生效': '주의 : 대량 워싱 라벨 기능은 주문하지 않은 상품에만 적용됩니다.',
  批量编辑子商品附加项: '부 상품 부가항목을 대량 편집',
  请选择相同国家商品: '동일 국가 상품을 선택하세요.',
  '注意：如需修改水洗标模版，请加入购物车后修改': '워싱 라벨을 수정 원하시면 장바구니에 상품 담으시고 나서  수정해주세요.',
  '国际送料（含远方送料手续费）': '국제운송비용(오지 포함)',
  请确认采购商品信息: '구매 상품 정보를 확인해 주세요.',
  '国际物流费用(含偏远地区附加费)退回': '국제운송비용(오지 포함) 환불',
  尺码差异2: '불량 원인：사이즈가 달라<br/> 검품 기준에 의한 불량 판정',
  配件差异2: '불량 원인：부속품이 달라<br/> 검품 기준에 의한 불량 판정',
  设计差异2: '불량 원인：디자인이 달라<br/> 검품 기준에 의한 불량 판정',
  染色不良: '불량 원인：염색 불량<br/> 검품 기준에 의한 불량 판정',
  抽绳不良: '불량 원인：스트링 불량<br/> 검품 기준에 의한 불량 판정',
  'ODM、质量管理、物流等全流程，提供一站式全方位支持。': '제안부터 구매, OEM/ODM, 품질 관리, 물류 등 전부 과정에 걸쳐 원스톱 전방위 지원을 제공합니다.',
  '海外からの輸入・仕入れ・OEMならTHE CKB（直行便）': '해외로 수입·구입·OEM이라면 THE CKB (직행편)',
  用户数: '사용자 수',
  商品数: '상품 수',
  什么是直行便: '직행편이란?',
  '专注于海外商品批发采购及OEM生产的全方位采购服务。': '해외 상품 도매 구매 및 OEM 생산을 위한 전방위적인 구매 서비스에 집중합니다. ',
  '通过线上线下双渠道确保高质量且低成本的采购渠道，依托自有OEM工厂、物流网络及专有系统，实现从订单下达至交付的全流程高效运作。': '온·오프라인 이중 경로를 통해 고품질의 저비용 구매 채널을 보장하고, 자체 OEM 공장, 물류 네트워크 및 독점 시스템을 기반으로 주문 발송부터 배송까지 전 과정의 효율적인 운영을 실현합니다.',
  '不仅优化日常采购流程，更全程支持原创品牌创建，致力于为客户实现利益最大化。': '일상적인 구매 절차를 최적화할 뿐만 아니라, 전부 과정에서 오리지널 브랜드 창출을 지원하여 고객의 이익을 극대화하는데 노력합니다.',
  选择CKB的理由: 'CKB를 선택한 이유',
  '通过多样化的采购渠道，提供丰富多样的商品阵容。': '다양한 구매 경롤르 통해 풍부하고 다양한 상품 라인업을 제공합니다.',
  '日本标准的严格检验，品质有保障。': '일본 표준의 엄격한 검사는 품질을 보장합니다.',
  通过自有OEM工厂支持品牌创建: '자체 OEM 공장을 통한 브랜드 창출 지원',
  '独自開発のシステムで仕入れ〜出荷を効率化': '개발한 구매 시스템으로 구매부터 출고까지 효율을 높였습니다.',
  电话联系时间: '상담 시간 (평일 10:30 - 19:30, 13:00 - 14:15 점심 시간)',
  其他登录方法: '기타 로그인 방법',
  '【专属的商品提案】': '전속 상품 제안',
  '通过提出差异化产品及未在阿里巴巴平台上架的商品，实现摆脱低价竞争的战略。': '차별화된 제품과 알리바바 플랫폼에 출시되지 않은 상품을 제안하여 저가 경쟁에서 벗어나는 전략을 실현합니다.',
  '【品牌代理销售权及折扣价采购】': '브랜드 대리 판매권 및 할인가 구매',
  '付费会员专享！通过品牌代理销售或独家销售实现与竞争对手的差异化，获得品牌代理销售权及折扣价采购。': '유료회원 전용! 브랜드 대리 판매 또는 독점 판매를 통해 경쟁사와의 차별화를 실현하고 브랜드 대리 판매권 및 할인된 가격으로 구매합니다.',
  '【OEM/ODM服务及产品选项】': 'OEM/ODM 서비스 및 상품 옵션',
  '丰富的定制选项和OEM服务，助力您打造自有品牌。': '다양한 맞춤 옵션과 OEM 서비스가 자체 브랜드를 구축하는 데 도움이 됩니다.',
  // '': '',
  // '': '',
  // '': '',
  // '': '',
  // '': '',
  // '': '',
  // '': '',
  // '': '',
  // '': '',
  // '': '',
  /** 新会员end */
  下单失败2: '주문 실패',
  '您的订单需要“子店铺口座”的余额支付': '원하시는 주문은 "부계정"의 잔액으로 지불해야 합니다.',
  '目前，主账户中有余额，但尚未转入子店铺口座。': '현재 본계정에 잔액이 있지만 아직 부계정 잔액 입구로 이체되지 않았습니다.',
  '主账户余额：X元（可转账）': '부계정 잔액: X (이체가능)',
  '主账户余额：X元': '부계정 잔액: X ',
  '请先从以下按钮进行转账，然后再下单。': '아래 버튼을 통해 계좌이체 후 주문 부탁드립니다.',
  去转账给子店铺: '부계정에 이체하러 가기',
  确认账户余额: '계좌 잔액 확인하기',
  '目前，主账户中有审核中的余额，但是还不能转账。': '현재 본계좌에 심사 중인 잔액이 있는데 아직 이체가 불가합니다.',
  审核结束后可以转账: '※ 심사 완료 후 이체 가능합니다. 잠시만 기다려주세요.',
  '不能接受该不良，希望同商品换货（该换货无需重新冻结费用，如供应商无货，则系统会自动取消）': '이 불량품은 받을 수 없고 동일상품 교환을 희망합니다(해당 교환 조작은 비용 동결 필요없습니다. 만약 공장이 품절 되면 시스템이 자동 취소할 것입니다.)',
  换货中: '교환 중',
  换货记录: '교환 내역',
  换货时间: '교환 시간',
  换货数量: '교환 수량',
  '': ''
}
